{
  "Aid_object": {
    "Delete item": "Hulpmiddel verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het hulpmiddel.",
    "Delete item success": "Hulpmiddel succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je hulpmiddel {0} wilt {1}?",
    "Edit item": "Hulpmiddel bewerken",
    "Edit item fail": "Fout bij het wijzigen van het hulpmiddel. Hulpmiddel niet gewijzigd.",
    "Edit item success": "Hulpmiddel succesvol gewijzigd.",
    "Name": "Naam",
    "New item": "Nieuw hulpmiddel",
    "New item fail": "Fout bij het maken van het nieuwe hulpmiddel.",
    "New item success": "Hulpmiddel succesvol toegevoegd.",
    "ObjectName": "Hulpmiddel",
    "Phone_number": "Telefoonnummer",
    "Registration_number": "Registratienummer",
    "Responsible": "Verantwoordelijke"
  },
  "Apply": "Toepassen",
  "Authmanagement-roles": {
    "Auth source": "Authenticatiebron",
    "Delete": "verwijderen",
    "Delete item": "Rol verwijderen",
    "Delete item fail": "De rol kon niet worden verwijderd.",
    "Delete item success": "Rol succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de rol {0} wilt {1}?",
    "Edit item": "Rol wijzigen",
    "Edit item fail": "Fout bij het wijzigen van de rol. Rol is niet gewijzigd.",
    "Edit item success": "Rol succesvol gewijzigd.",
    "Name": "Rol",
    "New item": "Nieuwe rol",
    "New item fail": "Fout bij het aanmaken van de rol.",
    "New item success": "Rol succesvol toegevoegd.",
    "Refresh list": "Lijst met rollen vernieuwen."
  },
  "Bathing_swimming_form": {
    "Bathing": "Baden",
    "Bathing Protocol List": "Afspraken baden en zwemmen",
    "Bathing_aids": "Hierbij worden de volgende hulpmiddelen gebruikt",
    "Bathing_aids_representative": "Hierbij worden de volgende hulpmiddelen gebruikt (vertegenwoordiger)",
    "Bathing_options": "De deelnemer/bewoner mag",
    "Bathing_options_representative": "De deelnemer/bewoner mag (vertegenwoordiger)",
    "Delete item": "Baden en zwemmen afspraken verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de baden en zwemmen afspraken.",
    "Delete item success": "Baden en zwemmen afspraken succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je baden en zwemmen afspraken wilt {1}?",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Baden en zwemmen afspraken bewerken",
    "Edit item fail": "Fout bij het wijzigen van de baden en zwemmen afspraken. Baden en zwemmen afspraken niet gewijzigd.",
    "Edit item success": "Baden en zwemmen afspraken succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Floatation_device": "Drijfmiddelen, te weten",
    "Floatation_device_representative": "Drijfmiddelen, te weten (vertegenwoordiger)",
    "Form client birthdate": "Geboortedatum",
    "Form client name": "Toestemmingsformulier van",
    "General": "Algemeen",
    "New item": "Afspraken baden en zwemmen",
    "New item fail": "Fout bij het maken van het toestemmingsformulier.",
    "New item success": " Toestemmingsformulier succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Other_bathing_aid": "Andere hulpmiddelen, te weten",
    "Other_bathing_aid_representative": "Andere hulpmiddelen, te weten (vertegenwoordiger)",
    "Other_swimming_aid": "Andere hulpmiddelen, te weten",
    "Other_swimming_aid_representative": "Andere hulpmiddelen, te weten (vertegenwoordiger)",
    "Risk_factors": "Risicofactoren",
    "Risk_factors_notes": "Opmerkingen",
    "Risk_factors_notes_representative": "Opmerkingen vertegenwoordiger(s)",
    "Risk_factors_representative": "Risicofactoren vertegenwoordiger",
    "Shower_options": "De deelnemer/bewoner mag",
    "Shower_options_representative": "De deelnemer/bewoner mag (vertegenwoordiger)",
    "Showering": "Douchen",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "Swimming": "Zwemmen",
    "Swimming_aids": "Hierbij worden de volgende hulpmiddelen gebruikt",
    "Swimming_aids_representative": "Hierbij worden de volgende hulpmiddelen gebruikt (vertegenwoordiger)",
    "Swimming_floatation_device": "Drijfmiddelen, te weten",
    "Swimming_floatation_device_representative": "Drijfmiddelen, te weten (vertegenwoordiger)",
    "Swimming_options": "De deelnemer/bewoner mag",
    "Swimming_options_representative": "De deelnemer/bewoner mag (vertegenwoordiger)"
  },
  "Behaviourgoal": {
    "Added by": "Toegevoegd door",
    "Client": "Cliënt",
    "Created": "Toegevoegd op",
    "Delete item": "Gedragsdoel verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de gedragsdoel.",
    "Delete item success": "Gedragsdoel succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je gedragsdoel {0} wilt {1}?",
    "Edit item": "Gedragsdoel bewerken",
    "Edit item fail": "Fout bij het wijzigen van de gedragsdoel. Gedragsdoel niet gewijzigd.",
    "Edit item success": "Gedragsdoel succesvol gewijzigd.",
    "Export item": "Gedragsdoel exporteren",
    "Export item fail": "Fout bij het exporteren van het gedragsdoel.",
    "Export item success": "Gedragsdoel succesvol geëxporteerd.",
    "Goal": "Gedragsdoel",
    "Goal expired per": "afgerond per {date}",
    "Message": "Bericht",
    "Moment": "Wanneer",
    "Month": "Maand",
    "New item": "Nieuw gedragsdoel",
    "New item fail": "Fout bij het maken van de nieuwe gedragsdoel.",
    "New item success": "Gedragsdoel succesvol toegevoegd.",
    "Notes": "Opmerkingen",
    "Valid_from": "Geldig vanaf",
    "Valid_until": "Geldig tot",
    "Year": "Jaar"
  },
  "Behaviourgoalmessage": {
    "Added by": "Toegevoegd door",
    "Author": "Toegevoegd door",
    "Behaviour_goal": "Gedragsdoel",
    "Behaviour_goal__client": "Cliënt",
    "Client": "Cliënt",
    "Color": "Kleur",
    "Created": "Toegevoegd op",
    "Delete item": "Bericht verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het bericht.",
    "Delete item success": "Bericht succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Duration": "Duur in minuten",
    "Edit item": "Bericht bewerken",
    "Edit item fail": "Fout bij het wijzigen van het bericht. Bericht niet gewijzigd.",
    "Edit item success": "Bericht succesvol gewijzigd.",
    "Message": "Bericht",
    "Moment": "Wanneer",
    "New item": "Nieuw bericht",
    "New item fail": "Fout bij het maken van de nieuw bericht.",
    "New item success": "Bericht succesvol toegevoegd.",
    "Notes": "Opmerkingen",
    "ObjectName": "Gedragsrapportage | Gedragsrapportage berichten",
    "Valid_from": "Geldig vanaf",
    "Valid_until": "Geldig tot"
  },
  "Camera_surveillance_form": {
    "Answer": "Toestemming:",
    "Answer_false": "Ik geef geen toestemming aan Nocht en Wille Zorg BV om het cameratoezicht zoals aangegeven in te richten.",
    "Answer_representative": "Antwoord vertegenwoordiger",
    "Answer_true": "Ik geef toestemming aan Nocht en Wille Zorg BV om het cameratoezicht zoals aangegeven in te richten.",
    "Consent message": "Met de ondertekening van dit formulier geeft je als wettelijk vertegenwoordiger formeel bij Nocht en Wille Zorg BV aan of je wel of niet wilt dat wij bij de zorgverlening aan je verwant gebruik maken van het genoemde cameratoezicht.",
    "Delete": "verwijderen",
    "Delete item": "Afspraken camera- en audio toezicht verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de afspraken camera- en audio toezicht.",
    "Delete item success": "Afspraken camera- en audio toezicht succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de afspraken camera- en audio toezicht wilt {1}?",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Afspraken camera- en audio toezicht bewerken",
    "Edit item fail": "Fout bij het wijzigen van de afspraken camera- en audio toezicht. Afspraken camera- en audio toezicht niet gewijzigd.",
    "Edit item success": "Afspraken camera- en audio toezicht succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Form client birthdate": "Geboortedatum",
    "Form client name": "Toestemmingsformulier van",
    "How does it work": "Hoe werkt het?",
    "How does it work explanation": "Elke kamer in de woonvorm en het logeerhuis is voorzien van een op afstand bestuurbare camera waarop beeld en geluid waar te nemen is. Personeel kan deze camerabeelden op de laptop, op de diensttelefoon of vanuit de kamer van de slaapwacht bekijken. Per kamer kan er ingezoomd en geroteerd worden, het is mogelijk per kamer de camera zo in te stellen dat deze sneller of minder snel op beweging en geluid reageert. Het systeem kan ook een melding versturen aan het personeel of aan de leidinggevende als er gesignaleerd word. Camerabeelden worden maximaal 2 weken bewaard op een beveiligd opslagmedium.",
    "How we handle it": "Hoe gaan we er mee om?",
    "How we handle it explanation": "In Nederland is er nog geen sprake van dat toezichthoudende domotica tot de zogeheten middelen en maatregelen met betrekking tot vrijheidsbeperking gerekend worden. (wettelijk) Toezichthoudende middelen kunnen echter wel vrijheid beperkend werken. We moeten ons afvragen wat we met de inzet van de middelen willen bereiken, of er minder ingrijpende middelen voorhanden zijn en of de inzet van deze middelen doelmatig is. Ons doel met betrekking tot de inzet van cameratoezicht is het vergoten van de veiligheid van onze bewoners in combinatie met onze wens bewoners tijdens rustmomenten niet onnodig te storen. Wij bieden zorg aan mensen met een zeer ernstige verstandelijke en/of lichamelijke beperking, velen hebben te kampen met epilepsie en geen enkele bewoner is zelfredzaam.",
    "New item": "Toestemmingsformulier camera- en audio toezicht",
    "New item fail": "Fout bij het maken van afspraken camera- en audio toezicht.",
    "New item success": " Afspraken camera- en audio toezicht succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Sign document": "Onderteken",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "Start signing form message": "Kies de naam van de vertegenwoordiger en medewerker in die het document zullen ondertekenen.\n\nDe vertegenwoordiger zal een e-mail met een tekenverzoek ontvangen, na ondertekening door de vertegenwoordiger zal de medewerker een tekenverzoek ontvangen.",
    "Start signing item": "Definitief maken",
    "What is it": "Wat is het?",
    "What is it explanation": "Nocht en Wille Zorg maakt in de woonvorm en in het logeerhuis gebruik van zogeheten toezichthoudende domotica.\n\nDomotica in de zorg vertaald zich als ondersteunende of toezichthoudende technologie. Een traplift is een voorbeeld van ondersteunende domotica. Camera- en audio toezicht is een voorbeeld van toezichthoudende domotica.\n\nMet het in werking hebben van een camerasysteem beoogt Nocht en Wille Zorg de veiligheid van bewoners met name op rustmomenten (nachtrust etc.) te waarborgen.\n\nTechnologie stelt ons in staat de bewoner te zien en te horen zonder de kamer van de bewoner te betreden en deze in zijn of haar rust te storen.\n\nMet deze middelen denken wij effectiever toezicht te kunnen houden en daar waar nodig snel tot het bieden van zorg en ondersteuning over te gaan. Dat gezegd hebbende vragen wij ook aandacht voor het feit dat technologie veiligheid en zorgverlening kan verbeteren maar dat er ook duidelijke beperkingen zijn. Er zal nooit sprake zijn van 100% veiligheid door de inzet van domotica of welke andere inzet dan ook."
  },
  "Cancel": "Annuleren",
  "Change": "Wijzigen",
  "Client": {
    "Added by": "Toegevoegd door",
    "Address": "Adres",
    "Attendant": "Begeleider",
    "Birthday": "Verjaardag",
    "Bsn_number": "BSN nummer",
    "City": "Stad",
    "Client": "Cliënt",
    "Client info": "Cliënt informatie",
    "Client name": "Cliënt naam",
    "Clientcare__location": "Locatie",
    "Created": "Toegevoegd",
    "Date": "Datum",
    "Date_of_birth": "Geboortedatum",
    "Declarable care delete warning": "Deze cliënt heeft nog niet gedeclareerde aanwezigheidsregistraties. Als je doorgaat, worden deze registraties niet meer meegenomen in toekomstige declaraties. Bestanden en berichtenborden die direct aan deze cliënt gekoppeld zijn worden definitief verwijderd en kunnen niet worden hersteld.",
    "Declarable care delete warning title": "Cliënt heeft nog te declareren zorg",
    "Delete": "archiveren",
    "Delete file message board warning": "Bestanden en berichtenborden die direct aan deze cliënt gekoppeld zijn worden definitief verwijderd en kunnen niet worden hersteld.",
    "Delete item": "Cliënt archiveren",
    "Delete item fail": "Fout bij het archiveren van de cliënt.",
    "Delete item success": "Cliënt succesvol gearchiveerd.",
    "Delete item text": "Weet je zeker dat je client {0} wilt {1}?",
    "Edit item": "Cliënt bewerken",
    "Edit item fail": "Fout bij het bewerken van de cliënt. Cliënt niet gewijzigd.",
    "Edit item success": "Cliënt succesvol gewijzigd.",
    "Edit photo": "Foto veranderen",
    "Editable by": "Bewerkbaar door",
    "Employee": "Medewerker",
    "Errors": {
      "Error loading client data": "Cliëntdata kan niet opgehaald worden.",
      "NOTHING_TO_EXPORT": "Er is geen cliënt data te exporteren."
    },
    "Export client": "Client data exporteren",
    "Export client email addresses": "Client e-mailadressen exporteren",
    "Export contact email addresses": "Contact e-mailadressen exporteren",
    "Export location presence": "Aanwezigheidsregistratie",
    "First_name": "Voornaam",
    "Gender": "Geslacht",
    "GenderOptions": {
      "M": "Man",
      "O": "Onbekend / niet opgegeven",
      "V": "Vrouw"
    },
    "General_practitioner": "Huisarts",
    "Goto epilepsy protocol": "Klik om het epilepsieprotocol te openen.",
    "House_annex": "Toevoeging",
    "House_number": "Huisnummer",
    "ID": "Id",
    "Id_card": "Identiteitsbewijs",
    "Indication": "Indicatie",
    "Initials": "Initialen",
    "Insurance": "Verzekering",
    "Insurance_card": "Verzekeringbewijs",
    "Insurance_number": "Verzekeringsnummer",
    "Insurance_supplier": "Verzekeraar",
    "Last_name": "Achternaam",
    "Last_name_prefix": "Tussenvoegsel",
    "Living_attendant": "Naam leidinggevende",
    "Living_attendant_phone": "Telefoonnr. leidinggevende",
    "Living_email": "E-mailadres",
    "Living_full_address": "Volledig adres",
    "Living_organization": "Organisatie",
    "Living_phone": "Telefoonnummer",
    "Load all reports": "Alle rapporten",
    "Locations": "Locaties",
    "MaritalStatus": "Burgerlijke staat",
    "MaritalStatusOptions": {
      "Achtergebleven_geregistreerd_partner": "Achtergebleven geregistreerd partner",
      "Gehuwd": "Gehuwd",
      "Geregistreerd_partner": "Geregistreerd partner",
      "Gescheiden": "Gescheiden",
      "Gescheiden_geregistreerd_partner": "Gescheiden geregistreerd partner",
      "Ongehuwd": "Ongehuwd",
      "Ongehuwd_geen_geregistreerd_partner": "Ongehuwd en geen geregistreerd partner, eventueel wel gehuwd of geregistreerd partner geweest",
      "Verweduwd": "Verweduwd"
    },
    "Medical treatment agreements": "Afspraken medisch handelen:",
    "More clients": "Meer cliënten",
    "Name": "Naam",
    "New item": "Nieuwe cliënt",
    "New item fail": "Fout bij het maken van de nieuwe cliënt.",
    "New item success": "Cliënt succesvol toegevoegd.",
    "ObjectName": "Cliënt",
    "Overview": "Overzicht",
    "Personal attendant": "Aanspreekpunt | Aanspreekpunten",
    "Photo": "Foto",
    "Postal_code": "Postcode",
    "Recent reports": "Recente rapportages",
    "Reports": {
      "Behaviour": "Gedrag",
      "Day": "Dagrapportages",
      "Epilepsy": "Epilepsie",
      "Excrement": "Ontlasting",
      "Fobo": "FOBO",
      "Food": "Voedsel",
      "Temperature": "Temperatuur",
      "Weight": "Gewicht"
    },
    "Representatives": "Vertegenwoordigers",
    "Restore item": "Cliënt herstellen",
    "Restore item fail": "Fout bij het herstellen van de cliënt.",
    "Restore item success": "Cliënt succesvol hersteld.",
    "Restore item text": "Weet je zeker dat je cliënt {client} wilt herstellen?",
    "Show ID": "Toon ID-kaart",
    "Show insurance": "Toon verzekering",
    "ShowArchive": "Toon archief",
    "Tabs": {
      "Behaviour reports": "Gedragsrapportages",
      "Care type per location": "Zorg per locatie",
      "Contacts": "Contacten",
      "Employee roles": "Medewerkerrollen",
      "General": "Algemeen",
      "Indicatie": "Indicatie",
      "Living location": "Woonlocatie",
      "Locations": "Locaties",
      "Representative roles": "Vertegenwoordigerrollen",
      "Representatives": "Vertegenwoordigers",
      "Vecozo-messages": "Berichtenbox"
    },
    "Telephone_number": "Telefoonnummer",
    "Type": "Type",
    "View client": "Open cliëntkaart",
    "Warnings": {
      "Deleted client": "Je bekijkt een gearchiveerde cliënt. Het maken van wijzigen is niet meer mogelijk.",
      "Expired protocol": "Het protocol/toestemmingsformulier {type} is verlopen",
      "Expired supportplan": "Het ondersteuningsplan is verlopen",
      "Hospitalisation": "GEEN ziekenhuisopname",
      "Intensive_care": "GEEN intensive care opname",
      "No doctor": "Geen huisarts geregistreerd",
      "No ID card": "Geen ID-kaart",
      "No insurance card": "Geen verzekeringskaart",
      "Reanimation": "NIET reanimeren",
      "Respiration": "NIET beademen"
    },
    "Weight": "Gewicht"
  },
  "Client_care": {
    "Always_declare": "Altijd declareren",
    "Client": "Cliënt",
    "Conflict_action": "Uit te voeren actie",
    "Conflicts": "Conflicten",
    "Date": "Datum",
    "Days_of_week": "Dagen",
    "Delete": "Verwijderen",
    "Delete item": "Zorgverlening verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de zorgverlening.",
    "Delete item success": "Zorgverlening succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de zorgverlening {0} wilt {1}?",
    "Edit item": "Zorgverlening bewerken",
    "Edit item fail": "Fout bij wijzigen zorgverlening.",
    "Edit item success": "Zorgverlening succesvol gewijzigd.",
    "End": "Einddatum",
    "Errors": {
      "START_DATE_CANNOT_BE_AFTER_ORIGINAL_END": "De startdatum mag niet later zijn dan de originele einddatum!",
      "START_DATE_CANNOT_BE_BEFORE_ORIGINAL_START": "De startdatum mag niet eerder zijn dan de originele startdatum",
      "VEKTISPRESTATIE_UPDATE_NOT_ALLOWED": "Het is niet toegestaan om de Vektis prestatiecode aan te passen",
      "VEKTISTOESLAGEN_UPDATE_NOT_ALLOWED": "Het is niet toegestaan om de Vektis toeslagen aan te passen"
    },
    "Location": "Locatie",
    "Move item": "Verplaatsen",
    "Move item fail": "Fout bij het verplaatsen van de zorgverlening",
    "Move item success": "Zorgverlening succesvol verplaatst",
    "New item": "Nieuwe zorgverlening",
    "New item fail": "Fout bij aanmaken nieuwe zorgverlening.",
    "New item success": "Nieuwe zorgverlening succesvol toegevoegd.",
    "No ZZP": "Het is voor deze cliënt nog niet mogelijk om zorg per locatie toe te voegen, omdat er voor deze clïent nog geen toegewezen zorgzwaartepakket bekend is.",
    "ObjectName": "Zorgverlening",
    "Part_of_day": "Dagdelen | Dagdeel",
    "Start": "Startdatum",
    "Vecozotoegewezenzorgzwaartepakket": "Toegewezen ZZP",
    "Vektisprestatie": "Vektis prestatiecode",
    "Vektisprestatiegroup": "Vektis prestatiegroep",
    "Vektistoeslagen": "Toeslagen",
    "ZZP code": "ZZP code"
  },
  "Client_user_role": {
    "Assign": "Toewijzen",
    "Client": "Cliënt",
    "Delete item": "Roltoewijzing verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de roltoewijzing.",
    "Delete item success": "Roltoewijzing succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de roltoewijzing wilt {1}?",
    "Edit item": "Roltoewijzing bewerken",
    "Edit item fail": "Fout bij wijzigen van de roltoewijzing.",
    "Edit item success": "Roltoewijzing succesvol gewijzigd.",
    "Employees": "Medewerkers",
    "Error loading data": "De lijst met roltoewijzingen kon niet worden geladen.",
    "New item": "Nieuwe roltoewijzing",
    "New item fail": "Fout bij het maken van de roltoewijzing.",
    "New item success": "Roltoewijzing succesvol toegevoegd.",
    "Representatives": "Vertegenwoordigers",
    "Role": "Rol",
    "Stepper": {
      "Steps": {
        "Select client": "Cliënt selecteren",
        "Select client description": "Selecteer de cliënt waarvoor je autorisaties gaat configureren.",
        "Select client title": "Voor welke cliënt wil je rollen toewijzen?",
        "Select representatives and roles": "Rollen per vertegenwoordiger",
        "Select representatives and roles description": "Ken specifieke rollen toe die alleen voor de geselecteerde vertegenwoordiger van toepassing zijn.",
        "Select representatives and roles title": "Welke rollen wil je per vertegenwoordiger aan deze cliënt toewijzen?",
        "Select users and roles": "Rollen per medewerker",
        "Select users and roles description": "Ken specifieke rollen toe die alleen voor de geselecteerde medewerker van toepassing zijn.",
        "Select users and roles title": "Welke rollen wil je per medewerker aan deze cliënt toewijzen?",
        "Summary": "Overzicht",
        "Summary description": "Controleer alle toegewezen rollen per niveau voordat je de configuratie opslaat.",
        "Summary title": "Samenvatting van de roltoewijzingen"
      }
    },
    "User": "Medewerker",
    "Users": "Medewerkers"
  },
  "Contact": {
    "Address": "Adres",
    "City": "Plaats",
    "Delete": "Verwijderen",
    "Delete item": "Contact verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het contact.",
    "Delete item success": "Contact succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je contact {0} wilt {1}?",
    "Edit item": "Contact bewerken",
    "Edit item fail": "Fout bij wijzigen contact.",
    "Edit item success": "Contact succesvol gewijzigd.",
    "Email": "E-mailadres",
    "Full_address": "Volledig adres",
    "Full_name": "Volledige naam",
    "House_annex": "Toevoeging",
    "House_number": "Huisnummer",
    "New item": "Nieuw contact",
    "New item fail": "Fout bij aanmaken nieuw contact.",
    "New item success": "Nieuw contact succesvol toegevoegd.",
    "ObjectName": "Contact",
    "Phone_alternative": "Alternatief telefoonnummer",
    "Phone_number": "Telefoonnummer",
    "Phone_primary": "Primair telefoonnummer",
    "Postal_code": "Postcode",
    "Type": "Type",
    "TypeOptions": {
      "10": "Ouder",
      "11": "Voogd",
      "12": "Partner/echtgeno(o)t(e)",
      "13": "Pleegouder",
      "14": "Bewindvoerder",
      "15": "Mentor",
      "16": "Zoon/dochter",
      "17": "Familielid",
      "18": "Gezinslid",
      "19": "Buur",
      "20": "Vriend(in)/kennis",
      "21": "Cliëntondersteuner",
      "22": "Huisarts",
      "23": "Erven van",
      "24": "Werkgever",
      "25": "Wijkcoach",
      "03": "Curator (juridisch)",
      "04": "Financieel (gemachtigd)",
      "05": "Financieel (toetsing)",
      "06": "Leefeenheid",
      "07": "Hulpverlener",
      "08": "Specialist",
      "09": "Anders"
    }
  },
  "Day": {
    "Add recording": "Audiofragment toevoegen",
    "Added by": "Toegevoegd door",
    "Attachment": "Bijlage",
    "Audio_recording": "Audio opname",
    "Cause": "Aanleiding",
    "Click to open image": "Klik om de afbeelding te openen",
    "Click to open PDF": "Klik om de PDF te openen",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Duration": "Duur",
    "Edit item": "Rapport bewerken | Rapport bewerken van {client}",
    "Edit item fail": "Fout bij het wijzigen van het bericht. Bericht is niet gewijzigd.",
    "Edit item success": "Bericht succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Medicine": "Medicijnen",
    "Message": "Bericht",
    "Name": "Naam",
    "New item": "Nieuw rapport | Nieuw rapport voor {client}",
    "New item fail": "Fout bij het maken van het bericht.",
    "New item success": " Bericht is succesvol toegevoegd.",
    "Notes": "Notities",
    "Nothing to show": "Geen berichten gevonden.",
    "ObjectName": "Dagrapportage | Dagrapportage berichten",
    "Only show priority messages": "Toon alleen prio berichten",
    "Priority": "Hoge prioriteit",
    "Quoted_message": "Bericht",
    "Shift": "Dagdeel",
    "Time": "Tijd",
    "When": "Wanneer"
  },
  "Dayreportmessage": {
    "Delete": "verwijderen",
    "Delete item": "Bericht verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het bericht.",
    "Delete item success": "Bericht succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het bericht wilt {1}?"
  },
  "Delete": "Verwijderen",
  "Email_log": {
    "Attachments": "Bijlages",
    "Bcc": "BCC",
    "Belongs_to": "Behoort tot",
    "Cc": "CC",
    "Content": "Bericht inhoud",
    "Created_at": "Gemaakt op",
    "Error loading data": "De lijst met email-logs kon vanwege een fout niet worden geladen.",
    "From": "Afzender",
    "Mail_sent": "Verzonden",
    "Mail_sent_at": "Verzonden op",
    "New item": "Nieuwe e-mail",
    "Reply_to": "Reageer naar",
    "Subject": "Onderwerp",
    "To": "Aan",
    "ToOptions": {
      "NoBcc": "Geen 'bcc' adres",
      "NoCc": "Geen 'cc' adres",
      "NoFrom": "Geen 'from' adres",
      "NoReplyTo": "Geen 'reageren naar' adres",
      "NoTo": "Geen 'aan' adres"
    },
    "Vendor_response": "Reactie leverancier",
    "View item": "E-mail log details"
  },
  "Audit_log": {
    "Client_ip": "Client IP",
    "Changes": "Wijzigingen",
    "Created_at": "Gemaakt op",
    "Data": "Data",
    "Diff": "Verschil",
    "Duration_ms": "Duur (ms)",
    "Error_message": "Foutmelding",
    "Error_stack": "Stacktrace",
    "Hostname": "Hostname",
    "Impersonated_by": "Namens",
    "Level": "Type",
    "Message": "Bericht",
    "Method": "Methode",
    "Object_id": "Object ID",
    "Original_object": "Origineel",
    "Path": "Pad",
    "Query": "Query",
    "Request_id": "Request ID",
    "Response_data": "Response",
    "Result_object": "Resultaat",
    "Status_code": "Status",
    "User": "Gebruiker",
    "View item": "Auditlog details"
  },
  "Epilepsy": {
    "Added by": "Toegevoegd door",
    "Cause": "Aanleiding",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Duration": "Duur in seconden",
    "Edit item": "Epilepsie rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het epilepsie rapport. Epilepsie rapport niet gewijzigd.",
    "Edit item success": "Epilepsie rapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Medicine": "Noodmedicatie gebruikt",
    "Month": "Maand",
    "Name": "Naam",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het maken van het epilepsie rapport.",
    "New item success": "Epilepsie rapport succesvol toegevoegd.",
    "Notes": "Notities",
    "ObjectName": "Epilepsie rapport | Epilepsie rapporten",
    "Shift": "Dagdeel",
    "Time": "Tijd",
    "When": "Wanneer",
    "Year": "Jaar"
  },
  "Epilepsy_protocol": {
    "Answer": "Antwoord",
    "Answer_representative": "Antwoord vertegenwoordiger",
    "Attachment": "Bijlage",
    "Cancelled": "Vervallen",
    "Delete item": "Epilepsie protocol verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het epilepsie protocol.",
    "Delete item success": "Epilepsie protocol succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het epilepsie protocol wilt {1}?",
    "Deleted": "Verwijderd",
    "Description_absence": "Absence",
    "Description_absence_representative": "Absence vertegenwoordiger(s)",
    "Description_big": "Grote toeval",
    "Description_big_representative": "Grote toeval vertegenwoordiger(s)",
    "Description_small": "Kleine toeval",
    "Description_small_representative": "Kleine toeval vertegenwoordiger(s)",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Epilepsie protocol bewerken",
    "Edit item fail": "Fout bij het wijzigen van het epilepsie protocol. Epilepsie protocol niet gewijzigd.",
    "Edit item success": "Epilepsie protocol succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Emergency_services": "Hulpdiensten ingeroepen?",
    "Emergency_services_representative": "Hulpdiensten ingeroepen? (vertegenwoordiger)",
    "Employee_signature": "Medewerker handtekening",
    "Employee_signature_date": "Medewerker handtekening datum",
    "Epilepsy Protocol List": "Omschrijving toevallen",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Form client birthdate": "Geboortedatum",
    "Form client name": "Toestemmingsformulier van",
    "Form_valid_until": "Geldig tot",
    "Measure time": "Houdt de duur van de toeval in de gaten. (bij twijfel eerder medicatie toedienen)",
    "Medication": "Bij een toeval",
    "Medication_representative": "Bij een toeval (vertegenwoordiger)",
    "New item": "Epilepsieprotocol",
    "New item fail": "Fout bij het maken van het toestemmingsformulier.",
    "New item success": " Toestemmingsformulier succesvol toegevoegd.",
    "Note in day report": "Noteer in de dagrapportage dat hij/zij een toeval heeft gehad (hoeveel/hoe lang)",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Repeat": "Herhalen?",
    "Repeat_representative": "Herhalen? (vertegenwoordiger)",
    "Replaced_by": "Vervangen door",
    "Representative_signature": "Vertegenwoordiger handtekening",
    "Representative_signature_date": "Vertegenwoordiger handtekening datum",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "Stay close": "Blijf bij de persoon in de buurt, laat hem niet alleen, zorg dat hij zich nergens aan kan bezeren.",
    "User": "Gebruiker",
    "What to do": "WAT TE DOEN!",
    "What to do representatives": "Opmerking vertegenwoordiger(s)"
  },
  "Excrement": {
    "Added by": "Toegevoegd door",
    "Amount": "Hoeveelheid",
    "Cause": "Aanleiding",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Consistency": "Type",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Duration": "Duur",
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het rapport. Rapport niet gewijzigd.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Medication": "Medicijnen/vloeistof naam",
    "Medicine": "Medicijnen",
    "Month": "Maand",
    "Name": "Naam",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het maken van de nieuw rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "ObjectName": "Ontlastingsrapport | Ontlastingsrapporten",
    "Shift": "Dagdeel",
    "Time": "Tijd",
    "When": "Wanneer",
    "Year": "Jaar"
  },
  "File_insight_form": {
    "Answer": "Toestemming:",
    "Answer_false": "Ik geef geen toestemming voor inzage in het dossier tbv. kwaliteitscontroles.",
    "Answer_representative": "Antwoord vertegenwoordiger",
    "Answer_true": "Ik geef toestemming voor inzage in het dossier en alle onderdelen van het dossier tbv. kwaliteitscontroles.",
    "Attachment": "Bijlage",
    "Cancelled": "Verlopen",
    "Client": "Cliënt",
    "Consent explanation": "Om deze kwaliteitscontroles uit te kunnen voeren hebben wij je schriftelijke toestemming nodig. (zie ook de folder ‘privacy en persoonsgegevens’ ).",
    "Consent message": "Om je zo goed mogelijk te kunnen ondersteunen worden je gegevens en afspraken tussen je en Nocht en Wille Zorg vastgelegd in het ondersteuningsplan. Dit is belangrijk om de kwaliteit van zorg te waarborgen. Om deze kwaliteit van zorg goed te kunnen bewaken worden er soms kwaliteitscontroles uitgevoerd. Deze kunnen intern worden uitgevoerd door zogenaamde ‘interne auditors’, maar soms worden deze ook extern uitgevoerd door ‘externe auditors’ (voor het ISO keurmerk), of b.v. door de Inspectie voor de Gezondheidszorg en Jeugd. (IGJ)",
    "Delete": "verwijderen",
    "Delete item": "Toestemmingsformulier inzage ondersteuningsplan verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het toestemmingsformulier inzage ondersteuningsplan.",
    "Delete item success": "Toestemmingsformulier inzage ondersteuningsplan succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het toestemmingsformulier inzage ondersteuningsplan wilt {1}?",
    "Deleted": "Verwijderd",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Toestemmingsformulier inzage ondersteuningsplan bewerken",
    "Edit item fail": "Fout bij wijzigen het toestemmingsformulier inzage ondersteuningsplan.",
    "Edit item success": "Toestemmingsformulier inzage ondersteuningsplan succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Employee_signature": "Medewerker handtekening",
    "Employee_signature_date": "Medewerker handtekening datum",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Form client birthdate": "Geboortedatum",
    "Form client name": "Toestemmingsformulier van",
    "Form_valid_until": "Geldig tot",
    "Insight Protocol List": "Toestemming inzage ondersteuningsplan",
    "New item": "Toestemming inzage ondersteuningsplan",
    "New item fail": "Fout bij het maken van het toestemmingsformulier inzage ondersteuningsplan.",
    "New item success": " Toestemmingsformulier inzage ondersteuningsplan succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Replaced_by": "Vervangen door",
    "Representative_signature": "Vertegenwoordiger handtekening",
    "Representative_signature_date": "Vertegenwoordiger handtekening datum",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "User": "Gebruiker"
  },
  "File_tree": {
    "Copy": "Kopiëren",
    "Copy category": "Map kopiëren",
    "Copy category item fail": "Map kon niet gekopieerd worden.",
    "Copy category item success": "Map succesvol gekopieerd.",
    "Copy document": "Document kopiëren",
    "Copy document item fail": "Document kon niet gekopieerd worden.",
    "Copy document item success": "Document succesvol gekopieerd.",
    "Copy or move item": "Kopiëren/verplaatsen",
    "Delete": "verwijderen",
    "Delete document item": "Verwijder bestand",
    "Delete document item fail": "Fout bij het verwijderen van bestand.",
    "Delete document item success": "Bestand succesvol verwijderd.",
    "Delete document item text": "Weet je zeker dat je het bestand {0} wilt {1}?",
    "Delete category item": "Verwijder map",
    "Delete category item fail": "De map kon niet worden verwijderd. ",
    "Delete category item success": "Map met succes verwijderd.",
    "Delete category item text": "{2}Weet je zeker dat je de map {0} wilt {1}?",
    "Deletion of data recursive": "Alle onderliggende mappen en bestanden zullen ook worden verwijderd!",
    "Description": "Omschrijving",
    "Edit document item": "Bewerk bestand",
    "Edit document item fail": "Fout bij het bewerken van bestand.",
    "Edit document item success": "Bestand succesvol gewijzigd.",
    "Edit category item": "Bewerk map",
    "Edit category item fail": "De map kon niet worden gewijzigd. ",
    "Edit category item success": "Map met succes gewijzigd.",
    "Error loading data": "De bestanden konden niet worden geladen.",
    "Errors": {
      "CATEGORY_ALREADY_EXISTS": "De map bestaat al op deze locatie.",
      "CATEGORY_CANNOT_BE_ITS_OWN_DECENDANT": "Een map kan niet verplaats worden naar een onderliggende map van zichzelf.",
      "COPY_CATEGORIES_FORBIDDEN_DESTINATION": "Je hebt niet de benodigde rechten om deze actie uit te voeren.",
      "COPY_FILES_FORBIDDEN_DESTINATION": "Je hebt niet de benodigde rechten om deze actie uit te voeren.",
      "FILE_OVERWRITE_REQUIRED": "Er bestaan al bestanden in de doelmap met dezelfde naam. Schakel overschrijven in om deze actie uit te voeren.",
      "MOVE_CATEGORIES_FORBIDDEN_DESTINATION": "Je hebt niet de benodigde rechten om deze actie uit te voeren.",
      "MOVE_CATEGORIES_FORBIDDEN_SOURCE": "Je hebt niet de benodigde rechten om deze actie uit te voeren.",
      "MOVE_FILES_FORBIDDEN_DESTINATION": "Je hebt niet de benodigde rechten om deze actie uit te voeren.",
      "MOVE_FILES_FORBIDDEN_SOURCE": "Je hebt niet de benodigde rechten om deze actie uit te voeren."
    },
    "File": "Bestand",
    "File_tree": "Doellocatie",
    "Files from client": "Bestanden van cliënt: {related}",
    "Files from location": "Bestanden van locatie: {related}",
    "Move": "Verplaatsen",
    "Move category": "Map verplaatsen",
    "Move category item fail": "Map kon niet verplaatst worden.",
    "Move category item success": "Map succesvol verplaatst.",
    "Move document": "Document verplaatsen",
    "Move document item fail": "Document kon niet verplaatst worden.",
    "Move document item success": "Document succesvol verplaatst.",
    "Name": "Naam",
    "New document item": "Nieuw bestand toevoegen",
    "New document item fail": "Fout bij het toevoegen van het bestand.",
    "New document item success": "Nieuw bestand succesvol toegevoegd.",
    "New category item": "Nieuwe map",
    "New category item fail": "Fout bij het toevoegen van de map.",
    "New category item success": "Nieuwe map succesvol aangemaakt.",
    "No file trees available": "Er zijn geen locaties beschikbaar om naartoe te @.lower:{action}.",
    "Nothing to show": "Geen resultaten gevonden.",
    "Original_filename": "Originele bestandsnaam",
    "Overwrite existing": "Bestaande bestanden met dezelfde naam overschrijven",
    "Parent folder": "Bovenliggende map",
    "Preview file item": "Voorbeeldweergave",
    "Show list view": "Lijst weergave",
    "Show tree view": "Boomstructuur",
    "Unauthorized": "Onvoldoende rechten"
  },
  "Fobo": {
    "Added by": "Toegevoegd door",
    "Aggression_nature": "Aard van agressie",
    "Aggression_to": "Agressie jegens",
    "Attachment": "Bijlage",
    "Attachment_signoff": "Aftekenlijst",
    "Cause": "Aanleiding",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Date_from": "Datum (vanaf)",
    "Date_until": "Datum (t/m)",
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Dialog confirm report finalization": {
      "Message": "Weet je zeker dat je dit FOBO rapport als definitief wilt markeren?",
      "Title": "Bevestig definitief markeren FOBO rapport"
    },
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij wijzigen van het report.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Error loading data": "De lijst met FOBO rapportages kon niet worden geladen.",
    "Export item": "Exporteren",
    "Export item fail": "Er is een fout opgetreden bij het exporteren van de rapporten.",
    "Export item success": "Rapporten succesvol geëxporteerd.",
    "Falling": "Vallen",
    "Finalized": "Afgerond",
    "Involved": "Betrokkenen",
    "Location": "Locatie",
    "Medication": "Medicijnen/vloeistof naam",
    "Name": "Naam",
    "Nature_of_incident": "Aard van incident",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het maken van het rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "Other": "Overige",
    "Recommendation": "Advies langetermijn maatregel",
    "Remediation": "Direct genomen actie of maatregel",
    "Report finalized": "Dit formulier is definitief gemaakt, wijzigen is niet meer mogelijk.",
    "Time": "Tijd",
    "Undesired_behaviour": "Ongewenst gedrag",
    "Walk_away": "Weglopen",
    "Where": "Plaats voorval"
  },
  "Food": {
    "Added by": "Toegevoegd door",
    "Bread_amount": "Aantal boterhammen",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het rapport. Rapport niet gewijzigd.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Food": "Voedsel",
    "Food_full": "Wat is er gegeten?",
    "Name": "Naam",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het maken van de nieuw rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "Notes": "Opmerkingen",
    "Number_of_drinks": "Aantal drankjes",
    "ObjectName": "Voedselrapport | Voedselrapporten",
    "Shift": "Dagdeel",
    "Time": "Tijd"
  },
  "General_practitioner": {
    "Address": "Adres",
    "City": "Plaats",
    "Delete": "Verwijderen",
    "Delete item": "Huisarts verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de huisarts.",
    "Delete item success": "Huisarts succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je huisarts {0} wilt {1}?",
    "Edit item": "Huisarts bewerken",
    "Edit item fail": "Fout bij wijzigen huisarts.",
    "Edit item success": "Huisarts succesvol gewijzigd.",
    "Email": "E-mailadres",
    "Error loading data": "De lijst met huisartsen kon niet worden geladen",
    "Full_name": "Volledige naam",
    "House_annex": "Toevoeging",
    "House_number": "Huisnummer",
    "New item": "Nieuwe huisarts",
    "New item fail": "Fout bij aanmaken nieuwe huisarts.",
    "New item success": "Nieuwe huisarts succesvol toegevoegd.",
    "Phone_alternative": "Alternatief telefoonnummer",
    "Phone_primary": "Primair telefoonnummer",
    "Postal_code": "Postcode"
  },
  "Globals": {
    "Add photo": "Voeg foto toe",
    "Admin": "Beheerder",
    "Aid-objects": "Hulpmiddelen",
    "Audit-logs": "Audit logs",
    "Audit-log-admin": "Audit logs",
    "All": "Alle | Alles",
    "And": " en ",
    "And another": "En nog {count}...",
    "Archive item": "Archiveren | @:{item} archiveren",
    "Assigned": "Toegewezen",
    "At": "om",
    "Attention": "LET OP",
    "Awaits": "Wacht op",
    "Back": "Terug",
    "Back to": "Terug naar @.lower:{to}",
    "Back to previous page": "Terug naar de vorige pagina",
    "Behavior": "Gedrag",
    "Behaviour": "Gedrag",
    "Biometrics": {
      "Biometrics activated successfully": "Touch/Face ID is succesvol geactiveerd.",
      "Biometrics activation failed": "Touch/Face ID instellen mislukt.",
      "ECD app locked": {
        "Message": "Je hebt touch-id of face-id ingeschakeld. Bevestig je identiteit om de app te ontgrendelen.",
        "Title": "ECD app vergrendeld"
      },
      "Setup biometrics": {
        "Message": "Je telefoon heeft Touch ID of Face ID ingeschakeld. Wil je dit gebruiken om de app te ontgrendelen?<br />Wanneer Touch ID of Face ID niet is ingeschakeld zal de app automatisch uitloggen na 15 minuten inactiviteit.",
        "Title": "Touch ID / Face ID inschakelen?"
      },
      "Unlock ECD app": {
        "cancelButtonTitle": "Annuleren",
        "description": "Touch ID of Face ID gebruiken",
        "Title": "ECD ontgrendelen"
      }
    },
    "Birthday": "{name} is vandaag jarig!",
    "Camera error": "De camera kan niet geladen worden.",
    "Cancel": "Annuleren",
    "Cancel item fail": "Annuleren is mislukt",
    "Cancel item success": "Annuleren is geslaagd",
    "Change": "Wijzigen",
    "Changed": "@:{key} aangepast",
    "Choose photo": "Kies een foto",
    "Clear recording": "Wis opname",
    "Click to copy ID": "Klik op het pictogram om de ID te kopiëren",
    "Click to open image": "Klik om de afbeelding te openen",
    "Click to open PDF": "Klik om de PDF te openen",
    "Client": "Cliënt | Cliënten",
    "Client-admin": "Cliënten",
    "Clients": "Cliënten",
    "Clone item": "Dupliceer @.lower:{item}",
    "Close": "Sluiten",
    "Collapse menu": "Menu samenvouwen",
    "Contacts": "Contacten",
    "Copy fail": "Kan tekst niet naar klembord kopiëren.",
    "Copy item": "@:{item} kopiëren",
    "Copy success": "Tekst naar het klembord gekopieerd.",
    "Countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Aland-eilanden",
      "ALB": "Albanië",
      "AND": "Andorra",
      "ARE": "Verenigde Arabische Emiraten (de)",
      "ARG": "Argentinië",
      "ARM": "Armenië",
      "ASM": "Amerikaans Samoa",
      "ATA": "Antarctica",
      "ATF": "Franse Zuidelijke Gebieden (de)",
      "ATG": "Antigua en Barbuda",
      "AUS": "Australië",
      "AUT": "Oostenrijk",
      "AZE": "Azerbeidzjan",
      "BDI": "Boeroendi",
      "BEL": "België",
      "BEN": "Benin",
      "BES": "Bonaire, Sint Eustatius en Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgarije",
      "BHR": "Bahrein",
      "BHS": "Bahama's (de)",
      "BIH": "Bosnië-Herzegovina",
      "BLM": "Saint Barthélemy",
      "BLR": "Wit-Rusland",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivia (plurinationale staat)",
      "BRA": "Brazilië",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BVT": "Bouvet-eiland",
      "BWA": "Botswana",
      "CAF": "Centraal-Afrikaanse Republiek (de)",
      "CAN": "Canada",
      "CCK": "Cocos (Keeling) Eilanden (de)",
      "CHE": "Zwitserland",
      "CHL": "Chili",
      "CHN": "China",
      "CIV": "Ivoorkust",
      "CMR": "Kameroen",
      "COD": "Congo (de Democratische Republiek der)",
      "COG": "Kongo (de)",
      "COK": "Cook Eilanden (de)",
      "COL": "Colombia",
      "COM": "Comoren (de)",
      "CPV": "Cabo Verde",
      "CRI": "Costa Rica",
      "CUB": "Cuba",
      "CUW": "Curacao",
      "CXR": "Kersteiland",
      "CYM": "Kaaimaneilanden (de)",
      "CYP": "Cyprus",
      "CZE": "Tsjechië",
      "DEU": "Duitsland",
      "DJI": "Djibouti",
      "DMA": "Dominica",
      "DNK": "Denemarken",
      "DOM": "Dominicaanse Republiek (de)",
      "DZA": "Algerije",
      "ECU": "Ecuador",
      "EGY": "Egypte",
      "ERI": "Eritrea",
      "ESH": "Westelijke Sahara",
      "ESP": "Spanje",
      "EST": "Estland",
      "ETH": "Ethiopië",
      "FIN": "Finland",
      "FJI": "Fiji",
      "FLK": "Falklandeilanden (de) [Malvinas]",
      "FRA": "Frankrijk",
      "FRO": "Faeröer Eilanden (de)",
      "FSM": "Micronesië (Federale Staten van)",
      "GAB": "Gabon",
      "GBR": "Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland (de)",
      "GEO": "Georgië",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadeloupe",
      "GMB": "Gambia (de)",
      "GNB": "Guinee-Bissau",
      "GNQ": "Equatoriaal-Guinea",
      "GRC": "Griekenland",
      "GRD": "Grenada",
      "GRL": "Groenland",
      "GTM": "Guatemala",
      "GUF": "Frans Guyana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hong Kong",
      "HMD": "Heard- en McDonaldeilanden",
      "HND": "Honduras",
      "HRV": "Kroatie",
      "HTI": "Haïti",
      "HUN": "Hongarije",
      "IDN": "Indonesië",
      "IMN": "Isle of Man",
      "IND": "India",
      "IOT": "Brits Indische Oceaanterritorium (de)",
      "IRL": "Ierland",
      "IRN": "Iran (Islamitische Republiek)",
      "IRQ": "Irak",
      "ISL": "IJsland",
      "ISR": "Israël",
      "ITA": "Italië",
      "JAM": "Jamaica",
      "JEY": "Jersey",
      "JOR": "Jordanië",
      "JPN": "Japan",
      "KAZ": "Kazachstan",
      "KEN": "Kenia",
      "KGZ": "Kirgizië",
      "KHM": "Cambodja",
      "KIR": "Kiribati",
      "KNA": "Saint Kitts en Nevis",
      "KOR": "Korea (de Republiek)",
      "KWT": "Koeweit",
      "LAO": "Lao Democratische Volksrepubliek (de)",
      "LBN": "Libanon",
      "LBR": "Liberia",
      "LBY": "Libië",
      "LCA": "Saint Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Litouwen",
      "LUX": "Luxemburg",
      "LVA": "Letland",
      "MAC": "Macao",
      "MAF": "Saint Martin (Frans deel)",
      "MAR": "Marokko",
      "MCO": "Monaco",
      "MDA": "Moldavië (de Republiek)",
      "MDG": "Madagascar",
      "MDV": "Maldiven",
      "MEX": "Mexico",
      "MHL": "Marshall Eilanden (de)",
      "MKD": "Republiek Noord-Macedonië",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolië",
      "MNP": "Noordelijke Marianen (de)",
      "MOZ": "Mozambique",
      "MRT": "Mauritanië",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Maleisië",
      "MYT": "Mayotte",
      "NAM": "Namibië",
      "NCL": "Nieuw-Caledonië",
      "NER": "Niger (de)",
      "NFK": "Norfolkeiland",
      "NGA": "Nigeria",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Nederland",
      "NOR": "Noorwegen",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NZL": "Nieuw-Zeeland",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCN": "Pitcairn",
      "PER": "Peru",
      "PHL": "Filipijnen (de)",
      "PLW": "Palau",
      "PNG": "Papoea-Nieuw-Guinea",
      "POL": "Polen",
      "PRI": "Puerto Rico",
      "PRK": "Korea (de Democratische Volksrepubliek)",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palestina, staat",
      "PYF": "Frans-Polynesië",
      "QAT": "Qatar",
      "REU": "Réunion",
      "ROU": "Roemenië",
      "RUS": "Russische Federatie (de)",
      "RWA": "Rwanda",
      "SAU": "Saoedi-Arabië",
      "SDN": "Soedan (de)",
      "SEN": "Senegal",
      "SGP": "Singapore",
      "SGS": "Zuid-Georgië en de Zuidelijke Sandwicheilanden",
      "SHN": "Sint-Helena, Ascension en Tristan da Cunha",
      "SJM": "Svalbard en Jan Mayen",
      "SLB": "Solomon eilanden",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalië",
      "SPM": "Saint Pierre en Miquelon",
      "SRB": "Servië",
      "SSD": "Zuid Soedan",
      "STP": "Sao Tomé en Principe",
      "SUR": "Suriname",
      "SVK": "Slowakije",
      "SVN": "Slovenië",
      "SWE": "Zweden",
      "SWZ": "Eswatini",
      "SXM": "Sint Maarten (Nederlands deel)",
      "SYC": "Seychellen",
      "SYR": "Syrische Arabische Republiek",
      "TCA": "Turks- en Caicoseilanden (de)",
      "TCD": "Tsjaad",
      "TGO": "Togo",
      "THA": "Thailand",
      "TJK": "Tadzjikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Timor-Leste",
      "TON": "Tonga",
      "TTO": "Trinidad en Tobago",
      "TUN": "Tunesië",
      "TUR": "Turkije",
      "TUV": "Tuvalu",
      "TWN": "Taiwan",
      "TZA": "Tanzania, Verenigde Republiek van",
      "UGA": "Oeganda",
      "UKR": "Oekraïne",
      "UMI": "Kleine afgelegen eilanden van de Verenigde Staten (de)",
      "URY": "Uruguay",
      "USA": "Verenigde Staten van Amerika (de)",
      "UZB": "Oezbekistan",
      "VAT": "Heilige Stoel (de)",
      "VCT": "Saint Vincent en de Grenadines",
      "VEN": "Venezuela (Bolivariaanse Republiek)",
      "VGB": "Maagdeneilanden (Brits)",
      "VIR": "Maagdeneilanden (VS)",
      "VNM": "Vietnam",
      "VUT": "Vanuatu",
      "WLF": "Wallis en Futuna",
      "WSM": "Samoa",
      "YEM": "Jemen",
      "ZAF": "Zuid-Afrika",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe"
    },
    "Created": "Aangemaakt",
    "Current": "Huidige",
    "Current time": "Huidige tijd",
    "Date": "Datum",
    "Datepicker": {
      "Days": "Zondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrijdag_Zaterdag",
      "DaysShort": "Zo_Ma_Di_Wo_Do_Vr_Za",
      "Months": "Januari_Februari_Maart_April_Mei_Juni_Juli_Augustus_September_Oktober_November_December",
      "MonthsShort": "Jan_Feb_Maa_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Dec",
      "PluralDay": "Dag"
    },
    "Day": "Dag",
    "DaysOfWeek": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag", "zondag"],
    "Delete": "verwijderen",
    "Delete item": "Verwijderen | @:{item} verwijderen",
    "Delete item archive": "Archiveer {0}",
    "Delete item fail": "Fout bij het verwijderen van @.lower:{item}.",
    "Delete item force delete": "{0} en alle onderliggende gegevens geforceerd verwijderen",
    "Delete item success": "@.capitalize:{item} succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je object {0} wilt {1}?",
    "Delete item title": "@.capitalize:{item} verwijderen",
    "Description": "Omschrijving",
    "Deselect All": "Deselecteer alles",
    "Dialog confirm copy profile": {
      "Message": "Weet je zeker dat je het protocol/toestemmingsformulier <strong>{formType}</strong> wilt kopiëren?",
      "Title": "Protocol/Toestemmingsformulier kopiëren"
    },
    "Dialog confirm copy profile supportplan": {
      "Message": "Weet je zeker dat je het <strong>ondersteuningsplan</strong> wilt kopiëren?",
      "Title": "Ondersteuningsplan kopiëren"
    },
    "Dialog confirm copy profile wzd": {
      "Message": "Weet je zeker dat je de <strong>WZD registratie</strong> wilt kopiëren?",
      "Title": "WZD registratie kopiëren"
    },
    "Dialog confirm expire": {
      "Message": "Weet je zeker dat je protocol/toestemmingsformulier <strong>{formType}</strong> wilt laten vervallen?",
      "Title": "Protocol/Toestemmingsformulier laten vervallen"
    },
    "Dialog confirm expire supportplan": {
      "Message": "Weet je zeker dat je het <strong>ondersteuningsplan</strong> wilt laten vervallen?",
      "Title": "Ondersteuningsplan laten vervallen"
    },
    "Dialog confirm expire wzd": {
      "Message": "Weet je zeker dat je de <strong>WZD-registratie</strong> wilt laten vervallen?",
      "Title": "Ondersteuningsplan laten vervallen"
    },
    "Dialog confirm import roles": {
      "Message": "Weet je zeker dat je de rollen wilt importeren en de huidige rollen wilt overschrijven?",
      "Title": "Rollen importeren"
    },
    "Dialog confirm revert expire": {
      "Message": "Weet je zeker dat je het vervallen van deze <strong>{formType}</strong> ongedaan wilt maken?",
      "Title": "Vervallen ongedaan maken"
    },
    "Dialog confirm revert expire supportplan": {
      "Message": "Weet je zeker dat je het vervallen van het <strong>ondersteuningsplan</strong> ongedaan wilt maken?",
      "Title": "Vervallen ongedaan maken"
    },
    "Dialog confirm revert expire wzd": {
      "Message": "Weet je zeker dat je het vervallen van de <strong>WZD-registratie</strong> ongedaan wilt maken?",
      "Title": "Vervallen ongedaan maken"
    },
    "Dialog confirm revert status": {
      "Message": "Weet je zeker dat je de tekenfase wilt annuleren en terug wilt gaan naar de conceptfase?",
      "Title": "Terugzetten naar conceptfase"
    },
    "Documentation": "Documentatie",
    "Done": "Gereed",
    "Download": "Download | Download {type}",
    "Download fail": "Downloaden van bestand mislukt.",
    "Download success": "Downloaden van bestand gelukt.",
    "Edit item": "Bewerken | @:{item} bewerken",
    "Edit item fail": "Wijzigen mislukt.",
    "Edit item success": "@.capitalize:{object} succesvol gewijzigd.",
    "Edited": "Bewerkt",
    "Email-log-admin": "E-mail management",
    "Email-logs": "E-mail logs",
    "Empty": "NB",
    "Enter time": "Voer tijd in",
    "Epilepsy": "Epilepsie",
    "Error": "Fout",
    "Errors": {
      "404": "De opgevraagde pagina is niet gevonden.",
      "404 description": "Controleer het webadres of ga terug naar een bekende pagina binnen het ECD.",
      "Data error": "Er was een probleem met het laden van de data.",
      "Default": "@:{key} is een verplicht veld",
      "Delete item has dependencies": "Het item heeft afhankelijkheden. Verwijder de afhankelijkheden eerst.",
      "Delete item has dependencies or archive": "Het item heeft afhankelijkheden. Verwijder de afhankelijkheden eerst of archiveer het item.",
      "Delete item has dependencies or force delete": "Het item heeft afhankelijkheden. Verwijder de afhankelijkheden eerst of kies geforceerd verwijderen.",
      "Email in use": "Het opgegeven e-mailadres is al in gebruik. Log met je oude e-mailadres in en probeer te wijzigen naar een adres welke nog niet in gebruik is.",
      "Error loading data": "De lijst met {item} kon vanwege een fout niet worden geladen.",
      "Invalid": "@:{key} heeft een ongeldige waarde.",
      "Invalid_date_in_future": "Datum kan niet in de toekomst liggen.",
      "Item fail": "Er is een fout opgetreden bij het verwerken van je aanvraag, probeer het opnieuw.",
      "Loading app": "Het ECD kan niet worden geladen.\n\nControleer je internetverbinding of probeer het opnieuw.",
      "Max_length": "@:{key} is te lang",
      "Min_length": "@:{key} is te kort",
      "No options available": "Geen opties beschikbaar",
      "Open URL warning": "Kan factuur niet downloaden. Sta pop-ups voor OMNI Vision toe om het downloaden van facturen mogelijk te maken.",
      "Permission denied": "Oeps! Het lijkt erop dat je geen toestemming hebt om deze bron te openen. Als je denkt dat dit een vergissing is, neem dan contact op met de ondersteuning of probeer het later opnieuw.",
      "Technical issue": "De gevraagde actie kan nu niet worden uitgevoerd.",
      "Technical issue description": "Door een technische oorzaak kunnen de benodigde gegevens op dit moment niet worden geladen. Ga terug naar de vorige pagina of ga naar de startpagina en probeer het later opnieuw.",
      "Required": {
        "default": "@:{key} is een verplicht veld"
      },
      "Unauthorized": "Niet toegestaan",
      "User not found": "De gebruiker {m}kan niet worden opgehaald van de server."
    },
    "Excrement": "@:Report.Excrement",
    "Expand menu": "Menu uitvouwen",
    "Expire item": "Laten vervallen",
    "Expire item fail": "Fout bij het laten vervallen.",
    "Expire item success": "Succesvol laten vervallen.",
    "Expired": "Verlopen",
    "Export": "Exporteren",
    "Export item": "Exporteren",
    "Export item fail": "Fout bij het exporteren.",
    "Export item success": "Succesvol geëxporteerd.",
    "Failed": "Mislukt",
    "File": "Bestand",
    "Files": "Bestanden",
    "Filters": "Filters | Stel filters in",
    "Finalize": "Definitief maken",
    "Flush": "Spoelen",
    "Fobo": "@:Report.Fobo",
    "Folder": "Map",
    "Food": "Voedsel",
    "Fullscreen": "Volledig scherm | Volledig scherm verlaten",
    "Future": "Toekomstig",
    "General-practitioners-admin": "Huisartsen",
    "General-reports": "Algemene rapportage",
    "Go to overview": "Overzicht weergeven",
    "Grid": "Raster",
    "Hide messages": "Verberg berichten",
    "Home": "Terug naar het begin",
    "Hours": "Uur | Uren",
    "Hrs": "Uur | Uren",
    "Https required": "HTTPS vereist",
    "Import": "Importeren",
    "Import item fail": "Fout bij importeren",
    "Import item success": "Succesvol geïmporteerd",
    "Invalid": "@:{key} is niet geldig",
    "Invalid date": "Ongeldige datum: {format}.",
    "Invalid time": "Ongeldige tijd: {format}.",
    "Item action": "{action} {type}",
    "Item fail": "Actie: {action}. <br />Service: {type}  <br />Doel: {item}.  <br />Resultaat: MISLUKT",
    "Item success": "Actie: {action}. <br />Service: {type}  <br />Doel: {item}.  <br />Resultaat: SUCCES",
    "Last 2 weeks": "Laatste 2 weken",
    "Last 3 days": "Laatste 3 dagen",
    "Last 30 days": "Laatste 30 dagen",
    "Last 90 days": "Laatste 90 dagen",
    "Last update": "Gewijzigd",
    "Last week": "Vorige week",
    "Legend": "Legenda",
    "Legionella": "Legionella",
    "List": "Lijst",
    "Loading": "ECD wordt geladen, even geduld...",
    "Location": "Locaties",
    "Location-admin": "Locaties",
    "Locations": "Locaties",
    "Lock item fail": "Fout bij het definitief maken van het rapport.",
    "Lock item success": "Rapport succesvol als definitief gemarkeerd.",
    "Logout": "Uitloggen",
    "Main": "Hoofdpagina",
    "MainPage": {
      "Clients": "Beheer cliëntgegevens. Krijg inzicht in dossiers en relevante zorginformatie.",
      "Locations": "Beheer locaties. Houd overzicht op locatiespecifieke informatie en voorzieningen.",
      "Management": "Beheer alle basisgegevens van cliënten, medewerkers, locaties en meer.",
      "Messages": "Beheer het berichtenverkeer m.b.t. zorg toewijzingen en declaraties.",
      "Profile": "Bekijk en beheer je persoonlijke profielinstellingen en voorkeuren.",
      "Quality manual": "Documenten uit het kwaliteitshandboek overzichtelijk opslaan en beheren.",
      "Technical services": "Beheer technische meldingen en onderhoud. Krijg direct inzicht in status en voortgang.",
      "Transportation": "Documenten met betrekking tot vervoer overzichtelijk opslaan en beheren."
    },
    "Management": "Beheer",
    "ManagementMainPage": {
      "Audit logs": "Beheer audit logs en verzoekactiviteit.",
      "Clients": "Beheer cliënten en houd hun gegevens actueel binnen het systeem.",
      "Email logs": "Beheer e-mail logs en verzendstatussen.",
      "General practitioners": "Beheer huisartsen en houd hun contactgegevens actueel.",
      "Locations": "Beheer locaties binnen de organisatie en pas adres- en locatiedetails aan.",
      "Representatives": "Beheer vertegenwoordigers en houdt actuele ouder- en contactinformatie actueel.",
      "Roles": "Beheer gebruikersrollen en stel toegangsrechten nauwkeurig in per functiegroep.",
      "Users": "Beheer medewerkers en onderhoud hun gegevens, rollen en beschikbaarheid."
    },
    "Mandatory": "@:{key} is verplicht",
    "Max end date": "De maximale einddatum is: {maxEndDate}",
    "Max end dateTime": "De maximale einddatum/tijd is: {maxEndDate}",
    "Maximize": "Maximaliseren",
    "Medical-file": "Medisch dossier",
    "Memo": "Memo's",
    "Menu": "Menu",
    "Message": "Bericht",
    "Messages": "Berichten",
    "MessagesMainPage": {
      "Vecozo messages": "Communicatie over toewijzingen en declaraties.",
      "Vektis-declaraties": "Declaraties beheren en klaarzetten.",
      "Vektis-prestatie-groups": "Vektis prestatie groepen beheren.",
      "Vektis-prestaties": "Tarieven voor Vektis-prestatiecodes beheren.",
      "Vektis-uzovi": "Overzicht van het UZOVI-register."
    },
    "Min start date": "De minimale startdatum is: {minStartDate}",
    "Min start dateTime": "De minimale startdatum/tijd is: {minStartDate}",
    "Mins": "Min | Minuten",
    "Minutes": "Minuut | Minuten",
    "Month": "Maand",
    "Months": "Maanden",
    "MonthsOfYear": {
      "1": "januari",
      "2": "februari",
      "3": "maart",
      "4": "april",
      "5": "mei",
      "6": "juni",
      "7": "juli",
      "8": "augustus",
      "9": "september",
      "10": "oktober",
      "11": "november",
      "12": "december"
    },
    "More options": "Meer opties",
    "Move": "Verplaats",
    "My profile": "Mijn profiel",
    "New item": "Nieuw | Nieuw(e) @.lower:{item}",
    "New item fail": "Toevoegen mislukt.",
    "New item success": "@.capitalize:{object} succesvol toegevoegd.",
    "New messages": "Er zijn nieuwe berichten.",
    "Next": "Volgende",
    "No": "Nee",
    "No data": "Er zijn geen gegevens gevonden.",
    "No messages found": "Er zijn geen berichten op het prikbord.",
    "No results": "Er is geen data, of er komen geen resultaten overeen met het filter",
    "None": "Geen",
    "Not": "Niet",
    "Not allowed": "Je bent niet gemachtigd de opgevraagde pagina te bekijken. Neem contact op met de beheerder wanneer je denkt dat dit onterecht is.",
    "Not applicable": "N.v.t.",
    "Notifications": {
      "Automatic logout": "Je wordt automatisch uitgelogd over {secLeft} seconde. | Je wordt automatisch uitgelogd over {secLeft} seconden."
    },
    "Of": "Van | van",
    "On": "op",
    "Open clock": "Klok weergeven",
    "Options": "opties",
    "Page": "pagina",
    "PartsOfDay": {
      "afternoon": "middag",
      "evening": "avond",
      "morning": "ochtend",
      "night": "nacht"
    },
    "Photo added successfully": "Foto succesvol toegevoegd.",
    "Please note": "Let op",
    "Please wait": "Even geduld...",
    "Presence": "Aanwezigheid",
    "Preview file item": "Voorbeeldweergave",
    "Process": "Verwerk",
    "Process item fail": "Verwerking mislukt.",
    "Process item success": "Verwerking succesvol uitgevoerd.",
    "Processed": "Verwerkt",
    "Processing recording": "Opname aan het verwerken. Even geduld...",
    "Profile": "Gebruikersprofiel",
    "Protocol or form not available": "Niet ingevuld",
    "Protocols-and-forms": "Protocollen en formulieren",
    "ProtocolsAndFormsStatusOptions": {
      "CANCELLED": "Vervallen",
      "CONCEPT": "Concept",
      "EXPIRED": "Verlopen",
      "FINAL": "Definitief",
      "REPLACED": "Vervangen",
      "SIGN_EMPLOYEE": "Tekenen (medewerker)",
      "SIGN_REPRESENTATIVE": "Tekenen (vertegenwoordiger)",
      "SUPERSEDED": "Vervangen"
    },
    "Quality-handbook": "Kwaliteitshandboek",
    "Quarter": "Kwartaal",
    "Record": "Opnemen",
    "Record audio clip": "Audiofragment opnemen",
    "Recording": "Aan het opnemen...",
    "Refresh": "Vernieuwen",
    "Refresh list": "Lijst vernieuwen",
    "Refresh messages": "Berichten vernieuwen",
    "Reload app": "Herladen",
    "Reply to audio recording only": "Geluidsfragment",
    "Report": "Rapport",
    "Reports": "Rapportages",
    "Representative": "Vertegenwoordigers",
    "Representative-admin": "Vertegenwoordigers",
    "Reset": "Resetten",
    "Retry": "Probeer opnieuw",
    "Revert item fail": "Fout bij het terugzetten naar de concept fase.",
    "Revert item success": "Terugzetten naar de concept fase succesvol uitgevoerd.",
    "Revert to concept": "Terug naar concept",
    "Revert_expire item": "Vervallen ongedaan maken",
    "Revert_expire item fail": "Fout bij het ongedaan maken van het vervallen",
    "Revert_expire item success": "Vervallen ongedaan gemaakt",
    "Roles": "Rollen",
    "Roles-admin": "Rollen",
    "Rows per page": "Rijen per pagina | Aantal",
    "Rows selected": "{count} van {total} {type} record(s) geselecteerd",
    "Save": "Opslaan",
    "Select All": "Selecteer alles",
    "Select item from list": "Maak een keuze in het @.lower:{item} om gegevens weer te geven.",
    "Select language": "Selecteer een taal",
    "Select regional settings": "Selecteer een regionale indeling",
    "Selected items": "{selected} van {total} @.lower:{items} geselecteerd",
    "Settings": "Instellingen",
    "Show": "Tonen",
    "Show messages": "Toon berichten",
    "Show more": "Toon meer",
    "Show only active": "Alleen actieve items tonen",
    "Show only archived": "Alleen gearchiveerde items tonen",
    "Show or hide columns": "Weer te geven kolommen",
    "Sign document": "Ondertekenen",
    "Sign employee": "Ondertekenen werknemer",
    "Sign on location": "Tekenen op locatie",
    "Sign representative": "Ondertekenen vertegenwoordiger",
    "Signature": "Handtekening",
    "Signed by employee item fail": "Fout bij ondertekenen voor de werknemer. Ondertekenen is niet gelukt.",
    "Signed by employee item success": "Ondertekenen door de werknemer succesvol. De tekenfase is nu afgerond.",
    "Signed by representative item fail": "Fout bij ondertekenen voor de vertegenwoordiger. Ondertekenen is niet gelukt.",
    "Signed by representative item success": "Ondertekenen door de vertegenwoordiger succesvol.",
    "Signing upload attachment": "Upload het getekende document. Zorg dat het document zowel door de huisarts als de medewerker is getekend!",
    "Signing upload attachment item": "Upload getekend document",
    "Sort": "Sorteer | Sorteren",
    "Sort data": "Sorteer gegevens",
    "SortOptions": {
      "Ascending": "Oplopend",
      "Descending": "Aflopend"
    },
    "Staff": "Personeel",
    "Start recording": "Klik op \"Opnemen ({0})\" op de opname te starten",
    "Start signing": "Start tekenfase",
    "Start signing form message": "Plaats je handtekening binnen het onderstaande kader, en druk op \"Ondertekenen\" om het document te ondertekenen.",
    "Start signing item fail": "Fout bij starten van de tekenfase.",
    "Start signing item success": "Tekenfase succesvol gestart",
    "Status": "Status ",
    "Success": "Succes",
    "Support-plans": "Ondersteuningsplan | Ondersteuningsplannen",
    "Switch to": "Schakel over naar @.lower:{mode}weergave",
    "Table of contents": "Inhoudsopgave",
    "Take photo": "Maak foto",
    "Task": "Taak",
    "Task-category": "Taakcategorie",
    "Task-template": "Taak sjabloon",
    "Tasks": "Taken",
    "Technical": "Technische",
    "Technical-services": "Technische dienst",
    "Technical-services-admin": "Technische dienst",
    "Temperature": "@:Report.Temperature",
    "Today": "Vandaag",
    "Transportation": "Vervoer",
    "Try again": "Probeer opnieuw",
    "Undo finalize": "Definitief ongedaan maken",
    "Unknown": "Onbekend",
    "Unsaved changes": "Er zijn wijzigingen nog niet opgeslagen. Weet je zeker dat je de pagina wilt verlaten en de wijzigingen ongedaan wilt maken?",
    "Unsaved changes title": "Niet opgeslagen wijzigingen",
    "Update available": "Update beschikbaar. Laad opnieuw om te bij te werken.",
    "Upload file": "Bestand uploaden",
    "User": "Medewerker | Medewerkers",
    "Users": "Medewerkers",
    "Value": "Waarde",
    "Vecozo-messages": "Berichtenbox | Berichtenverkeer",
    "VecozoMessages": "Vecozo berichten",
    "Vektis-declaraties": "Declaraties",
    "Vektis-prestatie-groups-admin": "Vektis-prestatiegroepen",
    "Vektis-prestaties-admin": "Vektis-prestatiecodes",
    "Vektis-uzovi-admin": "UZOVI-register",
    "View item": "Bekijk @.lower:{item}",
    "Week": "Week",
    "Weeks": "Weken",
    "Weight": "@:Report.Weight",
    "Windowed": "Zwevend",
    "Wzd": "Wet zorg en dwang | Wet zorg en dwang registraties",
    "Year": "Jaar",
    "Yes": "Ja"
  },
  "Gp_execution_request_form": {
    "Answer": "Toestemming:",
    "Answer_false": "Het uitvoeringsverzoek kan niet worden geaccepteerd door Nocht en Wille Zorg",
    "Answer_representative": "Het uitvoeringsverzoek kan worden geaccepteerd door Nocht en Wille Zorg",
    "Answer_true": "Het uitvoeringsverzoek kan worden geaccepteerd door Nocht en Wille Zorg",
    "Attachment": "Bijlage",
    "Cancelled": "Verlopen",
    "Client": "Cliënt",
    "Complications": "Eventuele patiëntgebonden complicaties/bijwerkingen",
    "Complications_representative": "Eventuele patiëntgebonden complicaties/bijwerkingen (vertegenwoordiger)",
    "Delete item": "Uitvoeringsverzoek huisarts verwijderen",
    "Delete item fail": "Fout bij het verwijderen van uitvoeringsverzoek huisarts.",
    "Delete item success": "Uitvoeringsverzoek huisarts succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het uitvoeringsverzoek huisarts wilt {1}?",
    "Deleted": "Verwijderd",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Dosage": "Exacte dosering per keer",
    "Dosage_representative": "Exacte dosering per keer (vertegenwoordiger)",
    "Edit item": "Uitvoeringsverzoek huisarts bewerken",
    "Edit item fail": "Fout bij wijzigen van het uitvoeringsverzoek huisarts.",
    "Edit item success": "Uitvoeringsverzoek huisarts succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Employee": "Vertegenwoordigd door",
    "Employee_signature": "Medewerker handtekening",
    "Employee_signature_date": "Medewerker handtekening datum",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Explanation": "Uitvoeringsverzoek tot medisch handelen van individuele huisarts aan de verpleegkundige/verzorgende omtrent bepaalde cliënt.",
    "Form client address": "Adres",
    "Form client birthdate": "Geboortedatum",
    "Form client BSN": "BSN",
    "Form client name": "Naam",
    "Form doctor address": "Praktijkadres",
    "Form doctor city": "Plaats",
    "Form doctor name": "Naam",
    "Form doctor phone number": "Telefoonnummer",
    "Form_valid_until": "Geldig tot",
    "GP header": "De huisarts (of diens waarnemer) van de patiënt",
    "Gp_request_date": "Dagtekening",
    "Indication": "Indicatie/aanleiding",
    "Indication_representative": "Indicatie/aanleiding (vertegenwoordiger)",
    "Medical_action": "Naam medische handeling",
    "Medical_action_representative": "Naam medische handeling (vertegenwoordiger)",
    "Medication": "Medicijnen/vloeistof; naam",
    "Medication_representative": "Medicijnen/vloeistof; naam (vertegenwoordiger)",
    "New item": "Uitvoeringsverzoek huisarts",
    "New item fail": "Fout bij aanmaken nieuw uitvoeringsverzoek huisarts.",
    "New item success": "Nieuw uitvoeringsverzoek huisarts succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Other_relevant_details": "Andere in dit verband relevant geachte gegevens",
    "Other_relevant_details_representative": "Andere in dit verband relevant geachte gegevens (vertegenwoordiger)",
    "Reason_rejection": "Reden van afwijzing",
    "Reason_rejection_representative": "Reden van afwijzing (vertegenwoordiger)",
    "Replaced_by": "Vervangen door",
    "Representative_signature": "Vertegenwoordiger handtekening",
    "Representative_signature_date": "Vertegenwoordiger handtekening datum",
    "Request text": "Onderstaande medische handeling uit te voeren ten behoeve van cliënt in het kader van de daartoe afgesloten `Raamovereenkomst Medisch Handelen' (conform de daartoe opgestelde protocollen).",
    "Requests": "Verzoekt Nocht en Wille Zorg",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "Signing upload attachment item": "Ondertekend uitvoeringsverzoek uploaden",
    "Specification_medical_action": "Nadere specificatie handeling",
    "Specification_medical_action_representative": "Nadere specificatie handeling (vertegenwoordiger)",
    "Time_execution": "Tijdstippen van uitvoering",
    "Time_execution_representative": "Tijdstippen van uitvoering (vertegenwoordiger)",
    "To be filled by doctor": "Nadere gegevens (door de arts in te vullen)",
    "User": "Gebruiker"
  },
  "Languages": {
    "Dutch": "Nederlands",
    "English": "Engels"
  },
  "Location": {
    "Address": "Adres",
    "Attendant": "Begeleider",
    "Birthday": "Verjaardag",
    "Bsn_number": "BSN nummer",
    "Care_types": "Geboden zorg",
    "City": "Stad",
    "Date_of_birth": "Geboortedatum",
    "Daycare": "Dagbesteding",
    "Delete item": "Locatie verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de locatie.",
    "Delete item success": "Locatie succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je locatie {0} wilt {1}?",
    "Documentation": "Documentatie",
    "Edit item": "Locatie bewerken",
    "Edit item fail": "Fout bij het bewerken van de locatie. Locatie niet gewijzigd.",
    "Edit item success": "Locatie succesvol gewijzigd.",
    "Edit photo": "Foto veranderen",
    "First_name": "Voornaam",
    "Flush reports": "Spoellijst | Spoel rapporten",
    "FOBO reports": "FOBO-meldingen",
    "Gender": "Geslacht",
    "GenderOptions": {
      "M": "Man",
      "O": "Unknown / not specified",
      "V": "Vrouw"
    },
    "General reports": "Algemene rapportage",
    "General_practitioner": "Dokter",
    "House_annex": "Toevoeging",
    "House_number": "Huisnummer",
    "ID": "Id",
    "Indication": "Indicatie",
    "Insurance": "Verzekering",
    "Insurance_number": "Verzekeringsnummer",
    "Last_name": "Achternaam",
    "Legionella": "Legionella",
    "Legionella reports": "Legionella rapportages",
    "Living": "Wonen",
    "Locations": "Locaties",
    "Memos": "Memo's",
    "Menu item description": "{item} voor {location}",
    "Name": "Naam",
    "New item": "Nieuwe locatie",
    "New item fail": "Fout bij het maken van de nieuwe locatie.",
    "New item success": "Locatie succesvol toegevoegd.",
    "No available actions": "Er zijn geen beschikbare acties voor deze locatie.",
    "ObjectName": "Locatie",
    "Photo": "Foto",
    "Postal_code": "Postcode",
    "Presence reports": "Aanwezigheidsregistratie | Aanwezigheidsregistraties",
    "Representatives": "Vertegenwoordigers",
    "Requires_legionella_temperature_check": "Legionella temperatuur controle nodig",
    "Stay": "Logeren",
    "Tabs": {
      "Client care": "Zorg op locatie",
      "Employee roles": "Medewerkerrollen",
      "General": "Algemeen",
      "Tap points": "Tappunten",
      "Task categories": "Takenlijsten",
      "Task templates": "Taaktemplates"
    },
    "Tap points": "Tappunten",
    "Task categories": "Takenlijst | Takenlijsten",
    "Tasks": "Takenlijst",
    "Technical-services": "Onderhoud",
    "Telephone_number": "Telefoonnummer",
    "Temperature check": "Temperatuurcontrole",
    "Transportation": "Vervoer",
    "View location": "Bekijk locatie"
  },
  "Location_appointment": {
    "Alarm": "Alarm",
    "Alarm expired": "Het opgegeven moment voor het alarm is verlopen",
    "Appointment": "Afspraak",
    "Appointments": "Afspraken",
    "Datetime_end": "Tijdstip (eind)",
    "Datetime_start": "Tijdstip (start)",
    "Delete item": "Afspraak verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de afspraak.",
    "Delete item success": "Afspraak succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de {0} wilt {1}?",
    "Edit item": "Afspraak bewerken",
    "Edit item fail": "Fout bij het wijzigen van de afspraak.",
    "Edit item success": "Afspraak succesvol gewijzigd.",
    "Message": "Afspraak",
    "New item": "Nieuwe afspraak",
    "New item fail": "Fout bij het aanmaken van de afspraak.",
    "New item success": "Afspraak succesvol toegevoegd.",
    "User": "Gebruiker"
  },
  "Location_flush_report": {
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het rapport {0} wilt {1}?",
    "Dialog confirm flush report finalization": {
      "Message": "Weet je zeker dat je dit spoel rapport als definitief wilt markeren?",
      "Title": "Bevestig definitief markeren spoel rapport"
    },
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het rapport.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Errors": {
      "CONFIRM_FLUSH": "Bevestig spoeling",
      "DUPLICATE_YEAR_WEEK_COMBINATION": "Controleer de combinatie jaar/week",
      "ERROR_CONFIRM_FLUSH": "Spoeling bevestigen",
      "Invalid": "De invoer is ongeldig",
      "REPORT_CANNOT_BE_IN_FUTURE": "De gekozen combinatie voor week en jaar mag niet in de toekomst liggen",
      "Unique": "Er is al een rapportage gemaakt voor deze locatie voor de gekozen week"
    },
    "Export item": "Exporteren",
    "Export item fail": "Fout bij het exporteren van het spoellijstrapport.",
    "Export item success": "Spoellijstrapport succesvol geëxporteerd.",
    "Finalize": "Definitief maken",
    "Finalized": "Afgerond",
    "Finalized item": "Dit rapport is definitief gemarkeerd en kan niet meer worden gewijzigd.",
    "Finalized_by": "Afgerond door",
    "Flushed_cold": "Koud",
    "Flushed_warm": "Warm",
    "Location": "Locatie",
    "Lock item fail": "Fout bij het definitief maken van het rapport.",
    "Lock item success": "Rapport succesvol als definitief gemarkeerd.",
    "Name": "Naam",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het aanmaken van het rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "ObjectName": "Spoellijstrapport",
    "Tap_point": "Tappunt",
    "Week": "Week",
    "Week_from": "Week (vanaf)",
    "Week_until": "Week (t/m)",
    "Year": "Jaar"
  },
  "Location_memo": {
    "By": "Door",
    "Created": "Toegevoegd op",
    "Delete item": "Memo verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de memo.",
    "Delete item success": "Memo succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je memo {0} wilt {1}?",
    "Edit item": "Memo bewerken",
    "Memo": "Memo | Memo's",
    "New item": "Nieuwe memo",
    "ObjectName": "Memo",
    "Subject": "Onderwerp",
    "Title": "Titel",
    "User": "Gebruiker"
  },
  "Location_presence": {
    "Active clients only": "Alleen niet-gearchiveerde cliënten exporteren",
    "Choose an performance or group": "Kies eerst een prestatie of groep.",
    "Choose part of the day": "Kies een dagdeel.",
    "Client": "Cliënt",
    "Clients no longer linked to location": "De volgende cliënten zijn niet langer aan deze locatie gekoppeld op deze weekdag, maar hadden al een aanwezigheidsregistratie: {list}",
    "Clients presence": "Aanwezige cliënten",
    "Clients with registrations elsewhere": "De volgende cliënten hebben al een aanwezigheidsregistratie op een andere locatie en kunnen niet worden gekozen: {list}",
    "Date": "Datum",
    "Edit item locked": "Registratie is vergrendeld; je kunt geen wijzigingen opslaan.",
    "Export item": "Aanwezigheidsregistratie exporteren",
    "Export item fail": "Fout bij het exporteren van de aanwezigheidsregistraties.",
    "Export item success": "Aanwezigheidsregistraties succesvol geëxporteerd.",
    "Generate presence list first": "Genereer eerst de aanwezigheidslijst.",
    "Historical registrations editable": "De planning is inmiddels gewijzigd voor {list}. Bestaande aanwezigheidsregistraties blijven zichtbaar en kunnen nog worden gecorrigeerd.",
    "Location": "Locatie",
    "Lock item fail": "Geen toestemming om te vergrendelen.",
    "Month": "Maand",
    "New item fail": "Aanwezigheidsregistratie NIET opgeslagen.",
    "Non-declarable registrations": "Voor {date} bestaan aanwezigheidsregistraties buiten de actieve zorg voor {list}. Deze staan niet in de aanwezigheidslijst en worden niet automatisch meegenomen in nieuwe declaraties. Historische zorg kan waar toegestaan via de declaratiekeuze worden gecorrigeerd.",
    "No performances available": "Er is geen geboden zorg ingesteld op deze locatie op de gekozen datum.",
    "Open registrations": "Niet definitief gemaakte registraties",
    "Open registrations found": " Er zijn aanwezigheidsregistraties binnen de declaratieperiode die nog {not} definitief zijn gemaakt. Alleen wanneer “Altijd declareren” voor dit zorgtype is ingeschakeld, wordt er gedeclareerd ongeacht de aanwezigheidsregistraties.",
    "Registration locked": "Deze aanwezigheidsregistratie is definitief gemaakt en kan alleen nog door de locatiecoördinator worden gewijzigd! {error}",
    "Registrations": "Registraties",
    "Not all registration locked": "<strong>LET OP!</strong> Er zijn cliënten toegevoegd na het definitief maken. Gebruik <strong>Definitief ongedaan maken</strong> om deze opnieuw te verwerken en daarna weer definitief te maken.",
    "Save item success": "Aanwezigheidsregistratie opgeslagen.",
    "Type": "Bestandsformaat",
    "Vektisprestatie": "Prestatie",
    "Year": "Jaar"
  },
  "Location_tap_point": {
    "Delete item": "Tappunt verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het tappunt.",
    "Delete item success": "Tappunt succesvol verwijderd",
    "Delete item text": "Weet je zeker dat je tappunt {0} wilt {1}?",
    "Edit item": "Tappunt bewerken",
    "Edit item fail": "Fout bij het wijzigen van het tappunt.",
    "Edit item success": "Tappunt succesvol gewijzigd.",
    "Location": "Locatie",
    "Name": "Naam",
    "New item": "Nieuw tappunt",
    "New item fail": "Fout bij het aanmaken van het tappunt.",
    "New item success": "Tappunt succesvol toegevoegd.",
    "ObjectName": "Tappunt",
    "Type": "Type",
    "TypeOptions": {
      "COLD": "Koudwaterkraan",
      "HOT": "Mengkraan"
    }
  },
  "Location_task_category": {
    "Delete item": "Taakcategorie verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de taakcategorie.",
    "Delete item success": "Taakcategorie succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je taakcategorie {0} wilt {1}?",
    "Edit item": "Taakcategorie bewerken",
    "Location": "Locatie",
    "Name": "Naam",
    "New item": "Nieuwe categorie",
    "ObjectName": "Taakcategorie",
    "Tabs": {
      "General": "Algemeen",
      "Task templates": "Taaktemplates"
    }
  },
  "Location_task_item": {
    "Category": "Categorie",
    "Deadline": "Deadline",
    "Deadline passed": "De deadline voor deze taak is verstreken",
    "Delete item": "Taak verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de taak.",
    "Delete item success": "Taak succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je deze taak wilt {1}?",
    "Dialog confirm task completion": {
      "Message": "Weet je zeker dat je deze taak als afgerond wilt markeren?",
      "Title": "Bevestig afronden taak"
    },
    "Edit item": "Taak bewerken",
    "Edit item fail": "Fout bij het wijzigen van de taak.",
    "Edit item success": "Taak succesvol gewijzigd.",
    "Finalize": "Afronden",
    "Finalized": "Afgerond",
    "Finalized_by": "Afgerond door",
    "Name": "Naam",
    "New item": "Nieuwe taak",
    "New item fail": "Fout bij het aanmaken van de taak.",
    "New item success": "Taak succesvol toegevoegd.",
    "Start": "Start",
    "Status": "Status",
    "StatusOptions": {
      "Finalized": "Afgerond",
      "Todo": "Nog uit te voeren"
    },
    "Task marked as finalized": "Taak als afgerond gemarkeerd.",
    "Task marked as finalized failed": "De taak kon niet als afgerond worden gemarkeerd.",
    "Template": "Sjabloon",
    "Template__category": "Categorie",
    "Template__category__location": "Locatie",
    "Template__description": "Taakomschrijving",
    "View item": "Taak bekijken"
  },
  "Location_task_template": {
    "Category": "Taakcategorie",
    "Deadline": "Deadline",
    "Deadline append": "weken",
    "Delete item": "Taaktemplate verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de taaktemplate.",
    "Delete item success": "Taaktemplate succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je taaktemplate {0} wilt {1}?",
    "Description": "Taakomschrijving",
    "Edit item": "Taak template bijwerken",
    "Edit item fail": "Fout bij het wijzigen van de taak template.",
    "Edit item success": "Taak template succesvol gewijzigd.",
    "Enabled": "Ingeschakeld",
    "Interval": "Interval",
    "Interval_type": "Interval type",
    "IntervalOptions": {
      "MONTHS": "maand | maanden",
      "WEEKS": "week | weken"
    },
    "Location": "Locatie",
    "Name": "Naam",
    "New item": "Nieuwe taak template",
    "New item fail": "Fout bij het aanmaken van de taak template.",
    "New item success": "Nieuwe taak template succesvol toegevoegd.",
    "ObjectName": "Taaktemplate"
  },
  "Location_temperature_report": {
    "Cold water": "Koud water",
    "Cold water text": "Zet de kraan aan en zorg dat er een straal zo dik als een stift uit de kraan komt. Meet halverwege de straal de temperatuur. Tel tot 10 en noteer de beginwaarde, tel tot 60 en meet de eindwaarde en noteer deze in het formulier.",
    "Delete item": "Rapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het rapport {0} wilt {1}?",
    "Dialog confirm temperature report finalization": {
      "Message": "Weet je zeker dat je dit temperatuurrapport als definitief wilt markeren?",
      "Title": "Bevestig definitief markeren rapport"
    },
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het rapport.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Errors": {
      "DUPLICATE_YEAR_WEEK_COMBINATION": "Controleer de combinatie jaar/week",
      "INVALID_TEMPERATURE": "Temperatuur voor @.lower:{key} is niet geldig.",
      "Max_value": "@:{key} mag niet meer zijn dan 100 graden.",
      "Max_whole_digits": "@:{key} kan niet uit meer dan 3 cijfers bestaan.",
      "Min_value": "@:{key} mag niet minder zijn dan 0 graden.",
      "Unique": "Er is al een rapportage gemaakt voor deze locatie voor de gekozen week."
    },
    "Export item": "Exporteren",
    "Export item fail": "Fout bij het exporteren van het temperatuurrapport.",
    "Export item success": "Temperatuurrapport succesvol geëxporteerd.",
    "Finalize": "Definitief maken",
    "Finalized": "Afgerond",
    "Finalized item": "Dit rapport is definitief gemarkeerd en kan niet meer worden gewijzigd.",
    "Finalized_by": "Afgerond door",
    "Location": "Locatie",
    "Lock item fail": "Fout bij het definitief maken van het rapport.",
    "Lock item success": "Rapport succesvol als definitief gemarkeerd.",
    "Name": "Naam",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het aanmaken van het rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "Note": "Meet altijd eerst KOUD en dan pas WARM per kraan!",
    "ObjectName": "Temperatuur rapport | Temperatuur rapporten",
    "Tap_point": "Tappunt",
    "Temperature_cold_end": "Koud (einde)",
    "Temperature_cold_start": "Koud (begin)",
    "Temperature_warm": "Warm",
    "Warm water": "Warm water",
    "Warm water text": "Zet de kraan aan en zorg dat er een straal zo dik als een stift uit de kraan komt. Meet halverwege de straal de temperatuur. Wacht 60 seconden, noteer de eindtemperatuur in het formulier.",
    "Week": "Week",
    "Week_from": "Week (vanaf)",
    "Week_until": "Week (t/m)",
    "Year": "Jaar"
  },
  "Location_user_role": {
    "Delete item": "Roltoewijzing verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de roltoewijzing.",
    "Delete item success": "Roltoewijzing succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de roltoewijzing wilt {1}?",
    "Edit item": "Roltoewijzing bewerken",
    "Edit item fail": "Fout bij wijzigen van de roltoewijzing.",
    "Edit item success": "Roltoewijzing succesvol gewijzigd.",
    "Error loading data": "De lijst met roltoewijzingen kon niet worden geladen.",
    "Location": "Locatie",
    "New item": "Nieuwe roltoewijzing",
    "New item fail": "Fout bij het maken van de roltoewijzing.",
    "New item success": "Roltoewijzing succesvol toegevoegd.",
    "Role": "Rol",
    "User": "Medewerker"
  },
  "Location_workorder": {
    "Closed": "Afgerond op",
    "Created": "Toegevoegd op",
    "Date_from": "Datum (vanaf)",
    "Date_until": "Datum (t/m)",
    "Delete item": "Werkopdracht verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de werkopdracht.",
    "Delete item success": "Werkopdracht succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je werkopdracht {0} wilt {1}?",
    "Edit item": "Werkopdracht bijwerken",
    "Edit item fail": "Fout bij het wijzigen van de werkopdracht.",
    "Edit item success": "Werkopdracht succesvol gewijzigd.",
    "Export item": "Werkopdrachten exporteren",
    "Export item fail": "Fout bij het exporteren van de werkopdrachten.",
    "Export item success": "Werkopdrachten succesvol geëxporteerd.",
    "Finalize": "Afronden",
    "Finish item success": "werkopdracht succesvol afgerond.",
    "Fixer": "Behandelaar",
    "Handle": "Behandelen",
    "Handled work orders": "Afgeronde werkorders",
    "Location": "Locatie",
    "Locations": "Locaties",
    "New item": "Nieuwe werkopdracht",
    "New item fail": "Fout bij het aanmaken van de werkopdracht.",
    "New item success": "Nieuwe werkopdracht succesvol toegevoegd.",
    "ObjectName": "Werkopdracht",
    "Order": "Omschrijving",
    "Priority": "Prioriteit",
    "Problem": "Probleem",
    "Reject": "Afwijzen",
    "Reject item success": "Werkopdracht succesvol afgewezen.",
    "Reporter": "Melder",
    "Status": "Status",
    "Status_reason": "Opmerkingen",
    "StatusOptions": {
      "1": "Open",
      "2": "Wacht",
      "3": "Afgewezen",
      "4": "Afgerond"
    },
    "Title": "Onderwerp",
    "Unhandled work orders": "Openstaande werkorders",
    "View item": "Werkopdracht bekijken",
    "Work order": "Werkopdracht",
    "Work orders": "Werkopdrachten"
  },
  "Medical_file": {
    "Add Medicalfileinvolved_set item": "Voeg medicus toe",
    "Anesthesia": "Narcose",
    "Average_body_temp": "Gemiddelde lichaamstemperatuur",
    "Avg_doctor_results": "AVG Arts bezoeken en uitkomsten/verslagen",
    "Blood_samples": "Bloedprikken",
    "Cardiology": "Cardiologie",
    "City": "Plaats",
    "Client": "Cliënt",
    "Created": "Aangemaakt",
    "Delete item": "Verwijder medisch dossier",
    "Delete item fail": "Fout bij het verwijderen van medisch dossier.",
    "Delete item success": "Medisch dossier succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het medisch dossier {0} wilt {1}?",
    "Delete Medicalfileinvolved_set item": "Verwijder medicus",
    "Discipline": "Discipline",
    "Edit item": "Bewerk medisch dossier",
    "Edit item fail": "Fout bij het wijzigen van het medisch dossier. Het medisch dossier is niet gewijzigd.",
    "Edit item success": "Medisch dossier succesvol gewijzigd.",
    "Epilepsy": "Epilepsie diagnoses en onderzoeken",
    "Gp_visits": "Huisartsbezoeken",
    "Hospital_admissions": "Ziekenhuisopnames",
    "Kno": "KNO",
    "Length": "Lengte",
    "Medical involved overview": "Lijst met medici",
    "Medicalfileinvolved_set": "Overzicht betrokken medici",
    "Modified": "Gewijzigd",
    "Neurology": "Neurologie",
    "New item": "Nieuw medisch dossier",
    "New item fail": "Fout bij het toevoegen van het medisch dossier.",
    "New item success": "Medisch dossier succesvol toegevoegd.",
    "No medical file": "Voor cliënt {0} is nog geen medisch dossier aangemaakt. Druk op de knop \"{1}\" om een nieuw dossier aan te maken.",
    "Orthopedics": "Orthopedie",
    "Others": "Overige",
    "Personal_history": "Geboorte, geschiedenis en diagnostisering",
    "Phone_number": "Telefoon",
    "Physiotherapy": "Fysiotherapie",
    "Practitioner": "Huisarts",
    "Speech_therapy": "Logopedie",
    "Tabs": {
      "General": "Algemeen",
      "Involved": "Betrokken medici"
    },
    "Teeth": "Gebit",
    "Vision": "Visus"
  },
  "Medical_file_involved": {
    "City": "Plaats",
    "Delete": "verwijderen",
    "Delete item": "Verwijder medicus",
    "Delete item fail": "Fout bij het verwijderen van medicus.",
    "Delete item success": "Medicus succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je medicus {0} wilt {1}?",
    "Discipline": "Discipline",
    "Edit item": "Bewerk medicus",
    "Edit item fail": "Fout bij het wijzigen van medicus. Medicus is niet gewijzigd.",
    "Edit item success": "Medicus succesvol gewijzigd.",
    "New item": "Nieuwe medicus",
    "New item fail": "Fout bij het toevoegen van medicus.",
    "New item success": "Medicus succesvol toegevoegd.",
    "ObjectName": "Medicus | Medici",
    "Phone_number": "Telefoon",
    "Practitioner": "Huisarts"
  },
  "Message_board_message": {
    "Delete": "verwijderen",
    "Delete item": "Bericht verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het bericht.",
    "Delete item success": "Het bericht is succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het bericht {0} wilt {1}?",
    "New item": "Nieuw bericht",
    "New item fail": "Fout bij het versturen van het bericht.",
    "New item success": "Bericht is succesvol toegevoegd.",
    "Send text": "Ctrl + Enter verzendt"
  },
  "No": "Nee",
  "Not applicable": "n.v.t.",
  "Personal_data_form": {
    "Answer": "Toestemming:",
    "Answer_false": "Ik geef geen toestemming voor de verwerking van persoonsgegevens.",
    "Answer_representative": "Antwoord vertegenwoordiger(s):",
    "Answer_true": "Ik geef toestemming voor de verwerking van persoonsgegevens.",
    "Attachment": "Bijlage",
    "Cancelled": "Verlopen",
    "Client": "Client",
    "Consent message": "In Europa is privacywetgeving van toepassing op het verwerken van belangrijke gegevens. We noemen die gegevens “persoonsgegevens”, het betreft dat gegevens die herleidbaar zijn tot een individu. Zorginstellingen verwerken en gebruiken veel persoonsgegevens van hun bewoners en deelnemers, wij bewaren bijvoorbeeld zorgpassen van bewoners en wij maken gedetailleerde plannen waarin veel persoonlijke gegevens van deelnemers staan. Te denken valt aan BSN nummers, geboortedata en medische informatie.\n\nVanzelfsprekend is het belangrijk dat wij zorgvuldig met je gegevens omgaan, een van de vereisten is dat wij kunnen aantonen dat wij je toestemming hebben om gegevens van je of je verwant te verwerken. Ook moet het voor je eenvoudig zijn om die toestemming in te trekken.\n\nJe kunt ons toestemming verlenen je gegevens te verwerken door onderstaande verklaring te ondertekenen, op eenzelfde wijze kunt je je oorspronkelijke toestemming intrekken als je of je verwant bijvoorbeeld geen zorg meer bij ons afneemt.\n\nJe hebt het recht ons te verzoeken je gegevens te verwijderen, op je verzoek zullen wij dat onverwijld doen. Ook zullen wij je verzoek doorgeven aan andere organisaties die gegevens van ons hebben gekregen of gebruiken.\n\nWij zijn tevens wettelijk verplicht een functionaris gegevensbescherming aan te stellen, een zogeheten FG. Voor Nocht en Wille Zorg hebben we een FG aangesteld en dit gemeld bij de Autoriteit Persoonsgegevens.\n\nHierbij verleen ik, wettelijk vertegenwoordiger van {client}, toestemming aan Nocht en Wille Zorg BV en aan haar gelieerde ondernemingen voor het verwerken van alle (persoons) gegevens die voor het bieden van goede en verantwoorde zorg noodzakelijk zijn.",
    "Delete": "verwijderen",
    "Delete item": "Verwijder toestemmingsformulier gegevensverwerking",
    "Delete item fail": "Fout bij het verwijderen van het toestemmingsformulier gegevensverwerking.",
    "Delete item success": "Toestemmingsformulier gegevensverwerking succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het toestemmingsformulier gegevensverwerking wilt {1}?",
    "Deleted": "Verwijderd",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Toestemmingsformulier gegevensverwerking bewerken",
    "Edit item fail": "Fout bij het wijzigen van de toestemmingsformulier gegevensverwerking. Het toestemmingsformulier gegevensverwerking is niet gewijzigd.",
    "Edit item success": "Toestemmingsformulier gegevensverwerking succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Employee_signature": "Medewerker handtekening",
    "Employee_signature_date": "Medewerker handtekening datum",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Form client birthdate": "Geboortedatum",
    "Form client name": "Toestemmingsformulier van",
    "Form_valid_until": "Geldig tot",
    "New item": "Toestemmingsformulier gegevensverwerking",
    "New item fail": "Fout bij het toevoegen van het toestemmingsformulier gegevensverwerking.",
    "New item success": "Toestemmingsformulier gegevensverwerking succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Personal Data Protocol List": "Toestemmingsformulier gegevensverwerking",
    "Replaced_by": "Vervangen door",
    "Representative_signature": "Vertegenwoordiger handtekening",
    "Representative_signature_date": "Vertegenwoordiger handtekening datum",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "Start signing form message": "Kies de naam van de vertegenwoordiger en medewerker in die het document zullen ondertekenen.\n\nDe vertegenwoordiger zal een e-mail met een tekenverzoek ontvangen, na ondertekening door de vertegenwoordiger zal de medewerker een tekenverzoek ontvangen.",
    "Start signing item": "Definitief maken",
    "User": "Gebruiker"
  },
  "Photo_film_form": {
    "Access_how": "Hoe mogen wij de foto's en video's gebruiken?",
    "Access_how_representative": "Hoe mogen wij de foto's en video's gebruiken?",
    "Answer": "Toestemming:",
    "Answer_false": "Nee, Nocht en Wille Zorg mag géén foto's en video's maken van mijn verwant.",
    "Answer_representative": "Toestemming (vertegenwoordiger)",
    "Answer_true": "Ja, Nocht en Wille Zorg mag foto's en video's maken van mijn verwant.",
    "Consent explanation": "Op onze locaties, tijdens activiteiten of bij andere gelegenheden willen wij soms foto's en/of filmpjes maken van bewoners en deelnemers. Soms doen wij dat om de beelden te analyseren zodat wij de zorgverlening kunnen verbeteren soms doen wij dat om mooie momenten die we samen beleven vast te leggen.",
    "Consent message": "Ondergetekende verklaart hierbij dat zij middels de folder privacy en persoonsgegevens geïnformeerd is over het privacy beleid binnen Nocht en Wille Zorg.",
    "Delete item": "Toestemmingsformulier gebruik foto- en filmmateriaal verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het toestemmingsformulier.",
    "Delete item success": "Toestemmingsformulier succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het toestemmingsformulier gebruik foto- en filmmateriaal wilt {1}?",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Toestemmingsformulier bewerken",
    "Edit item fail": "Fout bij het wijzigen van het toestemmingsformulier. Toestemmingsformulier niet gewijzigd.",
    "Edit item success": "Toestemmingsformulier gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Form client birthdate": "Geboortedatum",
    "Form client name": "Toestemmingsformulier van",
    "New item": "Toestemmingsformulier gebruik foto- en filmmateriaal",
    "New item fail": "Fout bij het toevoegen van het toestemmingsformulier gebruik foto- en filmmateriaal.",
    "New item success": "Toestemmingsformulier gebruik foto- en filmmateriaal succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Photo Film Protocol List": "Toestemmingsformulier gebruik foto- en filmmateriaal",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt"
  },
  "Protocols_and_forms": {
    "Created": "Aangemaakt",
    "Editable_by": "Bewerkbaar door",
    "EditableByOptions": {
      "Representative": "Vertegenwoordiger",
      "Supplier": "Nocht en Wille"
    },
    "FormTypes": {
      "Bathing_swimming_form": "Afspraken baden en zwemmen",
      "Camera_surveillance_form": "Formulier toestemming camera- en audiotoezicht",
      "Epilepsy_protocol": "Epilepsie",
      "File_insight_form": "Toestemming inzage ondersteuningsplan",
      "Gp_execution_request_form": "Uitvoeringsverzoek huisarts",
      "Personal_data_form": "Formulier toestemming gegevensverwerking",
      "Photo_film_form": "Toestemming gebruik foto- en filmmateriaal",
      "Reanimation_form": "Afspraken rond medisch handelen"
    },
    "ShowArchived": "Welke items tonen",
    "Status": "Status",
    "StatusOptions": {
      "CANCELLED": "Vervallen",
      "CONCEPT": "Concept",
      "EXPIRED": "Verlopen",
      "FINAL": "Definitief",
      "SIGN_EMPLOYEE": "Tekenen (medewerker)",
      "SIGN_REPRESENTATIVE": "Tekenen (vertegenwoordiger)",
      "SUPERSEDED": "Vervangen"
    },
    "Type": "Type",
    "User": "Medewerker",
    "Valid until": "Geldig tot"
  },
  "Quality_manual": {
    "Delete": "verwijderen",
    "Delete document item": "Verwijder bestand",
    "Delete document item fail": "Fout bij het verwijderen van bestand.",
    "Delete document item success": "Bestand succesvol verwijderd.",
    "Delete document item text": "Weet je zeker dat je het bestand {0} wilt {1}?",
    "Delete folder item": "Verwijder map",
    "Delete folder item fail": "De map kon niet worden verwijderd. ",
    "Delete folder item success": "Map met succes verwijderd.",
    "Delete folder item text": "{2}Weet je zeker dat je de map {0} wilt {1}?",
    "Deletion of data recursive": "Alle onderliggende mappen en bestanden zullen ook worden verwijderd!",
    "Description": "Omschrijving",
    "Edit document item": "Bewerk bestand",
    "Edit document item fail": "Fout bij het bewerken van bestand.",
    "Edit document item success": "Bestand succesvol gewijzigd.",
    "Edit folder item": "Bewerk map",
    "Edit folder item fail": "De map kon niet worden gewijzigd. ",
    "Edit folder item success": "Map met succes gewijzigd.",
    "Error loading data": "Het kwaliteitshandboek kon niet worden geladen.",
    "File": "Bestand",
    "Name": "Naam",
    "New document item": "Nieuw bestand toevoegen",
    "New document item fail": "Fout bij het toevoegen van het bestand.",
    "New document item success": "Nieuw bestand succesvol toegevoegd.",
    "New folder item": "Nieuwe map",
    "New folder item fail": "Fout bij het toevoegen van de map.",
    "New folder item success": "Nieuwe map succesvol aangemaakt.",
    "Nothing to show": "Geen resultaten gevonden.",
    "Original_filename": "Originele bestandsnaam",
    "Parent folder": "Bovenliggende map",
    "Preview file item": "Voorbeeldweergave",
    "Show list view": "Lijst weergave",
    "Show tree view": "Boomstructuur"
  },
  "Reanimation_form": {
    "Action": "Handeling",
    "Client information": "Cliëntinformatie",
    "Consent message": "Met ondertekening van deze verklaring geef ik hierbij mijn wensen aan ten aanzien van verschillende (medische) situaties die mogelijk kunnen voorkomen bij de persoon die ik wettelijk vertegenwoordig",
    "Delete": "verwijderen",
    "Delete item": "Verwijder afspraken rond medisch handelen",
    "Delete item fail": "Fout bij het verwijderen van de afspraken rond medisch handelen.",
    "Delete item success": "Afspraken rond medisch handelen succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de afspraken rond medisch handelen wilt {1}?",
    "Do or do not": "Wat wel/niet doen",
    "Do/not": "Wel / niet",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Afspraken rond medisch handelen bewerken",
    "Edit item fail": "Fout bij het wijzigen van de afspraken rond medisch handelen. Het afspraken rond medisch handelen is niet gewijzigd.",
    "Edit item success": "Afspraken rond medisch handelen succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Explanation": "In het kader van de Wet op de geneeskundige behandelovereenkomst (WGBO) dient, voorafgaand aan het invullen van dit formulier, overleg plaats te vinden tussen de behandelde (huis) arts en de client/ wettelijk vertegenwoordiger.",
    "Form client address": "Adres",
    "Form client birthdate": "Geboortedatum",
    "Form client BSN": "BSN",
    "Form client name": "Naam",
    "Motivation": "Persoonsbeeld en motivatie",
    "Motivation_representative": "Opmerkingen vertegenwoordiger(s)",
    "New item": "Afspraken rond medisch handelen",
    "New item fail": "Fout bij het toevoegen van de afspraken rond medisch handelen.",
    "New item success": "Afspraken rond medisch handelen succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Perform_hospitalisation": "Ziekenhuisopname",
    "Perform_hospitalisation_representative": "Ziekenhuisopname",
    "Perform_intensive_care": "IC-opname",
    "Perform_intensive_care_representative": "IC-opname",
    "Perform_reanimation": "Reanimatie",
    "Perform_reanimation_representative": "Reanimatie",
    "Perform_respiration": "Beademing",
    "Perform_respiration_representative": "Beademing",
    "Representatives notes": "Opmerkingen vertegenwoordiger(s)",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt"
  },
  "Report": {
    "Add new report": "Maak nieuw @:{report}rapport | Maak nieuwe @:{report}",
    "Added by": "Toegevoegd door",
    "Aggression_nature": "Aard van agressie",
    "Aggression_to": "Agressie jegens",
    "Agressie": "Agressie",
    "Aid objects": "Hulpmiddelen",
    "Amount": "Hoeveelheid",
    "Attachment": "Bijlage",
    "Attachment_signoff": "Aftekenlijst",
    "Audio_recording": "Audio opname",
    "Behavior": "Gedrag",
    "Behaviour": "Gedrag",
    "Bread_amount": "Aantal boterhammen",
    "Cause": "Aanleiding",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Consistency": "Type",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Day": "Dagrapportage",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Deleted": "Verwijderd",
    "Duration": "Duur in minuten",
    "Edit item": "Rapport bewerken",
    "Editable_by": "Bewerkbaar door",
    "Epilepsie": "Epilepsie",
    "Epilepsy": "Epilepsie",
    "Epilepsy_notes": "Epilepsie verslag",
    "Errors": {
      "Max_digits": "Zorg ervoor dat er in totaal niet meer dan 3 cijfers zijn"
    },
    "Excrement": "Ontlasting",
    "Falling": "Vallen",
    "Files": "Bestanden",
    "Finalized": "Afgerond",
    "Fobo": "FOBO",
    "Fobo report": "FOBO-",
    "Food": "Wat is er gegeten?",
    "Food report": "Voedsel",
    "Food_full": "Wat is er gegeten?",
    "Had_clothing": "Aangekleed",
    "Involved": "Betrokkenen",
    "Location": "Locatie",
    "Medical file": "Medisch dossier",
    "Medicatie": "Medicatie",
    "Medication": "Medicijnen/vloeistof naam",
    "Medicine": "Noodmedicatie gebruikt",
    "Message": "Bericht",
    "Name": "Naam",
    "Nature_of_incident": "Aard van incident",
    "New item": "Nieuw rapport",
    "No access to audio": "Geen toegang tot audio",
    "No access to attachment": "Geen toegang tot bijlage",
    "Notes": "Bijzonderheden",
    "Number_of_drinks": "Aantal bekers drinken",
    "Ongewenst_gedrag": "Ongewenst gedrag",
    "Other": "Overige",
    "Overige": "Overige",
    "Priority": "Hoge prioriteit",
    "Protocols and forms": "Protocollen en toestemmingsformulieren",
    "Quoted_message": "Bericht",
    "Read less": "Lees minder...",
    "Read more": "Lees meer...",
    "Recommendation": "Advies langetermijn maatregel",
    "Remediation": "Direct genomen actie of maatregel",
    "Shift": "Dagdeel",
    "Support plans": "Ondersteuningsplannen",
    "Tabs": {
      "General": "Algemeen"
    },
    "Temperature": "Temperatuur",
    "Thermometer_measurement": "Thermometer meting",
    "Thermometer_type": "Type thermometer",
    "Time": "Tijd",
    "Undesired_behaviour": "Ongewenst gedrag",
    "Vallen": "Vallen",
    "Verslikking": "Verslikking",
    "Walk_away": "Weglopen",
    "Weglopen": "Weglopen",
    "Weight": "Gewicht",
    "Weight report": "Gewichtsrapportage",
    "Wet zorg en dwang": "WZD-registraties",
    "When": "Wanneer",
    "Where": "Plaats voorval"
  },
  "Role": {
    "Assign": "Toewijzen",
    "Assign client roles": "Cliënt gebruikersrollen toewijzen",
    "Assign representative roles": "Vertegenwoordigersrollen toewijzen",
    "Assign roles": "Rollen toewijzen",
    "Assign user roles": "Medewerkersrollen toewijzen",
    "Clients": "Cliënten",
    "Delete item": "Rol verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de rol.",
    "Delete item success": "Rol succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de rol {0} wilt {1}?",
    "Description": "Omschrijving",
    "Edit item": "Rol bewerken",
    "Edit item fail": "Fout bij wijzigen van de rol.",
    "Edit item success": "Rol succesvol gewijzigd.",
    "Error loading data": "De lijst met rollen kon niet worden geladen.",
    "Friendly_name": "Weergavenaam",
    "Import roles": "Rollen importeren",
    "Import roles warning": "{note}: Met import werk je de rollen- en permissiematrix bij vanuit een Excelbestand. Gebruik altijd een recente export als basis en controleer wijzigingen zorgvuldig voordat je importeert.",
    "Locations": "Locaties",
    "Name": "Naam",
    "New item": "Nieuwe rol",
    "New item fail": "Fout bij het maken van de rol.",
    "New item success": "Rol succesvol toegevoegd.",
    "None assigned": "Geen toegewezen",
    "ObjectName": "Rol",
    "Permissions": "Permissies",
    "Representative": "Vertegenwoordiger",
    "Revert": "Stap herstellen",
    "Roles": "Rollen",
    "Services": {
      "Aid object": "Hulpmiddel",
      "Bathing swimming form": "Bad-/zwemformulier",
      "Behaviour goal": "Gedragsdoel",
      "Behaviour goal message": "Bericht bij gedragsdoel",
      "Camera surveillance form": "Cameratoezichtformulier",
      "Client": "Cliënt",
      "Client care": "Cliëntenzorg",
      "Client file": "Cliëntdossier",
      "Client goal": "Cliëntdoel",
      "Contact": "Contact",
      "Day report": "Dagrapport",
      "Day report message": "Bericht bij dagrapport",
      "Epilepsy protocol": "Epilepsieprotocol",
      "Epilepsy report": "Epilepsieverslag",
      "Excrement report": "Ontlastingsrapport",
      "File insight form": "Dossierinzageformulier",
      "File tree": "Mappenstructuur",
      "File tree category": "Mappenstructuurcategorie",
      "File tree document": "Mappenstructuurdocument",
      "Fobo report": "FoBo-rapport",
      "Food report": "Voedingsrapport",
      "General practitioner": "Huisarts",
      "Goal report": "Doelenrapport",
      "Gp execution request form": "Uitvoeringsverzoek huisarts",
      "Location": "Locatie",
      "Location appointment": "Locatieafspraak",
      "Location flush report": "Spoelrapport locatie",
      "Location flush report item": "Spoelrapport-item locatie",
      "Location memo": "Locatiememo",
      "Location presence": "Aanwezigheid op locatie",
      "Location tap point": "Tappunt locatie",
      "Location task category": "Taakcategorie locatie",
      "Location task item": "Taakitem locatie",
      "Location task template": "Taaksjabloon locatie",
      "Location temperature report": "Temperatuurrapport locatie",
      "Location temperature report item": "Temperatuurrapport-item locatie",
      "Location user role": "Gebruikersrol op locatie",
      "Location workorder": "Werkopdracht locatie",
      "Medical file": "Medisch dossier",
      "Medical file involved": "Betrokkenen medisch dossier",
      "Medical report": "Medisch rapport",
      "Message board": "Prikbord",
      "Message board message": "Prikbordbericht",
      "Personal data form": "Persoonsgegevensformulier",
      "Photo film form": "Foto-/filmformulier",
      "Quality manual category": "Categorie kwaliteitsdocument",
      "Quality manual document": "Kwaliteitsdocument",
      "Reanimation form": "Reanimatieformulier",
      "Role": "Rol",
      "Roles": "Rollen",
      "Support plan": "Ondersteuningsplan",
      "Temperature report": "Temperatuurrapport",
      "User": "Gebruiker",
      "User logon device": "Gebruikersinlogapparaat",
      "User role": "Gebruikersrol",
      "Weight report": "Gewichtsrapport",
      "Wzd registration": "Wzd-registratie"
    },
    "Stepper": {
      "Steps": {
        "Select client and roles": "Rollen per cliënt",
        "Select client and roles description": "Controleer alle toegewezen rollen per niveau voordat je de configuratie opslaat.",
        "Select client and roles title": "Welke rollen wil je per cliënt aan deze {userType} toewijzen?",
        "Select location and roles": "Rollen per locatie",
        "Select location and roles description": "Ken specifieke rollen toe die alleen binnen geselecteerde locaties van toepassing zijn.",
        "Select location and roles title": "Welke rollen wil je per locatie aan deze {userType} toewijzen?",
        "Select user": "{userType} selecteren",
        "Select user description": "Selecteer de {userType} waarvoor je autorisaties gaat configureren.",
        "Select user roles": "Algemene rollen",
        "Select user roles description": "Deze rollen gelden onafhankelijk van locatie of cliënt.",
        "Select user roles title": "Welke algemene rollen wil je aan deze {userType} toewijzen?",
        "Select user title": "Voor welke {userType} wil je rollen toewijzen?",
        "Summary": "Overzicht",
        "Summary description": "Controleer alle toegewezen rollen per niveau voordat je de configuratie opslaat.",
        "Summary title": "Samenvatting van de roltoewijzingen"
      }
    },
    "Type": "Type",
    "User": "Medewerker",
    "User roles": "Medewerkersrollen"
  },
  "Save": "Opslaan",
  "Save and add another": "Opslaan & nieuw",
  "Save and close": "Opslaan & sluiten",
  "Save and stay": "Opslaan & blijven",
  "Save and sync": "Opslaan en synchroniseren",
  "Save, sync and close": "Opslaan, synchroniseren en sluiten",
  "Services": {
    "Aid object": "Object van de hulp",
    "Bathing swimming form": "Baden zwemmen vorm",
    "Behaviour goal": "Gedrag doel",
    "Behaviour goal message": "Boodschap gedragsdoel",
    "Camera surveillance form": "Formulier camerabewaking",
    "Client": "Klant",
    "Client care": "Klantenservice",
    "Client file": "Cliëntenbestand",
    "Client goal": "Doel van de klant",
    "Contact": "Contact",
    "Day report": "Dagverslag",
    "Day report message": "Bericht dagrapport",
    "Epilepsy protocol": "Protocol epilepsie",
    "Epilepsy report": "Epilepsie rapport",
    "Excrement report": "Rapport over uitwerpselen",
    "File insight form": "Formulier voor bestandsinzicht",
    "File tree": "Bestandsstructuur",
    "File tree category": "Categorie bestandsstructuur",
    "File tree document": "Bestandsboom document",
    "Fobo report": "Verslag-Fobo",
    "Food report": "Voedsel rapport",
    "General practitioner": "Huisarts",
    "Goal report": "Rapport Doel",
    "Gp execution request form": "Aanvraagformulier voor uitvoering van de huisarts",
    "Location": "Plaats",
    "Location appointment": "Locatie afspraak",
    "Location flush report": "Rapport over locatiespoeling",
    "Location flush report item": "Rapportitem locatievereffening",
    "Location memo": "Locatie memo",
    "Location presence": "Locatie aanwezigheid",
    "Location tap point": "Locatie tappunt",
    "Location task category": "Locatie taakcategorie",
    "Location task item": "Locatie taakitem",
    "Location task template": "Sjabloon voor locatietaken",
    "Location temperature report": "Locatie temperatuur rapport",
    "Location temperature report item": "Locatie temperatuur rapportitem",
    "Location user role": "Locatie gebruikersrol",
    "Location workorder": "Locatie werkorder",
    "Medical file": "Medisch dossier",
    "Medical file involved": "Betrokken medisch dossier",
    "Medical report": "Medisch rapport",
    "Message board": "Het forum",
    "Message board message": "Het bericht van het prikbord",
    "Personal data form": "Formulier persoonsgegevens",
    "Photo film form": "Fotofilm formulier",
    "Quality manual category": "Kwaliteit handleiding categorie",
    "Quality manual document": "Kwaliteit handboek document",
    "Reanimation form": "Formulier reanimatie",
    "Role": "Rol",
    "Support plan": "Ondersteuningsplan",
    "Temperature report": "Temperatuur rapport",
    "User": "Gebruiker",
    "User logon device": "Apparaat voor aanmelding van de gebruiker",
    "User role": "Gebruikersrol",
    "Weight report": "Gewicht rapport",
    "Wzd registration": "Wzd-registratie"
  },
  "Support_plan": {
    "Agreements": "Afspraken",
    "Attachment": "Bijlage",
    "Attention_points": "Het is noodzakelijk aandacht te besteden aan:",
    "Attention_points_representative": "Het is noodzakelijk aandacht te besteden aan (vertegenwoordiger):",
    "Autosave is disabled": "Automatisch opslaan is uitgeschakeld.",
    "Autosave is enabled": "Automatisch opslaan is ingeschakeld.",
    "Cancelled": "Verlopen",
    "Care needs of the participant": "Zorgvraag van de deelnemer",
    "Client": "Cliënt",
    "Client_aid": "Hoe helpen wij de deelnemer deze overkoepelende doelen te bereiken?",
    "Client_aid_representative": "Hoe helpen wij de deelnemer deze overkoepelende doelen te bereiken (vertegenwoordiger)?",
    "Client_future": "Hoe ziet de toekomst van de deelnemer eruit?",
    "Client_future_representative": "Hoe ziet de toekomst van de deelnemer eruit? (vertegenwoordiger)",
    "Client_goals": "Welke overkoepelende doelen wil de deelnemer bereiken?",
    "Client_goals_representative": "Welke overkoepelende doelen wil de deelnemer bereiken (vertegenwoordiger)?",
    "Client_treatment": "Wat is de zorgvraag van de deelnemer?",
    "Client_treatment_representative": "Wat is de zorgvraag van de deelnemer (vertegenwoordiger)?",
    "Communication and interaction": "Hoe ziet de omgang en communicatie met de deelnemer eruit?",
    "Contact_decisions": "Beslissingen die alleen mogen worden genomen na overleg met ouders/vertegenwoordigers:",
    "Contact_decisions_representative": "Beslissingen die alleen mogen worden genomen na overleg met ouders/vertegenwoordigers (vertegenwoordiger):",
    "Contact_situations": "In welke situaties moet Nocht en Wille direct contact opnemen met ouders/vertegenwoordigers?",
    "Contact_situations_representative": "In welke situaties moet Nocht en Wille direct contact opnemen met ouders/vertegenwoordigers (vertegenwoordiger)?",
    "Created": "Toegevoegd op",
    "Delete": "verwijderen",
    "Delete item": "Verwijder ondersteuningsplan",
    "Delete item fail": "Fout bij het verwijderen van ondersteuningsplan.",
    "Delete item success": "Ondersteuningsplan succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het ondersteuningsplan wilt {1}?",
    "Deleted": "Gearchiveerd",
    "Disable autosave": "Uitschakelen",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Bewerk ondersteuningsplan",
    "Edit item fail": "Fout bij het wijzigen van het ondersteuningsplan. Het ondersteuningsplan is niet gewijzigd.",
    "Edit item success": "Ondersteuningsplan succesvol aangemaakt.",
    "Editable_by": "Bewerkbaar door",
    "EditableByOptions": {
      "Representative": "Vertegenwoordiger",
      "Supplier": "Nocht en Wille"
    },
    "Employee_signature": "Medewerker handtekening",
    "Employee_signature_date": "Medewerker handtekening datum",
    "Enable autosave": "Inschakelen",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REVERT_NOT_AVAILABLE": "Het ondersteuningsplan kan niet worden teruggezet naar de conceptfase."
    },
    "General_report": "Algemeen verslag. Hoe is het afgelopen jaar verlopen? (kort)",
    "General_report_representative": "Algemeen verslag. Hoe is het afgelopen jaar verlopen (kort, vertegenwoordiger)?",
    "Goal_1": "Doel 1",
    "Goal_1_representative": "Doel 1 (vertegenwoordiger)",
    "Goal_2": "Doel 2",
    "Goal_2_representative": "Doel 2 (vertegenwoordiger)",
    "Limitations": "Welke (beperkende) maatregelen worden genomen om deze risico's te voorkomen?",
    "Limitations_representative": "Welke (beperkende) maatregelen worden genomen om deze risico's te voorkomen? (vertegenwoordiger)",
    "Medical history": "Medicatie/Medische historie",
    "Medication": "Medicatie",
    "Medication_history": "Medische geschiedenis",
    "Medication_history_representative": "Medische geschiedenis (vertegenwoordiger)",
    "Medication_representative": "Medicatie (vertegenwoordiger)",
    "Meeting_summary": "Korte samenvatting OP-bespreking",
    "Meeting_summary_representative": "Korte samenvatting OP-bespreking (vertegenwoordiger)",
    "Modified": "Bewerkt op",
    "Name": "Naam",
    "New item": "Nieuw ondersteuningsplan",
    "New item fail": "Fout bij het toevoegen van het ondersteuningsplan.",
    "New item success": "Ondersteuningsplan succesvol toegevoegd.",
    "Not_met_support": "Ondersteuningsvragen waaraan Nocht en Wille niet tegemoet kan komen:",
    "Not_met_support_representative": "Ondersteuningsvragen waaraan Nocht en Wille niet tegemoet kan komen (vertegenwoordiger):",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "Plan_valid_until": "Geldig tot",
    "Replaced_by": "Vervangen door",
    "Report": "Verslag",
    "Representative_signature": "Vertegenwoordiger handtekening",
    "Representative_signature_date": "Vertegenwoordiger handtekening datum",
    "Risks and limitations": "Risico's en beperkingen",
    "Risks_others": "Risico's voor anderen",
    "Risks_others_representative": "Risico's voor anderen (vertegenwoordiger)",
    "Risks_self": "Risico's voor zichzelf",
    "Risks_self_representative": "Risico's voor zichzelf (vertegenwoordiger)",
    "Role_guardians": "Wat is de rol van ouders/mantelzorgers ten aanzien van de zorg en ondersteuning en met betrekking tot de realisatie van de gestelde doelen?",
    "Role_guardians_representative": "Wat is de rol van ouders/mantelzorgers ten aanzien van de zorg en ondersteuning en met betrekking tot de realisatie van de gestelde doelen (vertegenwoordiger)?",
    "Role_partners": "Wie zijn de samenwerkende partners met betrekking tot de zorg en ondersteuning? Wat is hun rol ten aanzien van de zorgverlening en de gestelde doelen?",
    "Role_partners_representative": "Wie zijn de samenwerkende partners met betrekking tot de zorg en ondersteuning? Wat is hun rol ten aanzien van de zorgverlening en de gestelde doelen (vertegenwoordiger)?",
    "ShowArchived": "Welke items tonen",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed": "Getekend op",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "since": "sinds",
    "Status": "Status",
    "StatusOptions": {
      "CANCELLED": "Vervallen",
      "CONCEPT": "Concept",
      "EXPIRED": "Verlopen",
      "FINAL": "Definitief",
      "SIGN_EMPLOYEE": "Tekenen (medewerker)",
      "SIGN_REPRESENTATIVE": "Tekenen (vertegenwoordiger)",
      "SUPERSEDED": "Vervangen"
    },
    "Supportplan of": "Ondersteuningsplan van",
    "Transport": "Transport",
    "Transport_representative": "Transport (vertegenwoordiger)",
    "Transportation": "Vervoer",
    "Treatment_activities": "Activiteiten",
    "Treatment_activities_representative": "Activiteiten (vertegenwoordiger)",
    "Treatment_communication": "Communicatie",
    "Treatment_communication_representative": "Communicatie (vertegenwoordiger)",
    "Treatment_drink": "Drinken",
    "Treatment_drink_representative": "Drinken (vertegenwoordiger)",
    "Treatment_food": "Eten",
    "Treatment_food_representative": "Eten (vertegenwoordiger)",
    "Treatment_grooming": "Verzorging",
    "Treatment_grooming_representative": "Verzorging (vertegenwoordiger)",
    "Treatment_movement": "Beweging en buitenlucht",
    "Treatment_movement_representative": "Beweging en buitenlucht (vertegenwoordiger)",
    "Treatment_sexuality": "Sexualiteit",
    "Treatment_sexuality_representative": "Sexualiteit (vertegenwoordiger)",
    "Treatment_sleep": "Slapen",
    "Treatment_sleep_representative": "Slapen (vertegenwoordiger)",
    "Treatment_transfer": "Transfer",
    "Treatment_transfer_representative": "Transfer (vertegenwoordiger)",
    "Treatment_water": "Baden, douchen en zwemmen",
    "Treatment_water_representative": "Baden, douchen en zwemmen (vertegenwoordiger)",
    "Valid until": "Geldig tot",
    "Who_is_client": "Wie is de deelnemer",
    "Who_is_client_representative": "Wie is de deelnemer (vertegenwoordiger)"
  },
  "Temperature": {
    "Added by": "Toegevoegd door",
    "Cause": "Aanleiding",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Delete item": "Temperatuurrapport verwijderen",
    "Delete item fail": "Fout bij het verwijderen van het temperatuurrapport.",
    "Delete item success": "Temperatuurrapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het temperatuurrapport wilt {1}?",
    "Edit item": "Temperatuurrapport",
    "Edit item fail": "Fout bij het wijzigen van het temperatuurrapport. Temperatuurrapport niet gewijzigd.",
    "Edit item success": "Temperatuurrapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Name": "Naam",
    "New item": "Nieuw temperatuurrapport",
    "New item fail": "Fout bij het maken van de nieuw temperatuurrapport.",
    "New item success": "Temperatuurrapport succesvol toegevoegd.",
    "ObjectName": "Temperatuur rapport | Temperatuur rapporten",
    "Temperature": "Temperatuur",
    "Thermometer_measurement": "Thermometer meting",
    "Thermometer_type": "Type thermometer",
    "Time": "Tijd"
  },
  "User": {
    "After Authenticator QR scan": "Klik na het scannen van de QR-code op {0}.",
    "After install authenticator next": "Nadat je de Authenticator-app op je apparaat hebt geïnstalleerd, klikt je op {0}.",
    "After setup authenticator account next": "Wanneer je klaar bent om door te gaan, klikt je op {0}.",
    "Already has account": "Heb je al een account? Om in te loggen, ga je naar de",
    "Already logged in": "Er is nog een gebruiker ingelogd. Log eerst uit en probeer het dan opnieuw.",
    "Assigned roles": "Toegewezen rollen",
    "Authenticator allow notifications": "Sta meldingen toe wanneer daarom wordt gevraagd.",
    "Authenticator select other account": "Voeg vervolgens een account toe. Wanneer je gebruik maakt van de Microsoft Authenticator-app, selecteer dan \"Ander account\".",
    "Back to login": "Terug naar inloggen",
    "Back to password reset request": "Nieuw wachtwoord aanvragen.",
    "Cannot scan QR code?": "Werkt de QR-code niet?",
    "Capslock enabled": "Caps Lock is ingeschakeld.",
    "Change email item fail": "Het wijzigen van het e-mailadres is niet gelukt. Controleer het gemarkeerde veld en probeer het opnieuw.",
    "Change photo": "Wijzig foto",
    "Change view": "Wijzig weergave",
    "Confirm identity fail": "Fout bij het bevestigen van de gebruiker.",
    "Confirm identity success": "Gebruiker is succesvol bevestigd.",
    "Current email": "Huidig e-mailadres",
    "Delete": "verwijderen",
    "Delete item": "Verwijder gebruiker",
    "Delete item fail": "Fout bij het verwijderen van gebruiker.",
    "Delete item success": "Gebruiker succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het account voor {0} wilt {1}?",
    "Delete user": "Gebruiker verwijderen",
    "Delete user fail": "De gebruiker kon niet worden verwijderd. ",
    "Delete user success": "Gebruiker met succes verwijderd.",
    "Delete user text": "Weet je zeker dat je het account voor {0} wilt {1}?",
    "Dialog confirm resend invite": {
      "Message": "Weet je zeker dat je de uitnodiging wilt verzenden?",
      "Title": "Uitnodiging verzenden"
    },
    "Dialog confirm reset password": {
      "Message": "Weet je zeker dat je het wachtwoord voor gebruiker <strong>{user}</strong> opnieuw in wilt stellen?",
      "Title": "Wachtwoord opnieuw instellen"
    },
    "Download Authenticator app": "Download Authenticator app",
    "Download authenticator first": "Download eerst de app",
    "Edit item": "Bewerk gebruiker",
    "Edit item email fail": "Fout bij het aanvragen van de e-mailadreswijziging. De e-mailgegevens zijn niet gewijzigd.",
    "Edit item fail": "Fout bij het bewerken van de gebruiker. De gebruiker is niet gewijzigd.",
    "Edit item profile": "Profiel bewerken",
    "Edit item success": "Gebruiker succesvol gewijzigd.",
    "Edit user": "Gebruiker wijzigen",
    "Edit user email fail": "Fout bij het verzoek tot wijzigen van het e-mailadres. E-mailadres is niet gewijzigd.",
    "Edit user fail": "Fout bij het wijzigen van de gebruiker. Gebruiker is niet gewijzigd.",
    "Edit user success": "Gebruiker met succes gewijzigd.",
    "Email": "E-mailadres",
    "Email change": "Om het @.lower:User.Email definitief te wijzigen, is er een bericht naar het nieuwe @.lower:User.Email gestuurd met instructies.",
    "Email change success": "Het @.lower:User.Email is bevestig. Je kunt nu met je nieuwe @.lower:User.Email inloggen.",
    "Email check": "Contoleer het e-mailadres.",
    "Email edit": "Klik op het pen icoon om het wachtwoord aan te passen.",
    "Email edit message": "Hieronder kun je het e-mailadres wijzigen. {0}{1}{2}{3} Het is verplicht om het nieuwe e-mailadres te bevestigen. Volg de instructies in de e-mail die naar het nieuwe e-mailadres wordt verzonden.",
    "Email in use": "Het opgegeven e-mailadres is al in gebruik.",
    "Email invalid": "E-mailadres is niet geldig.",
    "Email mandatory": "E-mailadres is verplicht.",
    "Error loading data": "De lijst met gebruikers kon vanwege een fout niet worden geladen.",
    "Errors": {
      "Biometrics blocked error": "Touch ID/Face ID is te vaak mislukt en geblokkeerd, probeer het later opnieuw.",
      "Biometrics error": "Je bent uitgelogd omdat Touch ID/Face ID verificatie is mislukt.",
      "Profile error": "Er is (nog) geen geldig ECD profiel aan je toegewezen, neem contact op met de beheerder.",
      "Timeout error": "Je bent uitgelogd vanwege inactiviteit.",
      "TOTP_TOKEN_INVALID": "MFA token is niet geldig."
    },
    "First name mandatory": "Voornaam is verplicht.",
    "First_name": "Voornaam",
    "FirstName": "Voornaam",
    "FirstName mandatory": "Voornaam is verplicht.",
    "Forgot": "Wachtwoord vergeten",
    "Full name": "Volledige naam",
    "Install authenticator on phone": "Installeer {0} of {1} op je telefoon.",
    "Is_attendant": "Is begeleider",
    "Is_living_location_caretaker": "Is concierge",
    "Is_location_coordinator": "Is locatie coördinator",
    "Is_management": "Is management",
    "Is_mentor": "Is mentor",
    "Is_personal_attendant": "Is persoonlijk begeleider",
    "Is_superuser": "Is superuser?",
    "Is_technical_services": "Is technische onderhoud",
    "Is_trustee": "Is curator",
    "IsSSO": "Via SSO?",
    "Keep me logged in": "Ingelogd blijven",
    "Last name mandatory": "Achternaam is verplicht.",
    "Last_name": "Achternaam",
    "LastName": "Achternaam",
    "LastName mandatory": "Achternaam is verplicht.",
    "Locale": "Taal",
    "LocaleOptions": {
      "En-US": "@:Languages.English",
      "Nl-NL": "@:Languages.Dutch"
    },
    "Locations": "Locaties",
    "Login": "Medewerker login",
    "Login failed": "De combinatie gebruikersnaam/wachtwoord is onjuist.",
    "Login header": "Inloggen",
    "Login help": "Hulp nodig bij inloggen?",
    "Login success": "Je bent succesvol ingelogd.",
    "Login user": "Inloggen",
    "Lost MFA code?": " Ben je de code kwijt?",
    "Manually add code": "Voeg de volgende code handmatig toe aan de Authenticator-app.",
    "Mark self": "Jij",
    "MFA enter code": "Voer de code in die wordt weergegeven in de Authenticator-app.",
    "MFA lost code": "Stuur een e-mail naar {0} met het verzoek om je beveiligingsinstellingen te verwijderen. Voor je veiligheid zullen wij je identiteit moeten verifiëren om dit proces te voltooien. Om het proces soepel te laten verlopen, verzoeken wij je om de e-mail bij voorkeur vanaf hetzelfde e-mailadres te versturen en onder vermelding van je klantnummer.",
    "MFA lost code after setup": "Als je de code verliest, stuur dan een e-mail naar {0} met het verzoek om je beveiligingsinstellingen te verwijderen. Voor je veiligheid zullen wij je identiteit moeten verifiëren om dit proces te voltooien. Om het proces soepel te laten verlopen, verzoeken wij je om de e-mail bij voorkeur vanaf hetzelfde e-mailadres te versturen en onder vermelding van je klantnummer.",
    "Mfa reset item fail": "MFA reset mislukt.",
    "Mfa reset item success": "MFA succesvol gereset.",
    "MFA setup completed": "Voltooid!",
    "MFA setup completed text": "Je hebt je beveiligingsgegevens ingesteld. Klik op {0} om door te gaan met inloggen.",
    "MFA Status": "MFA-status",
    "MFA verify failed": "De opgegeven token is niet geldig.",
    "Name": "Naam",
    "New item": "Nieuwe medewerker",
    "New item fail": "Fout bij het toevoegen van de gebruiker.",
    "New item success": "Gebruiker succesvol toegevoegd.",
    "New representative": "Vertegenwoordiger toevoegen",
    "New representative item": "Nieuwe vertegenwoordiger",
    "New user": "Gebruiker toevoegen",
    "New user fail": "Fout bij het aanmaken van de gebruiker.",
    "New user success": "Gebruiker met succes aangemaakt.",
    "Password": "Wachtwoord",
    "Password change": "Wachtwoord wijzigen",
    "Password change message": "Om het wachtwoord te wijzigen, dien je je oude wachtwoord én twee keer het nieuwe wachtwoord op te geven.",
    "Password change set": "Voer hieronder je gewenste wachtwoord in en bevestig dit.",
    "Password checks": {
      "At least n Characters": "Wachtwoord is minimaal {n} tekens lang",
      "Contains numbers": "Bevat minimaal één cijfer",
      "Contains special char": "Bevat minimaal één speciaal teken",
      "Contains uppercase": "Bevat minimaal één hoofdletter",
      "Digits": "Het wachtwoord moet minimaal 1 cijfer bevatten",
      "Lowercase": "Het wachtwoord moet minimaal 1 kleine letter bevatten",
      "Min": "Het wachtwoord moet minimaal {n} tekens lang zijn",
      "Not_same": "Nieuwe wachtwoorden zijn niet hetzelfde",
      "Passwords different then old password": "Wachtwoord is niet gelijk aan het huidige wachtwoord",
      "Passwords equal": "Beide wachtwoorden zijn gelijk",
      "Same_old": "Het nieuwe wachtwoord is hetzelfde als het oude wachtwoord",
      "Symbols": "Het wachtwoord moet minimaal 1 symbool bevatten",
      "Uppercase": "Het wachtwoord moet minimaal 1 hoofdletter bevatten"
    },
    "Password confirm": "Herhaal wachtwoord",
    "Password current": "Huidig wachtwoord",
    "Password fail": "Controleer het wachtwoord.",
    "Password mandatory": "Wachtwoord is verplicht.",
    "Password new": "Nieuw wachtwoord",
    "Password reset": "Wachtwoord resetten",
    "Password reset fail": "Wachtwoord reset kon niet worden uitgevoerd.",
    "Password reset new text": "Voer hieronder het nieuwe wachtwoord in",
    "Password reset request success": "Er is een e-mail voor wachtwoord herstel verstuurd naar {email}. ",
    "Password reset success": "Het wachtwoord is succesvol bijgewerkt.",
    "Password reset text": "Vul het e-mailadres van de gebruiker in, waarvan het wachtwoord moet worden gereset.",
    "Password reset token invalid": "De link is ongeldig of verlopen.",
    "Photo": "Foto",
    "Profile photo": "Profielfoto",
    "Refresh list": "Lijst met gebruikers vernieuwen",
    "RegionalSetting": "Regionale indeling",
    "RegionalSettingOptions": {
      "En-US": "@:Languages.English",
      "Nl-NL": "@:Languages.Dutch"
    },
    "Request forgot": "Nieuw wachtwoord aanvragen",
    "Resend invite": "Uitnodiging verzenden",
    "Resend invite item success": "Uitnodiging succesvol opnieuw verzonden.",
    "ResendInvite item": "Uitnodigen",
    "Reset mfa": "herstellen",
    "Reset password": "Wachtwoord opnieuw instellen",
    "Reset password item fail": "Wachtwoord opnieuw instellen mislukt.",
    "Reset password item success": "Wachtwoord succesvol opnieuw ingesteld.",
    "ResetMFA": "Herstel MFA",
    "ResetMFA item fail": "Fout bij het herstellen van MFA voor gebruiker.",
    "ResetMFA item success": "MFA succesvol gereset voor gebruiker.",
    "ResetMFA item text": "Weet je zeker dat je MFA voor {0} wilt {1}?",
    "Role": "Rol",
    "Roles": {
      "ADMINISTRATOR": "Beheerder",
      "ATTENDANT": "Begeleider",
      "EMPLOYEE": "Medewerker",
      "LOCATION_COORDINATOR": "Locatie coördinator",
      "MANAGEMENT": "Beheerder",
      "PERSONAL_ATTENDANT": "Persoonlijk begeleider",
      "REPRESENTATIVE": "Vertegenwoordiger",
      "TECHNICAL_SERVICES": "Technische dienst"
    },
    "Roles mandatory": "Er dient tenminste 1 rol te worden toegewezen.",
    "Scan QR code": "Scan de QR-code",
    "Send_invite": "Uitnodiging versturen",
    "Set password": "Wachtwoord instellen",
    "Setup authenticator account": "Authenticator-account instellen",
    "Setup your authenticator account": "Stel je account in",
    "SSO Microsoft": "Login via {0} Microsoft",
    "Tabs": {
      "General": "Algemeen",
      "Roles": "Roltoewijzingen"
    },
    "Trust MFA device": "Vertrouw dit apparaat voor 14 dagen",
    "Trust MFA device info": "Standaard blijft je account één dag automatisch ingelogd. Als je ervoor kiest om dit apparaat te vertrouwen, blijft je account 30 dagen automatisch ingelogd. Wanneer je handmatig uitlogt, zal er altijd opnieuw om verificatie worden gevraagd.",
    "Upload ID": "Upload ID",
    "Upload insurance": "Upload verzekering",
    "Use Authenticator app to scan QR code": "Gebruik de Authenticator-app om de QR-code te scannen. Hiermee wordt de Authenticator-app verbonden met je account.",
    "Verify": "Verifiëren",
    "Verify code": "Controleer de code.",
    "Verify MFA": "Code verifiëren",
    "Verify MFA text": "Bevestig je login door de code in te voeren die wordt weergegeven in de Authenticator-app op je apparaat.",
    "Verify token invalid": "De link is ongeldig of verlopen."
  },
  "User_role": {
    "Delete item": "Roltoewijzing verwijderen",
    "Delete item fail": "Fout bij het verwijderen van de roltoewijzing.",
    "Delete item success": "Roltoewijzing succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de roltoewijzing wilt {1}?",
    "Edit item": "Roltoewijzing bewerken",
    "Edit item fail": "Fout bij wijzigen van de roltoewijzing.",
    "Edit item success": "Roltoewijzing succesvol gewijzigd.",
    "Error loading data": "De lijst met roltoewijzingen kon niet worden geladen.",
    "New item": "Nieuwe roltoewijzing",
    "New item fail": "Fout bij het maken van de roltoewijzing.",
    "New item success": "Roltoewijzing succesvol toegevoegd.",
    "Role": "Rol",
    "User": "Medewerker"
  },
  "Vecozo_toegewezen_zorg_zwaarte_pakket": {
    "ShowSuperseded": "Vervangen toewijzingen"
  },
  "Vecozo_message": {
    "Soort": "Soort toewijzing",
    "Toewijzing_instelling": "Aanvraag instelling",
    "Toewijzing_percentage": "Toewijzingspercentage",
    "Toewijzing_ingangsdatum": "Toewijzing ingangsdatum",
    "Toewijzing_einddatum": "Toewijzing einddatum",
    "Opname": "Opname",
    "Address": "Straat",
    "Active": "Actief",
    "Expired": "Verlopen",
    "Afgiftedatum": "Afgiftedatum",
    "Assigned date": "Toewijzigsdatum",
    "Assigned percentage": "Toewijzigspercentage",
    "Assigned time": "Toewijzigstijdstip",
    "AW35 needed": "AW35 nodig",
    "Approval inherited": "Overgenomen",
    "AW35Statuses": {
      "Approved": "Melding goedgekeurd",
      "Downloaded": "Afwachting reactie Vecozo",
      "Rejected": "Melding afgewezen - Klik om het retourbericht te openen en de fouten te bekijken",
      "Unknown": "Melding aangemaakt"
    },
    "AanvraagInstellingen": "Toewijzingen",
    "AddToewijzing": "Toewijzing toevoegen",
    "RemoveToewijzing": "Toewijzing verwijderen",
    "Show current and superseded": "Huidige en vervangen toewijzingen tonen",
    "Show current only": "Alleen huidige toewijzingen tonen",
    "Superseded": "Vervangen",
    "Toewijzing": "Toewijzing",
    "AW39Types": {
      "SelectType": "Selecteer berichttype",
      "Mutation": "Mutatie",
      "AAT": "AAT (Aanvraag Alternatieve Toewijzing)"
    },
    "BerichtTypes": {
      "AW33": "Toewijzing zorg (AW33)",
      "AW34": "Retour - Toewijzing zorg (AW34)",
      "AW35": "Melding aanvang Wlz-zorg (AW35)",
      "AW35_RECALL": "Intrekken melding aanvang Wlz-zorg (AW35)",
      "AW36": "Retour - Melding aanvang Wlz-zorg (AW36)",
      "AW39": "Beëindiging/mutatie Wlz-zorg (AW39)",
      "AW39_RECALL": "Intrekken beëindiging/mutatie Wlz-zorg (AW39)",
      "AW310": "Retour - Beëindiging/mutatie Wlz-zorg (AW310)",
      "AW317": "Wachtlijstbericht (AW317)",
      "AW318": "Retour - Wachtlijstbericht (AW318)",
      "AW319": "Declaratiebericht (AW319)",
      "AW320": "Retour - Declaratiebericht (AW320)",
      "CA317": "Aanvang zorg CAK (CA317)",
      "CA318": "Retour - Aanvang zorg CAK (CA318)",
      "CA319": "Mutatie zorg CAK (CA319)",
      "CA320": "Retour - Mutatie zorg CAK (CA320)",
      "ZK31": "Dossieroverdracht cliënt ZK-ZK (ZK31)",
      "ZK32": "Retour - Dossieroverdracht cliënt ZK-ZK (ZK32)",
      "ZK33": "Toewijzing zorg ZK-ZK (ZK33)",
      "ZK34": "Retour - Toewijzing zorg ZK-ZK (ZK34)",
      "ZK35": "Aanvang zorg ZK-ZK (ZK35)",
      "ZK36": "Retour - Aanvang zorg ZK-ZK (ZK36)",
      "ZK39": "Mutatie zorg ZK-ZK (ZK39)",
      "ZK310": "Retour - Mutatie zorg ZK-ZK (ZK310)"
    },
    "Besluitnummer": "Besluitnummer",
    "Bsn": "BSN-nummer",
    "Cancel Melding aanvang zorg (AW35)": "Melding aanvang zorg intrekken (AW35)",
    "Cancel mutatie zorg (AW39)": "Melding mutatie/beëindiging zorg intrekken (AW39)",
    "Cancel request": "Aanvraag intrekken",
    "Category": "Categorie",
    "City": "Plaatsnaam",
    "Client": {
      "Beperking": "Beperking | Beperkingen",
      "Beperkingen": {
        "1": "Sociale redzaamheid (1)",
        "2": "Mobiliteit (2)",
        "3": "Persoonlijke zorg (3)",
        "4": "Huishoudelijk leven (4)",
        "5": "Sociale relaties en maatschappelijk leven (5)",
        "6": "Deelname aan leren, werken (6)"
      },
      "BeperkingScore": "Beperkingsscore",
      "BurgerlijkeStaatOptions": {
        "1": "Ongehuwd (1)",
        "2": "Gehuwd (2)",
        "3": "Gescheiden (3)",
        "4": "Verweduwd (4)",
        "5": "Geregistreerd partner (5)",
        "6": "Gescheiden geregistreerd partner (6)",
        "7": "Achtergebleven geregistreerd partner (7)",
        "9": "Ongehuwd geen geregistreerd partner (9)"
      },
      "Client": "{Bsn}",
      "Contact": "Contact | Contacten",
      "FinancieringOptions": {
        "1": "Wlz (1)",
        "2": "Wlz, voorheen Wlz-indiceerbaar (2)",
        "3": "Subsidieregeling (3)",
        "4": "Anders (4)"
      },
      "GeindiceerdeZorgzwaartePakketten": "Geïndiceerde zorgzwaartepakketten",
      "GeslachtOptions": ["Onbekend / niet opgegeven", "Man", "Vrouw"],
      "Indication": "Indicatie",
      "LeefeenheidOptions": {
        "1": "Woont alleen en zelfstandig (eenpersoonshuishouden) (1)",
        "2": "Woont als kind samen met ouder(s) in ouderlijk huis (2)",
        "3": "Heeft een zelfstandig huishouden met uitsluitend partner (3)",
        "4": "Heeft een huishouden met partner en thuiswonende kinderen (4)",
        "5": "Heeft een huishouden van volwassene met 1 of meer kinderen (5)",
        "6": "Een ander meerpersoonshuishouden (6)",
        "7": "Woont in een zorginstelling met verblijf (7)",
        "9": "Onbekend (9)"
      },
      "LeveringsstatusOptions": {
        "1": "Actief wachtend (1)",
        "2": "Wacht op voorkeur (2)",
        "3": "Wacht uit voorzorg (3)",
        "4": "In zorg (4)",
        "5": "Einde zorgvraag (5)",
        "6": "Urgent plaatsen (6)",
        "7": "Actief plaatsen (7)"
      },
      "LeveringsvormOptions": {
        "2": "Persoonsgebonden budget (PGB) (2)",
        "4": "Verblijf (4)",
        "5": "Volledig pakket thuis (VPT) (5)",
        "7": "Modulair Pakket Thuis (MPT) (7)",
        "8": "Deeltijdverblijf (DTV) (8)",
        "9": "Verkeerde bed (VKB) (9)"
      },
      "MutatiecodeOptions": {
        "12": "Client wil nu de zorg of ondersteuning (nog) niet (12)",
        "17": "Overplaatsing (er is een melding aanvang zorg of ondersteuning) (17)",
        "18": "Aanbieder kan nu de zorg of ondersteuning nog niet leveren (18)",
        "19": "Levering zorg of ondersteuning is beëindigd - toewijzing sluiten (19)",
        "20": "Levering zorg of ondersteuning is beëindigd - toewijzing aanhouden (20)",
        "21": "Overdracht toewijzing (er is geen melding aanvang zorg of ondersteuning) (21)"
      },
      "NaamgebruikOptions": {
        "1": "Eigen naam (1)",
        "2": "Naam echtgenoot of geregistreerd partner of alternatieve naam (2)",
        "3": "Naam echtgenoot of geregistreerd partner gevolgd door eigen naam (3)",
        "4": "Eigen naam gevolgd door naam echtgenoot of geregistreerd partner (4)",
        "5": "Pseudoniem (5)",
        "6": "Niet-natuurlijk persoon (6)"
      },
      "Relatie": "Relatie | Relaties",
      "ScoreBeperkingen": {
        "0": "Kan deze activiteit zelf, er is geen hulp van een ander nodig (0)",
        "1": "Kan het zelf, maar iemand anders moet toezien of stimuleren (1)",
        "2": "Kan dit slechts met veel moeite/iemand anders moet helpen (2)",
        "3": "Kan dit niet zelfstandig/iemand anders moet dit overnemen (3)",
        "9": "Niet beoordeeld (9)"
      },
      "SoortIndicatieContactOptions": {
        "01": "BRP-adres (01)",
        "02": "Correspondentie adres (02)",
        "03": "Verblijfadres (03)",
        "04": "Tijdelijk verblijfadres (04)"
      },
      "SoortIndicatieOptions": {
        "1": "CIZ indicatie (1)",
        "2": "BJZ indicatie (2)",
        "3": "CIZ/BJZ indicatie (3)",
        "4": "Experimenten (4)"
      },
      "SoortRelatieOptions": {
        "10": "Ouder (10)",
        "11": "Voogd (11)",
        "12": "Partner/echtgeno(o)t(e) (12)",
        "13": "Pleegouder (13)",
        "14": "Bewindvoerder (14)",
        "15": "Mentor (15)",
        "16": "Zoon/dochter (16)",
        "17": "Familielid (17)",
        "18": "Gezinslid (18)",
        "19": "Buur (19)",
        "20": "Vriend(in)/kennis (20)",
        "21": "Cliëntondersteuner (21)",
        "22": "Huisarts (22)",
        "23": "Erven van (23)",
        "24": "Werkgever (24)",
        "25": "Wijkcoach (25)",
        "03": "Curator (juridisch) (03)",
        "04": "Financieel (gemachtigd) (04)",
        "05": "Financieel (toetsing) (05)",
        "06": "Leefeenheid (06)",
        "07": "Hulpverlener (07)",
        "08": "Specialist (08)",
        "09": "Anders (09)"
      },
      "SoortToewijzingOptions": {
        "1": "Regulier (1)",
        "3": "Overbrugging (3)",
        "5": "Administratief (5)"
      },
      "StatusAanleveringOptions": {
        "1": "Eerste aanlevering (1)",
        "2": "Gewijzigde aanlevering (2)",
        "3": "Verwijderen aanlevering (3)",
        "9": "Niet van toepassing (ongewijzigd) (9)"
      },
      "Stoornis": "Stoornis | Stoornissen",
      "StoornisScore": "Stoornis score | Stoornis scores",
      "Stoornissen": {
        "COD923": {
          "10": "Ziekten van ademhalingsstelsel (10)",
          "11": "Ziekten van spijsverteringsstelsel (11)",
          "12": "Ziekten van huid en subcutis (12)",
          "13": "Ziekten van botspierweefsel en bindweefsel (13)",
          "14": "Ziekten van urogenitaal stelsel (14)",
          "15": "Zwangerschap, bevalling en kraambed (15)",
          "16": "Aandoeningen met oorsprong in perinatale periode (16)",
          "17": "Congenitale afw, misvormingen en chromos. afw. (17)",
          "18": "Overige symptomen, bevindingen, uitslagen (18)",
          "19": "Letsel en gevolgen van uitwendige oorzaken (19)",
          "20": "Uitwendige oorzaken van ziekte en sterfte (20)",
          "21": "Gezondheidstoestand beïnvloedende factoren (21)",
          "01": "Bep. infectieziekten en parasitaire aandoeningen (01)",
          "02": "Nieuwvormingen (= tumoren) (02)",
          "03": "Ziekten van bloed en immuunsysteem (03)",
          "04": "Endocriene ziekten en voedings/stofw.stoornissen (04)",
          "05": "Psychische stoornissen en gedragsstoornissen (05)",
          "06": "Ziekten van zenuwstelsel (06)",
          "07": "Ziekten van oog en adnexen (07)",
          "08": "Ziekten van oor en processus mastoideus (08)",
          "09": "Ziekten van hart en vaatstelsel (09)"
        },
        "COD924": {
          "b117_0": "Laag begaafd/ moeilijk lerend (b117.0)",
          "b117_1": "Lichte verstandelijke beperking/ zeer moeilijk lerend (b117.1)",
          "b117_2": "Matige verstandelijke beperking (b117.2)",
          "b117_3": "Ernstige verstandelijke beperking (b117.3)",
          "b117_4": "Zeer ernstige verstandelijke beperking (b117.4)",
          "b117_9": "Niet gespecificeerd (b117.9)"
        },
        "COD925": {
          "b110": "Bewustzijn (b110)",
          "b114": "Oriëntatie (b114)",
          "b117": "Intellectuele functies (b117)",
          "b122": "Globale psychosociale functies (b122)",
          "b126": "Temperament en persoonlijkheid (b126)",
          "b130": "Energie en driften (b130)",
          "b134": "Slaap (b134)",
          "b139": "Algemene mentale functies (niet gespecificeerd) (b139)",
          "b140": "Aandacht (b140)",
          "b144": "Geheugen (b144)",
          "b147": "Psychomotorische functies (b147)",
          "b152": "Stemming (b152)",
          "b156": "Perceptie (b156)",
          "b160": "Denken (b160)",
          "b164": "Hogere cognitieve functies (b164)",
          "b199": "Mentale functies (niet gespecificeerd) (b199)",
          "b210": "Visuele functies (b210)",
          "b215": "Functies van aan oog verwante structuren (b215)",
          "b220": "Gewaarwordingen van oog en aanverwanten (b220)",
          "b229": "Visuele en verwante functies (niet gespecificeerd) (b229)",
          "b230": "Hoorfuncties (b230)",
          "b235": "Vestibulaire functies (b235)",
          "b270": "Sensorische functies (pijn en andere stimuli) (b270)",
          "b310": "Stem (b310)",
          "b320": "Articulatie (b320)",
          "b340": "Alternatieve vormen van stemgebruik (b340)",
          "b410": "Hartfuncties (b410)",
          "b415": "Functies van bloedvaten (b415)",
          "b420": "Bloeddruk (b420)",
          "b430": "Functies van hematologisch systeem (b430)",
          "b435": "Functies van afweersysteem (b435)",
          "b440": "Ademhaling (b440)",
          "b455": "Inspanningstolerantie (b455)",
          "b469": "Andere functies hart/ vaten/ ademhaling (b469)",
          "b510": "Opname van voedsel (b510)",
          "b515": "Vertering (b515)",
          "b525": "Defecatie (b525)",
          "b535": "Gewaarwordingen spijsverteringsstelsel (b535)",
          "b539": "Functies van spijsverteringstelsel (niet gespecificeerd) (b539)",
          "b540": "Algemene metabole functies (b540)",
          "b545": "Water-, mineraal- en elektrolytenbalans (b545)",
          "b550": "Thermoregulatoire functies (b550)",
          "b555": "Functies van endocriene klieren (b555)",
          "b559": "Functies metabool-/ hormoonstelsel (niet gespecificeerd) (b559)",
          "b610": "Productie en opslag van urine (b610)",
          "b620": "Functies gerelateerd aan urinelozing (b620)",
          "b639": "Functies gerelateerd aan urine (niet gespecificeerd) (b639)",
          "b679": "Genitale en reproductieve functies (b679)",
          "b710": "Mobiliteit van gewrichten (b710)",
          "b715": "Stabiliteit van gewrichten (b715)",
          "b729": "Functies van gewrichten en botten (b729)",
          "b749": "Spierfuncties (b749)",
          "b750": "Motorische reflexfuncties (b750)",
          "b755": "Onwillekeurige bewegingsreacties (b755)",
          "b760": "Controle van willekeurige bewegingen (b760)",
          "b765": "Onwillekeurige bewegingen (b765)",
          "b789": "Bewegingsfuncties (niet gespecificeerd) (b789)",
          "b849": "Functies van huid (b849)",
          "b869": "Functies van haren en nagels (b869)"
        },
        "COD926": {
          "b210_1": "Lichte visusbeperking (b210.1)",
          "b210_2": "Matige visusbeperking (b210.2)",
          "b210_3": "(Zeer) ernstige visusbeperking (b210.3)",
          "b210_4": "(Functionele) blindheid (b210.4)",
          "b210_9": "Niet gespecificeerd (b210.9)"
        },
        "COD927": {
          "b230_1": "Lichte gehoorbeperking (b230.1)",
          "b230_2": "Matige gehoorbeperking (b230.2)",
          "b230_3": "(Zeer) ernstige gehoorbeperking (b230.3)",
          "b230_4": "(Volledige) doofheid (b230.4)",
          "b230_9": "Niet gespecificeerd (b230.9)"
        },
        "DiagnoseCodelijstMappingStoornissen": {
          "014": "COD923",
          "019": "COD923",
          "021": "COD925",
          "022": "COD924",
          "023": "COD926",
          "024": "COD927"
        },
        "DiagnoseCodelijstOptions": {
          "014": "Classificatie van ziekten (ZIN/ICD-10) (014)",
          "019": "Diagnostic and statistical manual of mental disorders IV (DSM-IV) (019)",
          "021": "Internationale classificatie van functioneren (ICF) (021)",
          "022": "IQ (022)",
          "023": "Visueel (023)",
          "024": "Auditief (024)"
        },
        "DiagnoseSubcodelijstOptions": {
          "10": "As IV (10)",
          "11": "As V (11)",
          "12": "Visueel (12)",
          "13": "Auditief (13)",
          "01": "Mentaal (01)",
          "02": "Zintuiglijk (02)",
          "03": "Fysiek (03)",
          "04": "1e aandoening (04)",
          "05": "2e aandoening (05)",
          "06": "3e aandoening (06)",
          "07": "As I (07)",
          "08": "As II (08)",
          "09": "As III (09)"
        },
        "GrondslagOptions": {
          "01": "Somatische ziekte/aandoening (01)",
          "02": "Psychogeriatrische ziekte/aandoening (02)",
          "03": "Psychiatrische aandoening, psychische stoornis (03)",
          "04": "Lichamelijke handicap (functiestoornis) (04)",
          "05": "Verstandelijke handicap (functiestoornis) (05)",
          "06": "Zintuiglijke handicap (functiestoornis) (06)",
          "07": "Psychosociale problemen (07)"
        },
        "PrognoseOptions": {
          "1": "Uitzicht op volledig herstel binnen 1 jaar (1)",
          "2": "Uitzicht op gedeeltelijk herstel/verbetering binnen 1 jaar (2)",
          "3": "De gezondheidstoestand blijft hetzelfde (3)",
          "4": "Er wordt een verslechtering verwacht binnen 1 jaar (4)",
          "5": "Onbekend; prognose niet beschikbaar of niet mogelijk (5)"
        },
        "ScoreStoornissen": {
          "0": "Geen probleem/geen hulp van anderen nodig (0)",
          "1": "Wel probleem: af en toe hulp, toezicht of sturing nodig (1)",
          "2": "Wel probleem: vaak hulp, toezicht of sturing nodig (2)",
          "3": "Wel probleem: continu hulp, toezicht of sturing nodig (3)",
          "9": "Niet beoordeeld (9)"
        },
        "VraagStoornissen": {
          "0101": "Orientatiestoornis - Orientatie in tijd: weten welke dag het is, etc. (0101)",
          "0102": "Orientatiestoornis - Orientatie naar plaats: weten waar je bent (0102)",
          "0103": "Orientatiestoornis - Orientatie in ruimte: de weg vinden in huis, en omgeving (0103)",
          "0104": "Orientatiestoornis - Orientatie in persoon: weten wie je bent, wie anderen zijn (0104)",
          "0201": "Psychosociale functies - Concentratie (0201)",
          "0202": "Psychosociale functies - Geheugen en denken (0202)",
          "0203": "Psychosociale functies - Perceptie van omgeving (-vertekende) (0203)",
          "0204": "Psychosociale functies - Motivatie (lusteloos, geen initiatief) (0204)",
          "0301": "Motorisch functioneren - Gebruik van rechterarm, linkerarm (0301)",
          "0302": "Motorisch functioneren - Gebruik van rechterhand, linkerhand (0302)",
          "0303": "Motorisch functioneren - Gebruik van rechterbeen, linkerbeen (0303)",
          "0304": "Motorisch functioneren - Gebruik van rechtervoet, linkervoet (0304)",
          "0305": "Motorisch functioneren - Handhaving hoofdbalans (0305)",
          "0306": "Motorisch functioneren - Handhaving rompbalans (0306)",
          "0401": "Probleemgedrag/veiligheid - Zelfverwondend of zelfbeschadigend gedrag (0401)",
          "0402": "Probleemgedrag/veiligheid - Verbaal agressief gedrag (0402)",
          "0403": "Probleemgedrag/veiligheid - Lichamelijk agressief gedrag (0403)",
          "0404": "Probleemgedrag/veiligheid - Destructief gedrag (vernielen, brandstichten, stelen) (0404)",
          "0405": "Probleemgedrag/veiligheid - Manipulatief gedrag (dwarsliggen, negeren, weglopen) (0405)",
          "0406": "Probleemgedrag/veiligheid - Dwangmatig gedrag (niet willen spreken, eten, bewegen) (0406)",
          "0407": "Probleemgedrag/veiligheid - Grensoverschrijdend seksueel gedrag (0407)",
          "0501": "Verslavingsproblemen - Gebruik van softdrugs (0501)",
          "0502": "Verslavingsproblemen - Gebruik van harddrugs (0502)",
          "0503": "Verslavingsproblemen - Gebruik van alcohol (0503)",
          "0504": "Verslavingsproblemen - Verslavingsproblemen anders (0504)",
          "0601": "Psychosociaal welbevinden - Angstig zijn (0601)",
          "0602": "Psychosociaal welbevinden - Moedeloos zijn (“depressief”) (0602)",
          "0603": "Psychosociaal welbevinden - Belangstelling en betrokkenheid (0603)",
          "0604": "Psychosociaal welbevinden - Gemis van persoonlijke relaties (0604)",
          "0605": "Psychosociaal welbevinden - Gemis van gewaardeerde sociale rollen (0605)"
        }
      },
      "ToegewezenZorgzwaartePakketten": "Toegewezen zorgzwaartepakketten",
      "VoorkeurClientOptions": {
        "2": "Persoonsgebonden budget (PGB) (2)",
        "3": "Zorg thuis (niet nader gespecificeerd) (3)",
        "4": "Verblijf (4)",
        "5": "Volledig pakket thuis (VPT) (5)",
        "6": "Combinatie PGB/MPT (6)",
        "7": "Modulair pakket thuis (MPT) (7)",
        "8": "combinatie VPT/PGB (8)",
        "9": "combinatie Verblijf/PGB (9)",
        "10": "Deeltijdverblijf (DTV) (10)"
      },
      "VraagBeperkingen": {
        "0101": "Sociale redzaamheid - Problemen oplossen, besluiten nemen en gevolgen inschatten (101)",
        "0102": "Sociale redzaamheid - Initieren + uitvoeren van eenvoudige taken (bv. eten maken, de was doen) (102)",
        "0103": "Sociale redzaamheid - Initieren + uitvoeren van complexere taken (bv. werkritme) (103)",
        "0104": "Sociale redzaamheid - Dagelijkse routine regelen: structuur in dagindeling (104)",
        "0105": "Sociale redzaamheid - Dagelijkse bezigheden: activiteiten plannen/uitvoeren (105)",
        "0106": "Sociale redzaamheid - Kunnen lezen, schrijven en rekenen (106)",
        "0107": "Sociale redzaamheid - Zelf geld beheren, weten hoe je iets koopt en betaalt (107)",
        "0108": "Sociale redzaamheid - Zelf allerlei administratieve zaken afhandelen (108)",
        "0109": "Sociale redzaamheid - Zich redden bij het gebruik van openbaar vervoer (109)",
        "0110": "Sociale redzaamheid - Zich redden in winkels, postkantoor, bank, etc. (110)",
        "0111": "Sociale redzaamheid - Communicatie: begrijpen wat anderen zeggen (111)",
        "0112": "Sociale redzaamheid - Communicatie: zich begrijpelijk maken naar anderen (112)",
        "0113": "Sociale redzaamheid - Communicatie: een gesprek voeren (113)",
        "0114": "Sociale redzaamheid - Hulpmiddelen voor communicatie gebruiken (telefoon, computer, etc.) (114)",
        "0201": "Mobiliteit - Lichaamspositie veranderen (opstaan uit stoel, knielen en opstaan) (201)",
        "0202": "Mobiliteit - Lichaamspositie handhaven (rechtop staan; in stoel zitten) (202)",
        "0203": "Mobiliteit - Lichtere voorwerpen tillen en dragen (bijv. kopje oppakken) (203)",
        "0204": "Mobiliteit - Zwaardere voorwerpen tillen en dragen (bijv. kind in bed leggen) (204)",
        "0205": "Mobiliteit - Gecoordinerede bewegingen met benen/voeten maken (bijv. fietsen) (205)",
        "0206": "Mobiliteit - Fijne handbewegingen maken (bijv. geld tellen, toetsen indrukken) (206)",
        "0207": "Mobiliteit - Grove hand- en armbewegingen maken (duwen, trekken, vangen) (207)",
        "0208": "Mobiliteit - Zich voortbewegen binnenshuis, zonder hulp of hulpmiddelen (208)",
        "0209": "Mobiliteit - Trap op en af gaan, zonder hulp of hulpmiddelen (209)",
        "0210": "Mobiliteit - Korte afstanden lopen: ten hoogste kilometer (210)",
        "0211": "Mobiliteit - Zich verplaatsen buitenshuis (> kilometer) zonder hulp/hulpmiddelen (211)",
        "0212": "Mobiliteit - Zich verplaatsen met gebruik van hulpmiddelen (rollator, rolstoel, etc.) (212)",
        "0213": "Mobiliteit - Een eigen vervoermiddel gebruiken (fiets, auto) (213)",
        "0214": "Mobiliteit - Gebruik maken van openbaar vervoer (trein, bus) (214)",
        "0301": "Persoonlijke zorg - Zich wassen: delen van lichaam of gehele lichaam (301)",
        "0302": "Persoonlijke zorg - Zich kleden: aankleden en uitkelden (302)",
        "0303": "Persoonlijke zorg - In en uit bed gaan (303)",
        "0304": "Persoonlijke zorg - Zich verplaatsen in zit- of lighouding (304)",
        "0305": "Persoonlijke zorg - Naar toilet gaan en zich reinigen (305)",
        "0306": "Persoonlijke zorg - Eten en drinken (306)",
        "0307": "Persoonlijke zorg - Persoonlijke zorg voor tanden, haren, nagels, huid (307)",
        "0308": "Persoonlijke zorg - Zelf aanbrengen van een prothese (308)",
        "0309": "Persoonlijke zorg - Voor eigen gezondheid zorgen (gezonde voeding etc.) (309)",
        "0401": "Huishoudelijk leven - Boodschappen voor het dagelijks leven doen (401)",
        "0402": "Huishoudelijk leven - Maaltijden bereiden: broodmaaltijd (402)",
        "0403": "Huishoudelijk leven - Maaltijden bereiden: warme maaltijd (403)",
        "0404": "Huishoudelijk leven - Licht poetswerk in huis; kamers opruimen (404)",
        "0405": "Huishoudelijk leven - Huis schoonmaken, stofzuigen, wc/badkamer reinigen (405)",
        "0406": "Huishoudelijk leven - Kleding/linnengoed wassen (“de was doen”) (406)",
        "0407": "Huishoudelijk leven - Huishoudelijke apparaten gebruiken (wasmachine, stofzuiger, strijkijzer) (407)",
        "0408": "Huishoudelijk leven - Huishoudelijke spullen in orde houden (kleding, planten, apparaten) (408)",
        "0409": "Huishoudelijk leven - Anderen in huishouden helpen met zelfverzorging (409)",
        "0410": "Huishoudelijk leven - Anderen helpen bij bereiden maaltijden, eten, etc. (410)",
        "0411": "Huishoudelijk leven - Dagelijkse organisatie van het huishouden (411)",
        "0501": "Sociale relaties en maatschappelijk leven - Relaties met familie onderhouden (501)",
        "0502": "Sociale relaties en maatschappelijk leven - Zelfstandig met anderen contacten opbouwen (502)",
        "0503": "Sociale relaties en maatschappelijk leven - Zelfstandig met anderen (vrienden) contacten onderhouden (503)",
        "0504": "Sociale relaties en maatschappelijk leven - Zelfstandig aan clubs en verenigingen deelnemen (504)",
        "0505": "Sociale relaties en maatschappelijk leven - Vrijetijdsbesteding buitenshuis: naar sport, theater, café, etc. (505)",
        "0506": "Sociale relaties en maatschappelijk leven - Zelfstandig naar algemene voorzieningen gaan (zoals winkels, bibliotheek) (506)",
        "0601": "Deelname onderwijs, werk - Deelname aan gewone kinderopvang (601)",
        "0602": "Deelname onderwijs, werk - School volgen binnen het gewoon onderwijs (602)",
        "0603": "Deelname onderwijs, werk - School volgen binnen het speciaal onderwijs (603)",
        "0604": "Deelname onderwijs, werk - Meedoen aan naschoolse of buitenschoolse opvang (604)",
        "0605": "Deelname onderwijs, werk - OUDERS van vrager: opvoeden van kind (ontwikkelen van vaardigheden) (605)",
        "0606": "Deelname onderwijs, werk - OUDERS van vrager: dagelijkse structuur bieden aan het opgroeiende kind (606)",
        "0607": "Deelname onderwijs, werk - Een betaalde baan zoeken en krijgen (607)",
        "0608": "Deelname onderwijs, werk - Een dagtaak uitvoeren, een vast werkritme aanhouden (608)",
        "0609": "Deelname onderwijs, werk - Betaald werk doen: voltijds (609)",
        "0610": "Deelname onderwijs, werk - Betaald werk doen: deeltijd (610)",
        "0611": "Deelname onderwijs, werk - Niet-betaald werk doen in vrijwillige verbanden (611)"
      },
      "ZorgkantoorOptions": {
        "5501": "Zorgkantoor Groningen (5501)",
        "5502": "Zorgkantoor Friesland (5502)",
        "5503": "Zorgkantoor Drenthe (5503)",
        "5504": "Zorgkantoor Zwolle (5504)",
        "5505": "Zorgkantoor Twente (5505)",
        "5506": "Zorgkantoor Apeldoorn, Zutphen en omstreken (5506)",
        "5507": "Zorgkantoor Arnhem (5507)",
        "5508": "Zorgkantoor Nijmegen (5508)",
        "5509": "Zorgkantoor Utrecht (5509)",
        "5510": "Zorgkantoor Flevoland (5510)",
        "5511": "Zorgkantoor ’t Gooi (5511)",
        "5512": "Zorgkantoor Noord Holland Noord (5512)",
        "5513": "Zorgkantoor Kennemerland (5513)",
        "5514": "Zorgkantoor Zaanstreek/Waterland (5514)",
        "5515": "Zorgkantoor Amsterdam (5515)",
        "5516": "Zorgkantoor Amstelland en De Meerlanden (5516)",
        "5517": "Zorgkantoor Zuid-Holland Noord (5517)",
        "5518": "Zorgkantoor Haaglanden (5518)",
        "5519": "Zorgkantoor Delft Westland Oostland (5519)",
        "5520": "Zorgkantoor Midden-Holland (5520)",
        "5521": "Zorgkantoor Rotterdam (5521)",
        "5523": "Zorgkantoor Zuid-Hollandse Eilanden (5523)",
        "5524": "Zorgkantoor Waardenland (5524)",
        "5525": "Zorgkantoor Zeeland (5525)",
        "5526": "Zorgkantoor West-Brabant (5526)",
        "5527": "Zorgkantoor Midden-Brabant (5527)",
        "5528": "Zorgkantoor Noordoost Brabant (5528)",
        "5529": "Zorgkantoor Zuidoost-Brabant (5529)",
        "5530": "Zorgkantoor Noord- en Midden Limburg (5530)",
        "5531": "Zorgkantoor Zuid-Limburg (5531)",
        "5532": "Zorgkantoor Midden-IJssel (5532)",
        "5533": "Zorgkantoor Friesland (5533)"
      },
      "ZzpOptions": {
        "190": "9VV A: Geriatrische revalidatiezorg (190)",
        "191": "9VV B: Herstelgerichte behandeling met verpleging en verzorging (191)",
        "750": "1VV: Beschut wonen met enige begeleiding (750)",
        "751": "2VV: Beschut wonen met begeleiding en verzorging (751)",
        "752": "3VV: Beschut wonen met begeleiding en intensieve verzorging (752)",
        "753": "4VV: Beschut wonen met intensieve begeleiding en uitgebreide verzorging (753)",
        "754": "5VV: Beschermd wonen met intensieve dementiezorg (754)",
        "755": "6VV: Beschermd wonen met intensieve verzorging en verpleging (755)",
        "756": "7VV: Beschermd wonen met zeer intensieve zorg, vanwege specifieke aandoeningen, met nadruk op begeleiding (756)",
        "757": "8VV: Beschermd wonen met zeer intensieve zorg, vanwege specifieke aandoeningen, met de nadruk op verzorging/verpleging (757)",
        "758": "9VV: Herstelgerichte behandeling met verpleging en verzorging (758)",
        "759": "10VV: Beschermd verblijf met intensieve palliatief-terminale zorg (759)",
        "760": "1GGZ C: Beschermd wonen met begeleiding (760)",
        "762": "2GGZ C: Gestructureerd beschermd wonen met uitgebreide begeleiding (762)",
        "764": "3GGZ C: Beschermd wonen met intensieve begeleiding (764)",
        "766": "4GGZ B: Voortgezet verblijf met intensieve begeleiding en verzorging (766)",
        "768": "5GGZ B: Voortgezet verblijf met intensieve begeleiding en gedragsregulering (768)",
        "770": "6GGZ B: Voortgezet verblijf met intensieve begeleiding en intensieve verpleging en verzorging (770)",
        "772": "7GGZ B: Beveiligd voortgezet verblijf vanwege extreme gedragsproblematiek met zeer intensieve begeleiding (772)",
        "780": "1LVG: Wonen met enige behandeling en begeleiding (780)",
        "781": "2LVG: Wonen met behandeling en begeleiding (781)",
        "782": "3LVG: Wonen met intensieve behandeling en begeleiding, kleine groep (782)",
        "783": "4LVG: Wonen met zeer intensieve behandeling en begeleiding (783)",
        "784": "5LVG: Besloten wonen met zeer intensieve behandeling en begeleiding (784)",
        "790": "1SGLVG: Behandeling in een SGLVG-behandelcentrum (790)",
        "800": "1VG: Wonen met enige begeleiding (800)",
        "802": "2VG: Wonen met begeleiding (802)",
        "804": "3VG: Wonen met begeleiding en verzorging (804)",
        "806": "4VG: Wonen met begeleiding en intensieve verzorging (806)",
        "808": "5VG: Wonen met intensieve begeleiding en intensieve verzorging (808)",
        "810": "6VG: Wonen met intensieve begeleiding, verzorging en gedragsregulering (810)",
        "812": "7VG: (Besloten) wonen met zeer intensieve begeleiding, verzorging en gedragsregulering (812)",
        "814": "8VG: Wonen met begeleiding en volledige verzorging en verpleging (814)",
        "820": "1LG: Wonen met enige begeleiding en enige verzorging (820)",
        "822": "2LG: Wonen met begeleiding en enige verzorging (822)",
        "824": "3LG: Wonen met enige begeleiding en verzorging (824)",
        "826": "4LG: Wonen met begeleiding en verzorging (826)",
        "828": "5LG: Wonen met begeleiding en intensieve verzorging (828)",
        "830": "6LG: Wonen met intensieve begeleiding en intensieve verzorging (830)",
        "832": "7LG: Wonen met zeer intensieve begeleiding en zeer intensieve verzorging (832)",
        "840": "1ZGvis: Wonen met enige begeleiding en enige verzorging (840)",
        "842": "2ZGvis: Wonen met begeleiding en enige verzorging (842)",
        "844": "3ZGvis: Wonen met intensieve begeleiding en verzorging (844)",
        "846": "4ZGvis: Wonen met intensieve begeleiding en intensieve verzorging (846)",
        "848": "5ZGvis: Wonen met zeer intensieve begeleiding en zeer intensieve verzorging (848)",
        "850": "1ZGaud: Wonen met begeleiding en enige verzorging (850)",
        "852": "2ZGaud: Wonen met intensieve begeleiding en verzorging (852)",
        "854": "3ZGaud: Wonen met intensieve begeleiding en intensieve verzorging (854)",
        "856": "4ZGaud: Wonen met intensieve begeleiding en enige verzorging (856)",
        "860": "1GGZ B: Voortgezet verblijf met beleiding (860)",
        "862": "2GGZ B: Voortgezet verblijf met structuur en uitgebreide begeleiding (862)",
        "864": "3GGZ B: Voortgezet verblijf met intensieve begeleiding (864)",
        "866": "4GGZ C: Gestructureerd beschermd wonen met intensieve begeleiding en verzorging (866)",
        "868": "5GGZ C: Beschermd wonen met intensieve begeleiding en gedragsregulering (868)",
        "870": "6GGZ C: Beschermd wonen met intensieve begeleiding en intensieve verpleging en verzorging (870)",
        "880": "1GGZ W: Wonen met intensieve begeleiding (880)",
        "882": "2GGZ W: Wonen met intensieve begeleiding en verzorging (882)",
        "884": "3GGZ W: Wonen met intensieve begeleiding en gedragsregulering (884)",
        "886": "4GGZ W: Wonen met intensieve begeleiding en intensieve verpleging en verzorging (886)",
        "888": "5GGZ W: Beveiligd Wonen vanwege extreme gedragsproblematiek met zeer intensieve begeleiding (888)",
        "996": "Wlz Indiceerbaar (996)",
        "997": "PGB: ZZP-code uitsluitend te gebruiken voor start en stop PGB Wlz-indiceerbaren aan CAK (997)",
        "998": "ZZPX: Onbepaald zorgzwaartepakket (998)",
        "999": "ZZP0: Partnerverblijf (999)"
      }
    },
    "Clients": "Cliënt(en)",
    "Clients processed": {
      "Client successfully added text": "De cliënt {fullName} is succesvol verwerkt.",
      "Clients successfully added text": "De cliënten zijn succesvol verwerkt.",
      "Following steps": {
        "Add attendant": "Een aanspreekpunt wordt toegewezen",
        "Add client care": "De zorg per locatie wordt ingesteld",
        "Add representative": "Een tegenwoordiger wordt toegewezen"
      },
      "Following steps text": "Indien er nieuwe cliënten zijn toegevoegd, is het van belang dat voor alle cliënten de volgende zaken worden ingesteld:"
    },
    "Comments": "Commentaar",
    "Coordinator zorg thuis": "Coordinator zorg thuis",
    "Created": "Aangemaakt",
    "Credit item fail": "Fout bij het crediteren van de prestaties.",
    "Credit item success": "Prestaties succesvol gecrediteerd.",
    "Credit items": "Crediteer prestaties",
    "Date of birth": "Geboortedatum",
    "Delivery type": "Leveringsvorm",
    "Diagnosis": "Diagnose",
    "DiagnosisSubcode": "Diagnose subcode",
    "Dialog confirm cancel message": {
      "Message": "Weet je zeker dat je dit bericht wilt intrekken?",
      "Title": "Bericht intrekken"
    },
    "Dialog confirm create declaration credit": {
      "Message": "Er is een concept gevonden voor deze periode. Wanneer je doorgaat, wordt deze verwijderd. Weet je zeker dat door wilt gaan?",
      "Title": "Credit aanmaken"
    },
    "Dialog confirm open credit message": {
      "Message": "De credit is succesvol aangemaakt. Wil je het bijbehorende AW319 bericht nu openen?",
      "Title": "Succesvol aangemaakt"
    },
    "Dialog confirm open message": {
      "Message": "Het bericht is succesvol geïmporteerd. Wil je het bericht nu openen?",
      "Title": "Succesvol geïmporteerd"
    },
    "Dialog confirm process message": {
      "Conflict message": "Er valt nog {count} aanwezigheidsregistratie na de einddatum van de zorg ({endDate}). Pas deze registratie aan en probeer het daarna opnieuw. | Er vallen nog {count} aanwezigheidsregistraties na de einddatum van de zorg ({endDate}). Pas deze registraties aan en probeer het daarna opnieuw.",
      "Message": "Weet je zeker dat je dit bericht wilt verwerken?",
      "Retry": "Opnieuw proberen",
      "Title": "Bericht verwerken"
    },
    "Direction": "Richting",
    "DirectionOptions": {
      "in": "Inkomend",
      "out": "Uitgaand"
    },
    "Disorder": "Ziektebeeld/Stoornis",
    "Download item fail": "Bericht kon niet worden gedownload.",
    "Download item success": "Bericht succesvol gedownload.",
    "Einddatum": "Einddatum",
    "Errors": {
      "AAT_ONLY_POSSIBLE_FOR_OWN_ZZPS": "AAT is alleen mogelijk voor toegewezen ZZPs.",
      "AT_LEAST_ONE_ASSIGNMENT_REQUIRED": "Er moet minimaal één toewijzing worden opgegeven.",
      "AW33_PROCESSING_FAILED": "De verwerking van het AW33-bericht is mislukt.",
      "AW35_START_AFTER_ASSIGNMENT": "De begindatum van de AW35 ligt na de einddatum van het toegewezen ZZP.",
      "AW35_START_BEFORE_ASSIGNMENT": "De begindatum van de AW35 ligt vóór de ingangsdatum van het toegewezen ZZP.",
      "AW36_CONTAINS_ERRORS": "De melding aanvang zorg is door Vecozo afgewezen. De retourcodes zijn bij het bericht opgeslagen.",
      "AW36_PROCESSING_FAILED": "De verwerking van het AW36-bericht is mislukt.",
      "AW319_PARSE_FAIL": "Het AW319-bericht kon niet worden ingelezen of bevat ongeldige data.",
      "AW320_PROCESSING_FAILED": "De verwerking van het AW320-bericht is mislukt.",
      "AW320_CLIENT_BSN_MISSING": "Een cliëntrecord in de AW320 bevat geen BSN.",
      "AW320_ALREADY_IMPORTED": "Deze AW320 is al geïmporteerd. Gebruik Probeer opnieuw bij het bestaande bericht.",
      "AW320_COMMENT_REFERENCE_MISSING": "Een foutcode in een AW320-commentaarrecord verwijst niet naar een detailrecord.",
      "AW320_CLIENT_SET_MISMATCH": "De AW320 bevat niet alle verwachte cliëntrecords.",
      "AW320_DECLARATION_MISMATCH": "De AW320 hoort niet bij de gevonden declaratie.",
      "AW320_DUPLICATE_CLIENT": "De AW320 bevat een cliëntrecord meer dan één keer.",
      "AW320_DUPLICATE_PERFORMANCE": "De AW320 bevat een prestatiereferentie meer dan één keer.",
      "AW320_INVOICE_NUMBER_MISSING": "De AW320 bevat geen factuurnummer.",
      "AW320_INVALID_STRUCTURE": "De AW320 heeft geen geldige vaste recordstructuur of bevat onjuiste aantallen.",
      "AW320_PERFORMANCE_BSN_MISMATCH": "De BSN bij een prestatie in de AW320 komt niet overeen met de declaratie.",
      "AW320_PERFORMANCE_BSN_MISSING": "Een prestatierecord in de AW320 bevat geen BSN.",
      "AW320_PERFORMANCE_REFERENCE_MISSING": "Een prestatierecord in de AW320 bevat geen referentie.",
      "AW320_PERFORMANCE_SET_MISMATCH": "De AW320 bevat niet alle verwachte prestatierecords.",
      "AW320_UNKNOWN_CLIENT": "De AW320 bevat een cliënt die niet in de declaratie voorkomt.",
      "AW320_UNKNOWN_COMMENT_TARGET": "Een AW320-commentaarrecord verwijst naar een onbekend detailrecord.",
      "AW320_UNKNOWN_PERFORMANCE": "De AW320 bevat een prestatiereferentie die niet in de declaratie voorkomt.",
      "CANNOT_AAT_TO_OWN_AGB": "Toewijzen naar eigen instelling is niet mogelijk.",
      "CANCELLATION_ALREADY_REQUESTED": "Voor dit bericht staat al een intrekkingsbericht open.",
      "CREDIT_DECLARATION_GENERAL_ERROR": "De credit declaratie kon door een technische fout niet worden aangemaakt.",
      "END_DATE_CANNOT_BE_BEFORE_START_DATE": "De einddatum kan niet voor de startdatum liggen.",
      "EXPORT_ONLY_AW319": "Alleen AW319-berichten kunnen worden geëxporteerd.",
      "FAILED_GENERATE_AW35": "Het genereren van het AW35-bericht is mislukt.",
      "FILE_NOT_FOUND": "Het opgegeven bestand kon niet worden gevonden.",
      "FIXED_WIDTH_MESSAGE_NOT_AW320": "Het aangeleverde bestand is geen geldig AW320-bericht.",
      "GENERAL_EXCEPTION": "Er is een onverwachte fout opgetreden tijdens de verwerking.",
      "GENERIC": "Er is een onbekende fout opgetreden.",
      "INVALID_BASE64": "De aangeleverde inhoud is geen geldige Base64-encoded tekst.",
      "MALFORMED_XML": "De XML-structuur is ongeldig of niet goed gevormd.",
      "MESSAGE_HAS_NO_ATTACHMENT": "Het bericht bevat geen bijlage om te verwerken of te exporteren.",
      "MESSAGE_ALREADY_HAS_RESPONSE": "Voor dit bericht is al een retourbericht verwerkt.",
      "MESSAGE_ALREADY_PROCESSED": "Dit bericht is al verwerkt.",
      "MESSAGE_CANNOT_BE_CANCELLED": "Dit bericht kan niet meer worden ingetrokken.",
      "MESSAGE_NOT_LATEST": "Alleen het nieuwste reguliere bericht kan worden ingetrokken.",
      "MIXED_DECLARATION_FOR_CREDIT": "Alle geselecteerde prestaties moeten tot dezelfde declaratie, jaar, maand en periode behoren.",
      "NAMESPACE_MISSING": "De XML mist vereiste namespaces of schema-verwijzingen.",
      "NO_COUNTERPART": "Er is geen gerelateerd bericht gevonden",
      "NO_COUNTERPART_MESSAGE": "Het verwante bericht kon niet worden gevonden.",
      "NO_FILE_PROVIDED": "Er is geen bestand aangeleverd.",
      "NO_MESSAGE_IDENTIFIER": "Het bericht mist een verplicht identificatieveld.",
      "NO_PRESTATIES_FOR_CREDIT": "Er zijn geen prestaties geselecteerd om te crediteren.",
      "Unique": "Er bestaat al een Vecozo-bericht met dit berichttype, deze identifier en richting.",
      "Unique_incoming": "Dit bericht is reeds aanwezig",
      "Unique_outgoing": "Deze aanvraag is reeds aanwezig",
      "UNSUPPORTED_IMPORT_MESSAGE_TYPE": "Het importeren van berichttype '{type}' wordt niet ondersteund.",
      "VECOZO_MESSAGE_WRONG_TYPE": "Het berichttype komt niet overeen met het verwachte Vecozo-berichttype.",
      "XML_INVALID": "De XML is verwerkbaar, maar bevat ongeldige of ontbrekende velden.",
      "XML_SCHEMA_PARSING_FAILED": "Het XSD-schema kon niet worden geladen of verwerkt.",
      "XML_VALIDATION_FAILED": "De XML voldoet niet aan het opgegeven schema."
    },
    "Field": "Soort",
    "File": "Bestand",
    "Financiering type": "Financieringsvorm",
    "First name": "Voornaam",
    "Gender": "Geslacht",
    "Generate Melding aanvang zorg (AW35)": "Genereer Melding aanvang zorg (AW35)",
    "Generate mutatie zorg (AW39)": "Genereer melding mutatie/beëindiging zorg (AW39)",
    "Generate_aw35 item fail": "Melding aanvraag zorg (AW35) kon niet worden aangemaakt.",
    "Generate_aw35 item success": "Melding aanvraag zorg (AW35) succesvol aangemaakt.",
    "Generate_aw39 item fail": "Melding mutatie/beëindiging zorg (AW39) kon niet worden aangemaakt.",
    "Generate_aw39 item success": "Melding mutatie/beëindiging zorg (AW39) succesvol aangemaakt.",
    "Has response": "Reactie",
    "HasResponseOptions": {
      "Cancelled": "Bericht afgewezen of ingetrokken",
      "Created but not exported": "Bericht aangemaakt",
      "Exported": "Bericht geëxporteerd, wachten op reactie Vecozo",
      "Received response": "Reactie van Vecozo ontvangen"
    },
    "House annex": "Huisnummertoevoeging",
    "House letter": "Huisletter",
    "House number": "Huisnummer",
    "Import message": "Bericht importeren",
    "Import message information": "Upload alleen door Vecozo aangeleverde XML-bestanden!",
    "Ingangsdatum": "Ingangsdatum",
    "Initials": "Initialen",
    "Instelling": "Instelling",
    "Instelling_bestemming": "Overplaatsen naar instelling",
    "Last name": "Achternaam",
    "Leveringsstatus": "Leveringsstatus",
    "Leveringsstatus_classificatie": "Leveringsstatus classificatie",
    "MaritalStatus": "Burgerlijke staat",
    "MedicalGrounds": "Grondslag",
    "Message": "Bericht",
    "Message already processed": "Dit bericht is eerder al verwerkt, verwerk berichten alleen opnieuw als je zeker weet dat dit noodzakelijk is!",
    "Message contains errors": "Het bericht bevat de volgende fouten",
    "Rejected return message": {
      "AW36": "De AW36 is verwerkt, maar Vecozo heeft de bijbehorende AW35 afgewezen. Controleer de retourcodes en maak na correctie zo nodig een nieuwe AW35 aan.",
      "AW310": "De AW310 is verwerkt, maar Vecozo heeft de bijbehorende AW39 afgewezen. De aangevraagde wijziging is niet toegepast. Controleer de retourcodes en maak na correctie een nieuwe AW39 aan.",
      "Title": "Retourbericht verwerkt: aanvraag afgewezen"
    },
    "Mutation_code": "Mutatiecode",
    "Mutation_date": "Mutatiedatum",
    "Name": "Naam",
    "New": "Nieuwe gegevens",
    "New item": "Nieuw iWlz bericht",
    "New item fail": "Fout bij het maken van de nieuw iWlz bericht.",
    "New item success": "iWlz bericht succesvol toegevoegd.",
    "Old": "Huidige gegevens",
    "Postal code": "Postcode",
    "Processed": "Verwerkt",
    "Prognosis": "Prognose",
    "Question": "Vraag",
    "RetourCodes": {
      "1156": "Mutatiedatum levering is onjuist. (1156)",
      "1157": "Zorgregel is al afgesloten door een eerder ontvangen MUT (melding einde zorg). (1157)",
      "1160": "De mutatiedatum van de te verwijderen MUT (melding einde zorg) ligt meer dan een jaar in het verleden. (1160)",
      "1161": "De mutatiedatum van de nieuwe MUT (melding einde zorg) valt na de startdatum van de tweede MAZ in een MAZ op MAZ situatie. De MUT hoort bij de eerste MAZ-periode die al is afgesloten door de MAZ op MAZ-situatie. (1161)",
      "1162": "Verwijderen van de MUT (melding einde zorg) veroorzaakt samenloop van 3 leveringsvormen. (1162)",
      "9002": "Bericht voldoet niet aan technische regel 2 (9002)",
      "9004": "Bericht voldoet niet aan technische regel 4 (9004)",
      "9005": "Bericht voldoet niet aan technische regel 5 (9005)",
      "9006": "Bericht voldoet niet aan technische regel 6 (9006)",
      "9014": "Bericht voldoet niet aan technische regel 14 (9014)",
      "9015": "Bericht voldoet niet aan technische regel 15 (9015)",
      "9016": "Bericht voldoet niet aan technische regel 16 (9016)",
      "9017": "Bericht voldoet niet aan technische regel 17 (9017)",
      "9018": "Bericht voldoet niet aan constraint CS136. (9018)",
      "9019": "Bericht voldoet niet aan technische regel 19 (9019)",
      "9020": "Bericht voldoet niet aan technische regel 20 (9020)",
      "9021": "Bericht voldoet niet aan technische regel 21 (9021)",
      "9037": "Bericht voldoet niet aan technische regel 37 (9037)",
      "9039": "Bericht voldoet niet aan technische regel 39 (9039)",
      "9040": "Bericht voldoet niet aan technische regel 40 (9040)",
      "9041": "Bericht voldoet niet aan technische regel 41 (9041)",
      "9042": "Bericht voldoet niet aan technische regel 42 (9042)",
      "9046": "Bericht voldoet niet aan constraint CS137. (9046)",
      "9056": "Bericht voldoet niet aan technische regel 56 (9056)",
      "9057": "Bericht voldoet niet aan technische regel 57 (9057)",
      "9061": "Bericht voldoet niet aan technische regel 61 (9061)",
      "9063": "Bericht voldoet niet aan technische regel 63 (9063)",
      "9064": "Bericht voldoet niet aan technische regel 64 (9064)",
      "9065": "Bericht voldoet niet aan technische regel 65 (9065)",
      "9066": "Bericht voldoet niet aan conditie CD094. (9066)",
      "9069": "Bericht voldoet niet aan technische regel 69 (9069)",
      "9070": "Bericht voldoet niet aan technische regel 70 (9070)",
      "9071": "Bericht voldoet niet aan technische regel 71 (9071)",
      "9073": "Bericht voldoet niet aan technische regel 73 (9073)",
      "9074": "Bericht voldoet niet aan technische regel 74 (9074)",
      "9078": "Bericht voldoet niet aan technische regel 78 (9078)",
      "9079": "Bericht voldoet niet aan technische regel 79 (9079)",
      "9080": "Bericht voldoet niet aan technische regel 80 (9080)",
      "9091": "Bericht voldoet niet aan constraint CS138. (9091)",
      "9097": "Bericht voldoet niet aan constraint CS139. (9097)",
      "9100": "Bericht voldoet niet aan technische regel 100 (9100)",
      "9101": "Bericht voldoet niet aan technische regel 101. (9101)",
      "9103": "Bericht voldoet niet aan technische regel 103 (9103)",
      "9104": "Bericht voldoet niet aan technische regel 104 (9104)",
      "9106": "Bericht voldoet niet aan technische regel 106 (9106)",
      "9107": "Bericht voldoet niet aan technische regel 107 (9107)",
      "9108": "Bericht voldoet niet aan technische regel 108 (9108)",
      "9109": "Bericht voldoet niet aan technische regel 109 (9109)",
      "9110": "Bericht voldoet niet aan technische regel 110 (9110)",
      "9111": "Bericht voldoet niet aan technische regel 111 (9111)",
      "9118": "Bericht voldoet niet aan technische regel 118 (9118)",
      "9119": "Bericht voldoet niet aan constraint CS140. (9119)",
      "9120": "Bericht voldoet niet aan technische regel 120 (9120)",
      "9121": "Bericht voldoet niet aan technische regel 121 (9121)",
      "9124": "Bericht voldoet niet aan technische regel 124 (9124)",
      "9125": "Bericht voldoet niet aan technische regel 125 (9125)",
      "9127": "Bericht voldoet niet aan technische regel 127 (9127)",
      "9128": "Bericht voldoet niet aan technische regel 128 (9128)",
      "9129": "Bericht voldoet niet aan technische regel 129 (9129)",
      "9130": "Bericht voldoet niet aan constraint CS141. (9130)",
      "9131": "Bericht voldoet niet aan technische regel 131 (9131)",
      "0001": "Bericht is afgekeurd om technische redenen. (0001)",
      "0200": "Geen opmerking over deze berichtklasse. (0200)",
      "0233": "Berichtklasse is niet beoordeeld. (0233)",
      "0328": "Client is uitgeschreven wegens overlijden. (0328)",
      "0448": "Client kan niet geïdentificeerd worden. (0448)",
      "0692": "Startdatum zorg met ZZP-code 880, 882, 884, 886, 888 ligt voor 1 januari 2021. (0692)",
      "0693": "Startdatum zorg met ZZP-code 997 ligt na 31 december 2020. (0693)",
      "0694": "Startdatum zorg met ZZP-code 996 ligt na 31 december 2020. (0694)",
      "0695": "Startdatum zorg met leveringsvorm DTV ligt voor 1 januari 2020. (0695)",
      "0696": "Startdatum zorg veroorzaakt samenloop van 3 leveringsvormen (0696)",
      "0699": "Startdatum levering is onjuist. (0699)",
      "0700": "De startdatum van de te verwijderen MAZ ligt meer dan een jaar in het verleden. (0700)",
      "0701": "De startdatum van de nieuwe MAZ ligt in een aanwezige MAZ-MUT (melding einde zorg)-periode. (0701)",
      "0703": "De startdatum van de nieuwe MAZ is al eerder aangeleverd met een andere Leveringsvorm. (0703)",
      "0704": "De startdatum van de nieuwe MAZ is al eerder aangeleverd met een andere AGB-code. (0704)",
      "0705": "De startdatum van de nieuwe MAZ is al eerder aangeleverd met een andere ZZP-code. (0705)",
      "0706": "De startdatum van de nieuwe MAZ is al eerder aangeleverd met een ander GeleverdeZorgID. (0706)",
      "0707": "De startdatum van de nieuwe MAZ is al eerder aangeleverd met leveringsvorm DTV met een ander aantal Etmalen. (0707)",
      "0800": "GeleverdeZorgID is al eerder aangeleverd met dezelfde gegevens. (0800)",
      "0801": "GeleverdeZorgID is al eerder aangeleverd met een andere Leveringsvorm. (0801)",
      "0802": "GeleverdeZorgID is al eerder aangeleverd met een andere AGB-code. (0802)",
      "0803": "GeleverdeZorgID is al eerder aangeleverd met een andere ZZP-code. (0803)",
      "0804": "GeleverdeZorgID is al eerder aangeleverd met leveringsvorm DTV met een ander aantal Etmalen. (0804)",
      "D004": "Bericht voldoet niet aan conditie CD004. (D004)",
      "D005": "Bericht voldoet niet aan conditie CD005. (D005)",
      "D007": "Bericht voldoet niet aan conditie CD007. (D007)",
      "D009": "Bericht voldoet niet aan conditie CD009. (D009)",
      "D016": "Bericht voldoet niet aan conditie CD016. (D016)",
      "D017": "Bericht voldoet niet aan conditie CD017. (D017)",
      "D020": "Bericht voldoet niet aan conditie CD020. (D020)",
      "D025": "Bericht voldoet niet aan conditie CD025. (D025)",
      "D029": "Bericht voldoet niet aan technische regel 132. (D029)",
      "D034": "Bericht voldoet niet aan conditie CD034. (D034)",
      "D036": "Bericht voldoet niet aan conditie CD036. (D036)",
      "D040": "Bericht voldoet niet aan conditie CD040. (D040)",
      "D047": "Bericht voldoet niet aan conditie CD047. (D047)",
      "D048": "Bericht voldoet niet aan conditie CD048. (D048)",
      "D050": "Bericht voldoet niet aan conditie CD050 (D050)",
      "D052": "Bericht voldoet niet aan conditie CD052 (D052)",
      "D070": "Bericht voldoet niet aan conditie CD070 (D070)",
      "D072": "Bericht voldoet niet aan conditie CD072 (D072)",
      "D073": "Bericht voldoet niet aan conditie CD073 (D073)",
      "D074": "Bericht voldoet niet aan conditie CD074 (D074)",
      "D090": "Bericht voldoet niet aan conditie CD090 (D090)",
      "D091": "Bericht voldoet niet aan conditie CD091 (D091)",
      "D097": "Bericht voldoet niet aan conditie CD097 (D097)",
      "D098": "Bericht voldoet niet aan conditie CD098. (D098)",
      "S002": "Bericht voldoet niet aan constraint CS002. (S002)",
      "S003": "Bericht voldoet niet aan constraint CS003. (S003)",
      "S012": "Bericht voldoet niet aan constraint CS012. (S012)",
      "S014": "Bericht voldoet niet aan constraint CS014. (S014)",
      "S023": "Bericht voldoet niet aan technische regel 134. (S023)",
      "S035": "Bericht voldoet niet aan constraint CS035. (S035)",
      "S050": "Bericht voldoet niet aan constraint CS050. (S050)",
      "S058": "Bericht voldoet niet aan constraint CS058. (S058)",
      "S062": "Bericht voldoet niet aan constraint CS062. (S062)",
      "S064": "Bericht voldoet niet aan technische regel 135. (S064)",
      "S067": "Bericht voldoet niet aan constraint CS067. (S067)",
      "S069": "Bericht voldoet niet aan constraint CS069. (S069)",
      "S072": "Bericht voldoet niet aan constraint CS072. (S072)",
      "S088": "Bericht voldoet niet aan constraint CS088. (S088)",
      "S089": "Bericht voldoet niet aan constraint CS089. (S089)",
      "S092": "Bericht voldoet niet aan constraint CS092. (S092)",
      "S093": "Bericht voldoet niet aan constraint CS093. (S093)",
      "S108": "Bericht voldoet niet aan technische regel 137. (S108)",
      "S113": "Bericht voldoet niet aan constraint CS113. (S113)",
      "S118": "Bericht voldoet niet aan constraint CS118. (S118)",
      "S123": "Bericht voldoet niet aan constraint CS123. (S123)",
      "S125": "Bericht voldoet niet aan constraint CS125 (S125)",
      "S127": "Bericht voldoet niet aan constraint CS127 (S127)",
      "S130": "Bericht voldoet niet aan constraint CS130 (S130)",
      "S131": "Bericht voldoet niet aan constraint CS131 (S131)",
      "S132": "Bericht voldoet niet aan constraint CS132 (S132)",
      "S133": "Bericht voldoet niet aan constraint CS133 (S133)"
    },
    "Retry request": "Melding opnieuw aanvragen",
    "Score": "Score",
    "SoortIndicatie": "Soort",
    "Start_date": "Startdatum",
    "Street": "Straat",
    "Type": "Type",
    "Value": "Waarde",
    "Vecozotoegewezenzorgzwaartepakket": "Toegewezen zorgzwaartepakket",
    "Zorgkantoor": "Zorgkantoor",
    "ZzpCode": "ZZP Code"
  },
  "Vektis_declaratie": {
    "Credit replaces concept title": "Conceptdeclaratie vervangen",
    "Credit replaces concept message": "Er bestaat een concept voor dezelfde maand en hetzelfde zorgkantoor. Bij doorgaan wordt het hele onderstaande concept definitief verwijderd, inclusief de regels van andere cliënten en gearchiveerde regels. Daarna wordt de creditdeclaratie aangemaakt. Bij annuleren blijven alle gegevens behouden.",
    "Delete concept and create credit": "Concept verwijderen en credit aanmaken",
    "Delete concept": "Concept verwijderen",
    "Delete concept message": "<p>Wil je dit concept definitief verwijderen?</p><p><strong>Periode:</strong> {begin} t/m {end}<br><strong>Revisie:</strong> {revision}</p><p><strong>Wordt verwijderd</strong><br>Alle conceptregels van alle cliënten, inclusief gearchiveerde cliënten en gemaakte keuzes.</p><p><strong>Blijft behouden</strong><br>Aanwezigheidsregistraties, oorspronkelijke declaraties en credits.</p><p class=\"q-mb-none\">Bij opnieuw aanmaken kun je de archiefselectie en cliëntgegevens opnieuw kiezen.</p>",
    "Aantal_clienten": "Aantal clienten (9902)",
    "Aantal_prestaties": "Aantal prestaties (9904)",
    "Always_declare": "Wordt gedeclareerd?",
    "Beginperiode": "Beginperiode (0114)",
    "Betaling_aan": "Betaling aan (0113)",
    "Btw_id": "BTW-id (0118)",
    "Claim": "Declareren",
    "Code_informatiesysteem_softwareleverancier": "Software code (0106)",
    "Declaration already exists": "Er bestaat al een declaratie voor deze maand. Wil je deze opnieuw berekenen?",
    "Delete item": "Verwijder declaratie",
    "Delete item fail": "Fout bij het verwijderen van de declaratie.",
    "Delete item success": "Declaratie succesvol verwijderd.",
    "Deleted": "Verwijderd",
    "Download item success": "Declaratie succesvol gedownload.",
    "Edit item": "Declaratie bewerken",
    "Edit item fail": "Fout bij het wijzigen van de declaratie. De declaratie is niet gewijzigd.",
    "Edit item success": "Declaratie succesvol gewijzigd.",
    "Eindperiode": "Eindperiode (0115)",
    "Errors": {
      "DECLARATION_CARE_ASSIGNMENT_MISSING": "De zorgtoewijzing bij deze zorgkoppeling ontbreekt. Herstel de zorgtoewijzing voordat je deze zorg opnieuw berekent.",
      "CLIENTS_NO_INSURANCE_SUPPLIER": "Declaratie kon niet worden gemaakt. Niet alle cliënten hebben een zorgverzekeraar ingesteld.",
      "DECLARATION_ALREADY_SUBMITTED": "Deze declaratie is al als AW319 ingediend.",
      "DECLARATION_NOT_CONCEPT": "Deze declaratie is al definitief gemaakt en kan niet worden verwijderd. Dit geldt ook als het AW319-bestand nog niet is gedownload of de declaratie is afgewezen.",
      "DECLARATION_GENERAL_ERROR": "Declaratie kon niet worden gemaakt. Neem contact op met de leverancier voor meer informatie.",
      "NO_PRESTATIES_FOR_DECLARATION": "Declaratie kon niet worden gemaakt. Er zijn geen prestaties om te declareren.",
      "OPEN_DECLARATION_EXIST": "Declaratie kon niet worden gemaakt. Er is al een conceptdeclaratie voor deze periode.",
      "PENDING_DECLARATION_EXIST": "Declaratie kon niet worden gemaakt. Er is een ingediende declaratie in afwachting van reactie van Vecozo.",
      "CREDIT_RETURN_PENDING": "Deze correctie kan nog niet worden ingediend. Verwerk eerst het retourbericht van de creditdeclaratie. De credit moet daarin zijn goedgekeurd.",
      "CARE_ALREADY_DECLARED": "Deze zorg staat al in een andere declaratie. Bereken het concept opnieuw en controleer de declaratiehistorie.",
      "CARE_REGISTRATIONS_OUTSIDE_PERIOD": "Er zijn zorgregistraties buiten de geldige zorgperiode. Controleer de zorgkoppeling, zorgtoewijzing en registraties.",
      "CONCEPT_CLIENT_DATA_AMBIGUOUS": "Het concept bevat verschillende cliëntgegevens die niet eenduidig aan deze zorg kunnen worden gekoppeld. Het concept is niet gewijzigd. Neem contact op met de leverancier."
    },
    "Externe_integratie": "Externe Integratie (0102)",
    "Factuurdatum": "Factuurdatum (0117)",
    "Factuurnummer": "Factuurnummer (0116)",
    "Force_generate": "Declaratie alsnog maken voor zorgtypes met “Altijd declareren” en definitieve aanwezigheidsregistraties.",
    "Grouped claim amounts": "Gegroepeerde declaratie bedragen",
    "Archived declarable care warning": "Er zijn gearchiveerde cliënten met nog te declareren zorg in deze periode. Als je doorgaat, wordt de declaratie aangemaakt zonder de regels van deze gearchiveerde cliënten.",
    "Archived declarable care warning title": "Gearchiveerde cliënten met te declareren zorg",
    "Indicatie_debet_credit": "Indicatie debet/credit (9908)",
    "Instellingscode": "AGB/Instelling (0112)",
    "Month": "Maand",
    "New item": "Nieuwe declaratie",
    "New item fail": "Fout bij het aanmaken van de declaratie.",
    "New item success": "Declaratie succesvol aangemaakt.",
    "Praktijkcode": "Praktijkcode (0111)",
    "Reload": "Opnieuw berekenen",
    "Reserve": "Reserve (0180)",
    "Revision": "Revisie",
    "Servicebureau": "Servicebureau (0109)",
    "Soort_bericht": "Soort bericht (0105)",
    "Status": "Status",
    "StatusOptions": {
      "accepted": "Goedgekeurd",
      "concept": "Concept",
      "partially_rejected": "Gedeeltelijk afgewezen",
      "pending": "Wacht op reactie",
      "rejected": "Volledig afgewezen"
    },
    "Subversie": "Subversie (0104)",
    "Tab errors": {
      "Declaration errors": "Een of meerdere cliënt(en) hebben afgewezen declaraties.",
      "Unauthorized": "Onvoldoende rechten om deze gegevens te in te mogen zien."
    },
    "Tabs": {
      "Efforts": "Geleverde prestaties",
      "General": "Algemeen",
      "Totals": "Totalen"
    },
    "Totaal_aantal_detail_records": "Totaal aantal detail records (9906)",
    "Totaal_declaratiebedrag_cent": "Totaal declaratiebedrag (9907)",
    "Uzovi": "Zorgkantoor (0108)",
    "Valuta": "Valuta (0119)",
    "Vektis_uzovi": "Zorgkantoor (0108)",
    "Vektis_uzovi_info": "Zorgkantoor (0108)",
    "Versie": "Versie (0103)",
    "Versieaanduiding_informatiesysteem_softwareleverancier": "Software versie (0107)",
    "View item": "Declaratie bekijken",
    "Will be declared": "Deze registratie wordt gedeclareerd omdat “Altijd declareren” is ingeschakeld. Dit is niet afhankelijk van aanwezigheidsregistraties.",
    "Will not be declared": "Deze registratie wordt niet gedeclareerd omdat “Altijd declareren” is uitgeschakeld. Dit is afhankelijk van definitieve aanwezigheidsregistraties.",
    "Year": "Jaar",
    "Zorgverlenerscode": "Zorgverlenerscode (0110)",
    "ArchivedCare": {
      "Title": "Gearchiveerde zorg beoordelen",
      "Message": "Kies welke zorg van gearchiveerde cliënten je in dit concept wilt meenemen. Nog nooit gedeclareerde zorg wordt alleen na selectie meegenomen. Regels die al in een ander concept of ingediende declaratie staan, zijn niet selecteerbaar. Ontbrekende zorgkoppelingen worden hersteld wanneer de oorspronkelijke verwijzing eenduidig is vastgelegd.",
      "PendingCredit": "Een deel van de credits wacht nog op retour. Je kunt de correctie voorbereiden; indienen kan pas nadat de betreffende credit is goedgekeurd.",
      "Include": "Meenemen",
      "CareCode": "Prestatiecode",
      "Reason": "Declaratiehistorie",
      "Registrations": "Registraties",
      "FirstRegistration": "Eerste registratie",
      "LastRegistration": "Laatste registratie",
      "MissingSource": "Zorgtoewijzing niet eenduidig te herleiden",
      "Skip": "Doorgaan zonder deze zorg",
      "IncludeSelection": "Selectie meenemen",
      "Reasons": {
        "never_declared": "Nog nooit gedeclareerd",
        "rejected": "Eerder afgewezen",
        "credited": "Gecrediteerd",
        "credit_pending": "Credit wacht op retour",
        "declaration_pending": "Declaratie wacht op retour",
        "existing_concept": "Bestaand concept",
        "approved": "Al goedgekeurd"
      }
    },
    "RedeclarationClientData": {
      "Title": "Cliëntgegevens bij herdeclaratie",
      "Message": "Cliëntgegevens zijn gewijzigd sinds de oorspronkelijke declaratie. Kies per cliënt welke gegevens voor deze zorgperiode gelden. Huidige gegevens zijn standaard geselecteerd en gelden voor alle opgenomen herdeclaratieregels van die cliënt. De credit blijft het origineel spiegelen.",
      "NoChanges": "De gegevens zijn intussen gewijzigd; er zijn geen verschillen meer voor de opgenomen herdeclaratieregels. Ga door om het concept aan te maken.",
      "Current": "Huidige cliëntgegevens (standaard)",
      "Original": "Oorspronkelijke declaratiegegevens",
      "Confirm": "Keuze gebruiken",
      "Source": "Oorspronkelijke declaratie",
      "Field": "Gegeven",
      "OriginalValue": "Oorspronkelijk",
      "CurrentValue": "Huidig"
    },
    "Credit created refresh failed": "De credit is aangemaakt, maar de lijst kon niet worden vernieuwd. Vernieuw de lijst om de actuele status te zien.",
    "Concept deleted refresh failed": "Het concept is verwijderd, maar de lijst kon niet worden vernieuwd. Vernieuw de lijst om de actuele status te zien.",
    "Recalculated refresh failed": "Het concept is opnieuw berekend, maar de weergave kon niet worden vernieuwd. Open het concept opnieuw om het resultaat te zien."
  },
  "Vektis_declaratie_client": {
    "Bsn": "BSN (0203)",
    "Client": "Cliënt",
    "Client Effort Table": "Cliënten prestatie tabel",
    "Client Table": "Cliënten tabel",
    "ClientDeceasedOptions": {
      "1": "Cliënt is overleden",
      "2": "Cliënt is niet overleden"
    },
    "Clientnummer_indicatieorgaan": "Cliëntnummer indicatieorgaan (0225)",
    "Code_indicatieorgaan": "Code indicatieorgaan (0224)",
    "Credit items": "Crediteer prestaties",
    "Debiteurnummer": "Debiteurnummer (0222)",
    "Geboortedatum": "Geboortedatum (0207)",
    "Geslacht": "Geslacht (0208)",
    "Huisnummer": "Huisnummer (huisadres) verzekerde (0219)",
    "Huisnummer_toevoeging": "Huisnummertoevoeging (huisadres) verzekerde (0220)",
    "Ident_detail": "Identificatie detailrecord (0202)",
    "Indicatie_client_overleden": "Indicatie cliënt overleden (0223)",
    "Landcode": "Code land verzekerde (0221)",
    "Naam_01": "Naam verzekerde (0210, 01)",
    "Naam_02": "Naam verzekerde (0213, 02)",
    "Naamcode_01": "Naamcode/naamgebruik (0209, 01)",
    "Naamcode_02": "Naamcode/naamgebruik (0212, 02)",
    "Naamcode_03": "Naamcode/naamgebruik (0216, 03)",
    "Patientnummer": "Patiënt(identificatie)nummer (0206)",
    "Postcode": "Postcode (huisadres) verzekerde (0217)",
    "Postcode_buitenland": "Postcode buitenland (0218)",
    "Retourcode_01": "Retourcode 01 (0296)",
    "Retourcode_02": "Retourcode 02 (0297)",
    "Retourcode_03": "Retourcode 03 (0298)",
    "StatusOptions": {
      "Accepted": "Goedgekeurd",
      "Partially_rejected": "Gedeeltelijk afgewezen",
      "Rejected": "Volledig afgewezen"
    },
    "Total_amount": "Declaratiebedrag",
    "Verzekerdennummer": "Verzekerdennummer (0205)",
    "Voorletters": "Voorletters verzekerde (0215)",
    "Voorvoegsel_01": "Voorvoegsel verzekerde (0211, 01)",
    "Voorvoegsel_02": "Voorvoegsel verzekerde (0214, 02)"
  },
  "Vektis_declaratie_client_prestatie": {
    "Aanduiding_prestatiestelsel": "Aanduiding prestatiecodelijst (0416)",
    "Aantal": "Aantal uitgevoerde prestaties (0418)",
    "Begindatum": "Begindatum prestatie (0414)",
    "Berekend_bedrag_eur": "Berekend bedrag incl. btw (0426) [EUR]",
    "Berekend_bedrag_zorgverzekeraar_eur": "Berekend bedrag zorgverzekeraar (0481) [EUR]",
    "Bsn": "BSN (0403)",
    "Btw_percentage_bp": "Btw-percentage declaratiebedrag (0428, basispunten)",
    "Clientnummer_indicatieorgaan": "Cliëntnummer indicatieorgaan (0409)",
    "Code_indicatieorgaan": "Code indicatieorgaan (0408)",
    "Debcred1": "Indicatie debet/credit (0427)",
    "Debcred2": "Indicatie debet/credit (0430)",
    "Debcred3": "Indicatie debet/credit (0482)",
    "Debcred4": "Indicatie debet/credit (0483)",
    "Declaratiebedrag_eur": "Declaratiebedrag incl. btw (0429) [EUR]",
    "Doorsturen_toegestaan": "Doorsturen toegestaan (0407)",
    "Doorsturen_toegestaanOptions": {
      "1": "Doorsturen naar zorgverzekeraar is toegestaan",
      "2": "Op verzoek van verzekerde niet doorsturen naar zorgverzekeraar",
      "3": "Op verzoek van zorgverlener niet doorsturen naar zorgverzekeraar",
      "4": "Op verzoek van verzekerde én zorgverlener niet doorsturen naar zorgverzekeraar"
    },
    "Einddatum": "Einddatum prestatie (0415)",
    "Functiecode": "Functiecode (0412)",
    "Ident_detail": "Identificatie detailrecord (0402)",
    "Indicatie_aanvraagnummer": "Indicatie-aanvraagnummer (0410)",
    "Indicatiebesluitnummer": "Indicatiebesluitnummer (0411)",
    "Machtigingsnummer": "Machtigingsnummer (0406)",
    "Prestatiecode": "Prestatiecode (0417)",
    "PrestatiecodelijstOptions": {
      "55": "Prestatiecodelijst Wlz/AWBZ"
    },
    "Ref_huidig": "Referentienummer dit prestatierecord (0431)",
    "Ref_vorig": "Referentienummer voorgaande prestatierecord (0432)",
    "Retourcode_01": "Retourcode 01 (0496)",
    "Retourcode_02": "Retourcode 02 (0497)",
    "Retourcode_03": "Retourcode 03 (0498)",
    "Specialisme_behandelaar": "Specialisme behandelaar/uitvoerder (0421)",
    "Specialisme_voorschrijver": "Specialisme voorschrijver/verwijzer (0423)",
    "Tarief_eur": "Tarief prestatie incl. btw (0425) [EUR]",
    "Tijdseenheid": "Tijdseenheid zorgperiode (0419)",
    "Toegekend_bedrag_eur": "Toegekend bedrag (0483) [EUR]",
    "Verrekenpercentage": "Verrekenpercentage (0424)",
    "Verzekerdennummer": "Verzekerdennummer (0405)",
    "Zorgverlenerscode_behandelaar": "Zorgverlenerscode behandelaar/uitvoerder (0420)",
    "Zorgverlenerscode_voorschrijver": "Zorgverlenerscode voorschrijver/verwijzer (0422)",
    "Zorgzwaartepakketcode": "Zorgzwaartepakketcode (0413)"
  },
  "Vektis_prestatie": {
    "Aaneengesloten declareren": "Aaneengesloten declareren",
    "Edit item": "Vektis prestatie bewerken",
    "Edit item fail": "Fout bij wijzigen van de prestatiecode.",
    "Edit item success": "Prestatiecode succesvol gewijzigd.",
    "Einddatum": "Einddatum",
    "Error loading data": "De lijst met prestatiecodes kon niet worden geladen.",
    "Group": "Groep",
    "Ingangsdatum": "Ingangsdatum",
    "Is_toeslag": "Is toeslag",
    "NZa beleidsregel": "NZa beleidsregel",
    "Omschrijving": "Omschrijving",
    "Prestatiecode": "Prestatiecode",
    "Prestatiecodelijst": "Prestatiecodelijst",
    "Prestatiegroep": "Prestatiegroep",
    "Tabs": {
      "General": "Algemeen",
      "Tarieven": "Tarieven"
    },
    "Tarief": "Tarief",
    "Tijdseenheid": "Tijdseenheid",
    "TijdseenheidOptions": {
      "dagdeel": "Dagdeel (4 uur)",
      "etmaal": "Etmaal",
      "minuut": "Minuut",
      "tijdsonafhankelijk": "Tijdsonafhankelijk",
      "uur": "Uur"
    },
    "Vektisprestatiegroup": "Vektis prestatiegroep",
    "ZZP codes": "ZZP codes"
  },
  "Vektis_prestatie_group": {
    "Default_registered": "Standaard als aanwezig registreren",
    "Delete item": "Verwijder prestatie groep",
    "Delete item fail": "Fout bij het verwijderen van de prestatie groep.",
    "Delete item success": "Prestatie groep succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je de prestatiegroep {0} wilt {1}?",
    "Deleted": "Verwijderd",
    "Description": "Omschrijving",
    "Edit item": "Prestatie groep bewerken",
    "Edit item fail": "Fout bij het wijzigen van de prestatie groep. De prestatie groep is niet gewijzigd.",
    "Edit item success": "Prestatie groep succesvol gewijzigd.",
    "Name": "Naam",
    "New item": "Nieuwe prestatie groep",
    "New item fail": "Fout bij het aanmaken van de prestatie groep.",
    "New item success": "Prestatie groep succesvol aangemaakt."
  },
  "Vektis_prestatie_tarief": {
    "Amount": "Bedrag",
    "Edit item": "Vektis prestatie tarief bewerken",
    "Edit item fail": "Fout bij wijzigen van het prestatietarief.",
    "Edit item success": "Prestatietarief succesvol gewijzigd.",
    "New item": "Nieuw prestatietarief",
    "New item fail": "Fout bij het aanmaken van het prestatietarief.",
    "New item success": "Prestatietarief succesvol aangemaakt.",
    "ObjectName": "Vektis prestatietarief",
    "Valid_from": "Geldig vanaf"
  },
  "Vektis_uzovi": {
    "End": "Einddatum",
    "Modified": "Bewerkt",
    "Naam": "Naam",
    "Rol": "Rol",
    "RolOptions": {
      "AV": "Aanvullende verzekeringen",
      "BN": "orgaan voor in Nederland wonende buitenlandse verzekerden (CZ)",
      "CO": "Concern",
      "CV": "Centrale verwerkingseenheid",
      "DB": "Declarant Buitenlandse partij",
      "DN": "Declarant Nederlandse partij",
      "FZ": "Wet forensische zorg (ondergebracht bij Min. van Justitie)",
      "GA": "Gevolmachtigd agent",
      "IC": "Inkoopconcern",
      "LA": "Label",
      "NB": "orgaan conform art.69 ZVW, verdragsgerechtigden in buitenland (Zorginstituut Nederland)",
      "NV": "Nevenvestiging",
      "OV": "Uitvoerend Orgaan van Verblijf namens Zorginstituut Nederland",
      "PJ": "Preferentie ten behoeve van Justitiële Inrichtingen",
      "RG": "Uitvoeringsregeling Gemoedsbezwaarden",
      "RI": "Uitvoeringsregeling finan. zorg Illegalen",
      "RO": "Uitvoeringsregeling Onverzekerden",
      "RW": "Uitvoeringsregeling Wanbetalers",
      "VD": "Volmacht voor Declarant",
      "VO": "Verbindingsorgaan",
      "ZF": "Ziekenfonds",
      "ZK": "Zorgkantoor",
      "ZP": "Ziektekostenverzekeraar (particulier)",
      "ZR": "Ziektekostenregeling (ambtenaren)",
      "ZV": "Zorgverzekeraar"
    },
    "Start": "Startdatum",
    "Uzovi": "UZOVI"
  },
  "Weight": {
    "Added by": "Toegevoegd door",
    "Client": "Cliënt",
    "Client name": "Cliëntnaam",
    "Created": "Toegevoegd op",
    "Date": "Datum",
    "Delete": "verwijderen",
    "Delete item": "Verwijder rapport",
    "Delete item fail": "Fout bij het verwijderen van rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het rapport. Het rapport is niet gewijzigd.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Had_clothing": "Aangekleed",
    "Name": "Naam",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het toevoegen van het rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "ObjectName": "Gewicht rapport | Gewicht rapporten",
    "Tabs": {
      "General": "Algemeen"
    },
    "Time": "Tijd",
    "Weight": "Gewicht"
  },
  "Wzd_registration": {
    "Action": "Actie/maatregelen",
    "Action_representative": "Opmerkingen vertegenwoordiger(s)",
    "Added by": "Toegevoegd door",
    "Awaits": "Wacht op",
    "Consideration": "Overweging/afweging",
    "Consideration_representative": "Opmerkingen vertegenwoordiger(s)",
    "Created": "Toegevoegd op",
    "Delete": "verwijderen",
    "Delete item": "Verwijder rapport",
    "Delete item fail": "Fout bij het verwijderen van het rapport.",
    "Delete item success": "Rapport succesvol verwijderd.",
    "Delete item text": "Weet je zeker dat je het {0} wilt {1}?",
    "Document is cancelled": "Het document is vervallen.",
    "Document is expired": "Let op: de geldigheid van het document is verlopen!",
    "Document is final": "Het document is definitief gemaakt en kan niet meer worden gewijzigd.",
    "Documents awaits signing by representative": "Het document is in afwachting door ondertekening van de vertegenwoordiger en kan niet meer worden gewijzigd.",
    "Documents awaits signing by supplier": "Het document is in afwachting door ondertekening door Nocht en Wille en kan niet meer worden gewijzigd.",
    "Edit item": "Rapport bewerken",
    "Edit item fail": "Fout bij het wijzigen van het rapport. Het rapport is niet gewijzigd.",
    "Edit item success": "Rapport succesvol gewijzigd.",
    "Editable_by": "Bewerkbaar door",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen.",
      "REPRESENTATIVE_SIGN_CONSENT": "Je dient akkoord te gaan om het document te kunnen ondertekenen."
    },
    "Is_resistance": "Is er sprake van verzet?",
    "Is_resistance_representative": "Is er sprake van verzet? (vertegenwoordiger)",
    "Modified": "Laatst gewijzigd",
    "New item": "Nieuw rapport",
    "New item fail": "Fout bij het toevoegen van het rapport.",
    "New item success": "Rapport succesvol toegevoegd.",
    "Only editable by representative": "Het document kan momenteel alleen door vertegenwoordigers worden gewijzigd.",
    "Only editable by supplier": "Het document kan momenteel alleen door Nocht en Wille worden gewijzigd.",
    "ShowArchived": "Welke items tonen",
    "Sign_consent": "Verklaring akkoord",
    "Sign_consent_text": "Ik verklaar dit document te hebben gelezen en ga akkoord met de inhoud zoals hierin beschreven.",
    "Signed": "Getekend op",
    "Signed_by_employee": "Ondertekenen namens Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Ondertekenen namens cliënt",
    "Status": "Status",
    "StatusOptions": {
      "CANCELLED": "Vervallen",
      "CONCEPT": "Concept",
      "EXPIRED": "Verlopen",
      "FINAL": "Definitief",
      "SIGN_EMPLOYEE": "Tekenen (medewerker)",
      "SIGN_REPRESENTATIVE": "Tekenen (vertegenwoordiger)",
      "SUPERSEDED": "Vervangen"
    },
    "Valid until": "Geldig tot",
    "WZD registration": "WZD registratie"
  },
  "Yes": "Ja"
}
